var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _months, _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "Status",
    "history": "Energia",
    "layout": "Układ",
    "menu": "Menu"
  },
  "button": {
    "cancel": "Anuluj",
    "done": "Gotowe",
    "login": "Zaloguj się",
    "today": "Dziś",
    "submit": "Prześlij",
    "ok": "OK",
    "choose_file": "Wybierz plik",
    "refresh": "Odśwież",
    "send": "Wyślij",
    "skip": "Pomiń",
    "continue": "Kontynuuj",
    "clickHere": "Kliknij tutaj",
    "confirm": "Potwierdź",
    "reset": "Zresetuj",
    "edit": "Edytuj",
    "update": "Zaktualizuj",
    "next": "Następne",
    "save": "Zapisz",
    "no": "Nie",
    "yes": "Tak",
    "enable": "Włącz",
    "setNow": "Ustaw teraz",
    "gotIt": "Rozumiem",
    "okGotIt": "OK, rozumiem",
    "knowMore": "Dowiedz się więcej",
    "noExportCredit": "Nie otrzymuję należności za eksport",
    "tryLater": "Spróbuj później",
    "otherNetworks": "Inne sieci"
  },
  "form": {
    "topic": "Temat",
    "contactSupport": {
      "success": {
        "message": "Dziękujemy za skontaktowanie się z nami.",
        "description": "Chętnie pomożemy Ci rozwiązać problem. Ekspert Enphase wkrótce się z Tobą skontaktuje.",
        "email_notify": "Raport zostanie wkrótce wysłany na adres %{email}."
      },
      "error": {
        "message": "Nie udało się wysłać wiadomości.",
        "description": "Spróbuj ponownie.",
        "reset_password": "Hasło wygasło. Zresetuj hasło."
      }
    },
    "default": {
      "success": "Pomyślnie zapisano",
      "error": "Spróbuj ponownie",
      "pleaseEnterAValue": "Wprowadź wartość",
      "permissionDenied": "Odmowa uprawnień",
      "activeBatteryProfile": "Masz aktywne żądanie profilu akumulatora. Poczekaj na potwierdzenie lub anuluj to żądanie, aby kontynuować."
    },
    "search": "Wyszukiwanie"
  },
  "common": {
    "please": "Prosimy",
    "contactSupport": "Skontaktuj się z obsługą klienta",
    "forHelp": "aby otrzymać pomoc.",
    "videos": "Filmy",
    "articles": "Artykuły",
    "new": "Nowości",
    "startDate": "Data rozpoczęcia",
    "endDate": "Data zakończenia",
    "clearedDate": "Data usunięcia",
    "startTime": "Godzina rozpoczęcia",
    "endTime": "Godzina zakończenia",
    "duration": "Czas trwania"
  },
  "errors": {
    "error": "Błąd",
    "errors": "Błędy",
    "warning": "ostrzeżenie",
    "retry": "Ponów próbę",
    "email": "Wprowadź swój adres e-mail",
    "password": "Wprowadź swoje hasło",
    "login": "Wprowadzona kombinacja adresu e-mail/hasła nie jest zgodna z naszymi danymi.",
    "accInactive": "Konto jest nieaktywne. Skontaktuj się z instalatorem i spróbuj ponownie, gdy system będzie w pełni aktywny.",
    "expired": "Niestety Twój login wygasł.",
    "loggedout": "Nastąpiło wylogowanie.",
    "report": "Niestety wystąpił błąd.",
    "offline": "Sprawdź połączenie internetowe i spróbuj ponownie.",
    "noInternet": "Brak dostępu do internetu",
    "message": "Wiadomość",
    "tryagain": "spróbuj ponownie",
    "resetNow": "Zresetuj teraz",
    "resetPassword": "Twoje hasło straciło ważność. Zresetuj je, aby wyświetlić raport",
    "validEmail": "Wprowadź prawidłowy adres e-mail",
    "validPhone": "Wprowadź prawidłowy numer telefonu",
    "fileError": "Logo firmy musi mieć rozmiar od 0,05 kB do 4 MB.",
    "400": "Nieprawidłowe żądanie",
    "401": "Nieautoryzowany dostęp",
    "403": "Zakazany dostęp",
    "404": "Nie znaleziono zasobu",
    "422": "Jednostka bez możliwości przetworzenia",
    "500": "Wewnętrzny błąd serwera.",
    "502": "Nieprawidłowa brama.",
    "503": "Usługa niedostępna.",
    "504": "Limit czasu bramy.",
    "default": "Server error.",
    "400_text": "Nieprawidłowe żądanie",
    "401_text": "Nieautoryzowany dostęp",
    "403_text": "Zakazany dostęp",
    "404_text": "Nie znaleziono zasobu",
    "422_text": "Jednostka bez możliwości przetworzenia",
    "500_text": "Wewnętrzny błąd serwera. Spróbuj ponownie później.",
    "502_text": "Nieprawidłowa brama. Spróbuj ponownie później.",
    "503_text": "Usługa niedostępna. Spróbuj ponownie później.",
    "504_text": "Limit czasu bramy. Spróbuj ponownie później.",
    "default_text": "Błąd serwera. Spróbuj ponownie później.",
    "noDeviceFound": "Nie znaleziono urządzenia",
    "noBackupHistoryFound": "Nie znaleziono historii zasobów rezerwowych",
    "noWiFiNetworkFound": "Nie znaleziono sieci Wi-Fi.",
    "noResultFound": "Brak wyniku",
    "allSites": "Wszystkie lokalizacje",
    "favorites": "Ulubione",
    "changesNotSaved": "Nie zapisano zmian",
    "wantToExit": "Czy chcesz wyjść bez zapisywania?",
    "rateNotFound": "Nie znaleziono stawki"
  },
  "login": {
    "forgot": "Nie pamiętam hasła",
    "signup": "Nowe konto",
    "header": "Zaloguj się do Enphase",
    "intro_content": "Wprowadź swój adres e-mail i hasło, aby się zalogować",
    "remember_me": "Pamiętaj mnie",
    "forgot_password": "Nie pamiętasz hasła?",
    "forgot_password_success": "Jeśli masz już konto w Enphase, sprawdź pocztę e-mail, aby uzyskać instrukcje resetowania.",
    "caps_lock_warning": "Klawisz Caps Lock jest włączony",
    "welcome_back": "Witaj ponownie, %{user_name}. ",
    "en_us_installer_html": "Witaj, %{user_name}! Odwiedź naszą stronę <a href='http://go.enphase.com/gettingstarted' target='_blank'>Wprowadzenie</a>, aby dowiedzieć się wszystkiego, co musisz wiedzieć o projektowaniu, instalowaniu i uruchamianiu systemów Enphase.  ",
    "en_aunz_installer_html": "Witaj, %{user_name}! Odwiedź naszą stronę <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>Wprowadzenie</a>, aby dowiedzieć się wszystkiego, co musisz wiedzieć o projektowaniu, instalowaniu i uruchamianiu systemów Enphase. ",
    "provide_email_password": "Podaj nazwę użytkownika i hasło.",
    "request_account": "Poproś o konto",
    "subheader": {
      "new_user": "Czy jesteś nowym użytkownikiem Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Produkty Enphase Energy radykalnie poprawiają wydajność instalacji fotowoltaicznych. Dzięki mikroinwerterom Enphase właściciele i operatorzy mogą zwiększyć wydajność i niezawodność swoich instalacji fotowoltaicznych.<br/><br/>Aby bliżej poznać możliwości Enphase, <a href='%{systems_list_link}'>zobacz systemy naszych klientów.</a>",
    "public_system_content_html": "Czy chcesz poznać bliżej możliwości Enphase? <a href='%{systems_list_link}'>Zobacz systemy publiczne</a>",
    "register_new_user_html": "Instalujesz swój pierwszy system Enphase? <a href='%{register_user_link}'>Zarejestruj się w Enphase</a>",
    "recommended_browsers": "Aplikacja Enphase jest kompatybilna z następującymi przeglądarkami: Chrome 5 lub nowsza, Firefox 3.6 lub nowsza, Internet Explorer 10 lub nowsza, Microsoft Edge dla Windows, Safari 4 lub nowsza. Do obsługi aplikacji Enphase wymagana jest wtyczka Adobe Flash Player 10.",
    "recommended_browsers_3x": "Aplikacja Enphase jest kompatybilna z następującymi przeglądarkami: Chrome 44 lub nowsza, Firefox 41 lub nowsza, Internet Explorer 11, Microsoft Edge dla Windows, Safari 8 lub nowsza.",
    "cookies_required": "Cookies must be enabled.",
    "no_community": "Ta strona jest przeznaczona dla instalatorów, którzy chcą omówić kwestie techniczne związane z systemami Enphase. Zapraszamy do udziału w dyskusjach na naszej <a href='https://www.facebook.com/EnphaseEnergy'>stronie w serwisie Facebook</a>.",
    "required": "Musisz się zalogować, aby uzyskać dostęp do tej strony",
    "findInstaller": "Znajdź instalatora",
    "sizeYourSystem": "Ustal wielkość systemu",
    "getEnphase": "Pobierz Enphase",
    "experienceTheApp": "Poznaj aplikację",
    "viewStorageSystem": "Wyświetl system magazynowania",
    "meetEnphase": "Poznaj Enphase",
    "enphaseSolar": "System do produkcji energii słonecznej Enphase",
    "enphaseStorage": "System magazynowania energii Enphase"
  },
  "logout": {
    "confirm_logout": "Wylogowano Cię. Dziękujemy za odwiedziny."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Aktywuj konto",
      "link": "Aktywuj swoje konto teraz"
    },
    "header": "Resetowanie hasła",
    "intro_content": "Wpisz swój identyfikator e-mail zarejestrowany w Enphase. Wyślemy link do zresetowania hasła na identyfikator e-mail.",
    "login": "Zaloguj się",
    "try_again": "Spróbuj ponownie.",
    "sent_message_html": "Wysłaliśmy wiadomość na adres %{email}. Kliknij link w wiadomości e-mail, aby zresetować hasło. <span style='color:red'>Jeśli wiadomość e-mail do Ciebie nie dotarła, sprawdź folder śmieci/spamu.</span>",
    "invalid_request": "Nieprawidłowe żądanie",
    "invalid_link": "Nie można zresetować hasła. Link do resetowania hasła jest ważny przez 7 dni. Spróbuj ponownie.",
    "success": "Pomyślnie zresetowano hasło.",
    "failed_password_reset": "Napotkano problem. Spróbuj ponownie.",
    "password_requirements": "Your password must be at least six characters, must contain at least one number or special character, and can't be the same as your email address.",
    "note": "Hasło ",
    "OK": "OK",
    "sent_email": "Wysłaliśmy wiadomość e-mail na",
    "rest_pwd": "Kliknij link w wiadomości e-mail, aby zresetować hasło."
  },
  "users": {
    "new": "Rejestracja nowego użytkownika",
    "company_details": "Dane firmy",
    "edit": "Edytuj użytkownika",
    "re-upload_documents": "Ponowne przesłanie identyfikatora biznesowego",
    "site_accesses": "Dostęp do systemu",
    "login": "Zaloguj się",
    "logged_in_as": "%{admin}, jesteś zalogowany jako %{user}",
    "logout_as": "Zatrzymaj",
    "reset_password": "Zresetuj hasło",
    "preview_marketing_description": "Tylko do podglądu. Nie zapisano jeszcze zmian.",
    "preview_custom_welcome_message": "Tylko do podglądu. Nie zapisano jeszcze zmian.",
    "reset_password_confirm_html": "<b>Czy na pewno chcesz zresetować hasło dla tego użytkownika?</b><p>Spowoduje to wysłanie do użytkownika wiadomości e-mail dotyczącej resetowania hasła.</p>",
    "reset_password_success": "Wiadomość e-mail umożliwiająca zresetowanie hasła zostanie wysłana na adres %{email}.",
    "reset_password_failed": "Nie udało się zresetować hasła.",
    "enlighten_manager_access": "Ten użytkownik ma Enlighten Manager z dostępem do danych na poziomie modułu.",
    "myenlighten_access_note": "(tylko dla użytkowników, którzy NIE są powiązani z firmą)",
    "module_level_access_note": "(z dostępem do danych na poziomie modułu)",
    "complimentary_note": "UWAGA! Przełączenie użytkownika z MyEnlighten na Enlighten Manager oznacza przekazanie aktywacji oprogramowania o wartości %{price}. Ta transakcja zostanie zarejestrowana i zgłoszona do działu finansowego.",
    "purchase_note": "Aktywacja oprogramowania została zakupiona przez %{email} za %{price} dnia %{date}.",
    "enlighten_version_title": "Wersja aplikacji Enphase",
    "unlock_account": "Odblokuj konto",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "Jestem majsterkowiczem, który instaluje produkty Enphase we własnym domu lub w firmie",
    "self_installer_false": "Jestem specjalistą ds. fotowoltaiki rejestrującym się w imieniu mojej firmy",
    "self_register_independent": "Inne",
    "opt_in": "Wyrażam zgodę na otrzymywanie biuletynów, promocji i ankiet dotyczących produktów lub usług Enphase.",
    "opt_in_info": "W każdej chwili możesz wycofać zgodę. Aby uzyskać więcej informacji, zapoznaj się z <a href='%{privacy_url}' target='_blank'>polityką prywatności</a> firmy Enphase lub <a href='%{contact_url}' target='_blank'>skontaktuj się z nami</a>.",
    "personal_details": "Dane osobowe",
    "enable_camera": "Zapewnij aplikacji dostęp do aparatu na karcie ustawień",
    "dont_allow": "Nie zezwalaj",
    "cameraText": "Umożliwi to wybranie obrazu, który chcesz przesłać jako logo firmy"
  },
  "company": {
    "id": "Identyfikator firmy",
    "active_users": "Aktywni użytkownicy",
    "address1": "Ulica i numer",
    "optional": "Opcjonalnie",
    "address2": "Ulica i numer 2",
    "address_id": "Lokalizacja",
    "branch_name": "Nazwa oddziału",
    "branch_of": "Oddział",
    "city": "Miejscowość",
    "companies": "Branches",
    "country": "Kraj",
    "duplicate_of": "Zastąpione",
    "latitude": "Szerokość geograficzna",
    "logo_img": "Logo firmy",
    "file_type_size": "Musi to być plik JPEG lub PNG nie większy niż 4 MB.",
    "file_recommendation": "Aby uzyskać najlepszy efekt, zalecamy kwadratowy obraz z przezroczystym tłem o szerokości co najmniej 400 pikseli i wysokości 400 pikseli.",
    "file_examples": "Przykład: licencja C-46, numer GST",
    "logo_img_file_size": "Logo firmy",
    "logo_img_content_type": "Logo firmy",
    "longitude": "Długość geograficzna",
    "long_name": "Nazwa firmy",
    "marketing_description": "Opis firmy",
    "custom_welcome_message": "Powitalna wiadomość e-mail dla klienta",
    "show_logo_in_welcome_email": "Wyświetlaj logo firmy w powitalnej wiadomości e-mail dla klienta",
    "name": "Imię i nazwisko",
    "parent": "Firma macierzysta",
    "phone": "Tel.",
    "role": "Rola",
    "roles": {
      "admin": "Obsługa klienta / Centrum telefoniczne",
      "installer": "Instalator",
      "distributor": "Dystrybutor",
      "third_party_owner": "Zewnętrzna firma będąca właścicielem"
    },
    "state": "Stan/Province",
    "support_email": "Adres e-mail obsługi klienta",
    "support_phone": "Numer telefonu obsługi klienta",
    "timezone": "Strefa czasowa",
    "url": "Adres URL witryny",
    "zip": "Kod pocztowy",
    "is_installer": "Ta firma instaluje systemy Enphase",
    "errors": {
      "name_not_found": "Nie można znaleźć nazwy firmy"
    },
    "success": {
      "msg": "Utworzono konto. Sprawdź pocztę e-mail, aby uzyskać instrukcje dotyczące logowania."
    }
  },
  "forecast": {
    "nodata": "Dane prognozowane są niedostępne!",
    "nodata5": "Aby dokładnie prognozować dane produkcyjne, wymagamy danych z co najmniej 5 dni.",
    "nodata10": "Wyświetlic prognoze, potrzebujemy danych produkcyjnych z co najmniej 5 dni z ostatnich 15 dni.",
    "apifail": "Nie można wyświetlić danych prognozy!",
    "apifailSub": "Blad w wyswietlaniu prognozowanych danych z powodu problemow technicznych. Prosze sprawdzić za jakis czas.",
    "weatherErr": "Błąd w wyświetlaniu prognozowanych danych z powodu niedostępnosci danych pogodowych.",
    "weatherProdErr": "Błąd w wyświetlaniu prognozowanych danych z powodu niedostępności danych produkcyjnych lub pogodowych.",
    "genErr": "Blad w wyświetlaniu prognozowanych danych z powodu problemów technicznych.",
    "envoyErr1": "Dane produkcyjne sa niedostepne, poniewaz twoja brama nie raportuje do chmury.",
    "envoyErr2": "Dane produkcyjne nie sa aktualizowany, ponieważ brama nie raportuje do chmury.",
    "microErr1": "Dane produkcyjne sa niedostepne, poniewaz zaden z mikroinwerterow nie raportuje",
    "microErr2": "Dane produkcyjne nie sa aktualizowane, poniewaz zaden z mikroinwerterow nie raportuje",
    "accCTA": "Dlaczego produkcja rzeczywista różni się od prognozowanej?",
    "ctainfo": "Prognoza bazuje na danych szacunkowych, które mogą pomóc przewidzieć zapotrzebowanie na energię. Należy pamiętać, że wartości produkcyjne mogą się różnić od prognozowanych.",
    "ctainfoRes": "Możliwe przyczyny różnic między produkcją rzeczywistą a prognozowaną",
    "ctainfoRes1": "Częste zmiany pogody w okolicy",
    "ctainfoRes2": "Niektóre z mikroinwerterów nie przekazują danych",
    "ctainfoRes3": "System nie przekazuje danych od ponad doby",
    "today": "Dziś",
    "forecast": "Prognoza",
    "actual": "Rzeczywiste",
    "timeFrom": "Pokazywanie 00:00",
    "actualProd": "Actual Production",
    "sunrise": "Wschód słońca",
    "sunset": "Zachód słońca",
    "clearDay": "Przeważnie słonecznie",
    "clearNight": "Mostly clear",
    "rain": "Głównie deszczowo",
    "snow": "Przeważnie śnieżna",
    "sleet": "Głównie ślisko",
    "wind": "Głównie wietrznie",
    "fog": "Głównie mglisty",
    "cloudy": "Pochmurny",
    "partlycloudy": "Częściowe zachmurzenie",
    "unknown": "Unknown",
    "at12": "O godzinie 00:00",
    "title": "Poznaj prognozę swojej produkcji",
    "infoIconPopup": "Prognoza produkcji szacuje, ile energii wyprodukują panele dziś i w ciągu następnych 5 dni. Prognoza jest określana na podstawie dotychczasowej produkcji energii oraz prognozy pogody dla danego regionu.",
    "fiveday": "Prognoza na 5 dni",
    "tomo": "Jutro"
  },
  "user": {
    "id": "Identyfikator użytkownika",
    "api_key": "Klucz API",
    "company": "Firma",
    "company_id": "Identyfikator firmy",
    "consumer": "MyEnlighten",
    "country": "Kraj",
    "email": "Adres e-mail",
    "email_confirm": "Potwierdź adres e-mail",
    "password": "Hasło",
    "first_name": "Imię",
    "last_name": "Nazwisko",
    "sfdc_email": "E-mail",
    "sfdc_subject": "Podmiot",
    "sfdc_message": "Wiadomość",
    "sfdc_siteId": "ID lokalizacji Enphase",
    "created_at": "Utworzono",
    "name": "Imię i nazwisko",
    "updated_at": "Zaktualizowano",
    "status": "Status",
    "phone": "Tel.",
    "locale": "Preferowane ustawienia regionalne",
    "preferred_metric": "Jednostki",
    "preferred_alert_level": "Domyślny poziom alertu",
    "preferred_array_builder": "Może tworzyć układy",
    "preferred_show_dashboard_help": "Preferencje pomocy na pulpicie",
    "preferred_new_look": "Podgląd Enlighten 3.0",
    "preferences": "Preferencje",
    "role": "Rola",
    "roles_mask": "Maska ról",
    "sales_demo": "Prezentacja handlowa",
    "sees_modules": "Może zobaczyć dane modułu",
    "notes": "Uwagi",
    "prefers_monthly_email": "Subskrybuj comiesięczną wiadomość e-mail",
    "preferred_enphase_email": "Subskrybuj wiadomość e-mail od Enphase",
    "prefers_privacy_policy_assent": "Zaakceptowano warunki polityki prywatności",
    "active": "Aktywny",
    "inactive": "Inactive",
    "add_user": "Dodaj użytkownika",
    "self_installer": "Samodzielny instalator",
    "site_access_id": "Identyfikator obiektu",
    "user_access_id": "Identyfikator użytkownika",
    "with_company": "Dołącz dane firmy do mojej rejestracji",
    "last_login": "Ostatnie logowanie",
    "acknowledge": "Potwierdzam przeczytanie i zaakceptowanie Polityki prywatności firmy Enphase",
    "privacy_url": "Polityka prywatności",
    "terms_url": "Warunki świadczenia usługi",
    "acknowledgementHead": "Potwierdzam przeczytanie dokumentu Enphase",
    "acknowledgementBody": "oraz zapoznanie się z treścią i zgodę na treść dokumentu"
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Nasza polityka prywatności zmieniła się z dniem %{policy_date}",
      "acknowledgement": "Potwierdzam przeczytanie i zaakceptowanie <a href='%{privacy_url}' target='_blank'>Polityki prywatności</a> firmy Enphase.",
      "continue_button": "Kontynuuj",
      "privacy_settings_button": "Przejdź do ustawień prywatności",
      "privacy_policy_agreement_required": "Potwierdzam przeczytanie i zaakceptowanie <a target='_blank' href='%{privacy_url}'>Polityki prywatności firmy Enphase</a>\noraz <a target='_blank' href='%{terms_url}'>Warunków świadczenia usług</a>.\n"
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "To pole jest wymagane."
    }
  },
  "validate": {
    "privacy_policy_accept": "Jeśli nie zaakceptujesz warunków Polityki prywatności i Warunków świadczenia usług Enphase, nie zarejestrujesz się w aplikacji Enphase."
  },
  "period": {
    "hours": "Dzień",
    "days": "Miesiąc",
    "week": "Tydzień",
    "months": "Rok",
    "years": "Dożywotni",
    "custom": "Niestandardowe"
  },
  "history": {
    "totals": "Sumy",
    "graph": "Strona główna",
    "production": "Wyprodukowano",
    "consumption": "Zużyto",
    "grid": "Sieć",
    "export": "Wyeksportowano",
    "import": "Zaimportowano",
    "netExported": "Wyeksportowano netto",
    "netImported": "Zaimportowano netto",
    "battery": "Akumulator",
    "charge": "Naładowano",
    "discharge": "Rozładowano",
    "soc": "Akumulator",
    "hours": "",
    "months": "",
    "today": "Dziś",
    "battery_status": "Opłata",
    "bulbs": "Żarówka 100 W",
    "last_updated": "Zaktualizowano",
    "power": "Moc",
    "solar_produced": "Wyprodukowana energia słoneczna",
    "solar_consumed": "Zużyta energia słoneczna",
    "saved": "Ocalono",
    "emission_saved": "Zaoszczędzona emisja CO2",
    "refrigerator": "Lodówka",
    "produced_today": "Wyprodukowano dzisiaj",
    "produced_yesterday": "Wyprodukowano wczoraj",
    "this_week": "Ten tydzień",
    "last_week": "ostatni tydzień",
    "this_month": "ten miesiąc",
    "last_month": "ostatni miesiąc",
    "this_year": "Ten rok",
    "last_year": "Ostatni rok",
    "selected_day": "Wybrany dzień ",
    "previous_day": "Poprzedni dzień",
    "selected_week": "Wybrany tydzień",
    "previous_week": "Poprzedni tydzień",
    "selected_month": "Wybrany miesiąc",
    "previous_month": "Poprzedni miesiąc",
    "selected_year": "Wybrany rok",
    "previous_year": "Poprzedni rok",
    "produced_this_week": "Wyprodukowano w tym tygodniu",
    "produced_last_week": "Wyprodukowano w ostatnim tygodniu",
    "produced_this_year": "Wyprodukowano w tym roku",
    "produced_last_year": "Wyprodukowano w ostatnim roku",
    "produced_this_month": "Wyprodukowano w tym miesiącu",
    "produced_last_month": "Wyprodukowano w tym miesiącu",
    "produced_lifetime": "Wyprodukowano w całym okresie użytkowania",
    "imported-exported": "Zaimportowano/Wyeksportowano",
    "yesterday": {
      "hours": "Wczoraj",
      "days": "Ostatni miesiąc",
      "months": "Ostatni rok",
      "years": "Wyprodukowano"
    },
    "lastyear": {
      "hours": "Ostatni rok",
      "days": "Ostatni rok",
      "months": "Ostatni rok",
      "years": "Wyprodukowano"
    },
    "generator": "Generator"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Wybierz częstotliwość danych",
      "daily": "Codzienny",
      "weekly": "Co tydzień",
      "monthly": "Miesięczny",
      "yearly": "Rocznie",
      "generateReport": "Do wygenerowania raportu potrzebujemy przynajmniej tygodniowych danych"
    }
  },
  "calendar": {
    "select": "Wybierz datę",
    "scale": {
      "production": "Produkcja",
      "consumption": "Zużycie"
    },
    "weekDays": {
      "monday": "Poniedziałek",
      "tuesday": "Wtorek",
      "wednesday": "Środa",
      "thursday": "Czwartek",
      "friday": "Piątek",
      "saturday": "Sobota",
      "sunday": "Niedziela"
    },
    "months": (_months = {
      "january": "Styczeń",
      "february": "Luty",
      "march": "Marzec",
      "april": "Kwiecień",
      "may": "Maj",
      "june": "Czerwiec",
      "july": "Lipiec",
      "august": "Sierpień",
      "september": "Wrzesień",
      "october": "Październik",
      "november": "Listopad",
      "december": "Grudzień",
      "jan": "Sty",
      "feb": "Lut",
      "mar": "Mar",
      "apr": "Kwi"
    }, _defineProperty(_months, "may", "Maj"), _defineProperty(_months, "jun", "Cze"), _defineProperty(_months, "jul", "Lip"), _defineProperty(_months, "aug", "Sie"), _defineProperty(_months, "sep", "Wrz"), _defineProperty(_months, "oct", "Paz"), _defineProperty(_months, "nov", "Lis"), _defineProperty(_months, "dec", "Gru"), _months),
    "time": {
      "hour": "h",
      "hours": "h",
      "minute": "min",
      "minutes": "min",
      "second": "s",
      "seconds": "s",
      "millisecond": "ms",
      "milliseconds": "ms",
      "day": "dzień",
      "h": "h",
      "hrs": "h",
      "min": "min",
      "mins": "min"
    }
  },
  "status": {
    "nameChangeNormal": "Normalne",
    "nameChangeError": 'Błąd',
    "nameChangeWarning": 'Ostrzeżenie',
    "dayTitle": "Dzisiejszy stan",
    "dayAltTitle": "Ostatni stan",
    "monthTitle": "Stan w tym miesiącu",
    "monthAltTitle": "Ostatni stan miesięczny",
    "yearTitle": "Stan w tym roku",
    "yearAltTitle": "Ostatni stan roczny",
    "lifetimeTitle": "Stan całego okresu użytkowania",
    "lifetime": "Dożywotni",
    "system_normal": "System normalny",
    "system_error": "Błąd systemu",
    "latest_power": "Ostatnia energia",
    "peak_power": "Moc szczytowa",
    "energyConsumed": "Zużyta energia",
    "energyProduced": "Produkowana energia",
    "powerProduced": "Wyprodukowana moc",
    "powerConsumed": "Zużyta moc",
    "moreDetails": "Więcej szczegółów",
    "latest_power_text": "Najnowsza energia słoneczna to najnowsza zgłoszona moc wyjściowa z systemu fotowoltaicznego",
    "peak_power_text": "Moc szczytowa to maksymalna moc wyjściowa systemu fotowoltaicznego w wybranym okresie",
    "addEnphaseStorage": "Dodaj akumulator Enphase",
    "getAQuote": "Uzyskaj wycenę",
    "production": {
      "title": "Energia słoneczna",
      "label": "Wyprodukowano",
      "section": "Miejsca docelowe energii"
    },
    "consumption": {
      "title": "Zużycie",
      "label": "Zużyto",
      "section": "Źródła energii"
    },
    "grid": {
      "title": "Energia netto",
      "export": "Wyeksportowano",
      "import": "Zaimportowano",
      "label": "Energia netto z importem/eksportem",
      "section": "Źródła energii",
      "progressbarTitle": "Energia netto z sieci"
    },
    "breakdown": {
      "consumption": "Strona główna",
      "battery": "Magazynowanie",
      "production": "Energia słoneczna",
      "grid": "Sieć",
      "export": "Wyeksportowano",
      "import": "Zaimportowano",
      "soc": "Zmagazynowano",
      "total": "Total",
      "peak": "Moc szczytowa",
      "latest": "Ostatnia energia",
      "next": "Następny raport"
    },
    "battery": {
      "title": "Magazynowanie",
      "label": {
        "none": "bezczynny",
        "positive": "Ładowanie",
        "negative": "Rozładowywanie"
      },
      "section": "Dostępna energia"
    },
    "charge": "Opłata",
    "stormAlertOn": "Alert burzowy: włączony",
    "batteryProfile": "Profil",
    "batteryInfo1": "Bazując na zużyciu w ostatnich 24 godzinach, (%{consumption}) Twój system Enphase będzie działać przez około ",
    "batteryInfo2": " bez energii słonecznej ani połączenia z siecią.",
    "batteryInfoWOSolar": " bez sieci.",
    "batteryErrorInfo": "Nie mamy wystarczającej ilości danych, aby oszacować czas zasobu rezerwowego akumulatora.",
    "to": "do",
    "batteryZeroErrorInfo": "Masz 0 godzin zasobów rezerwowych, ponieważ Twoje akumulatory są rozładowane.",
    "hours": "h",
    "minutes": "min",
    "gridControls": {
      "verifyOtp": "Zweryfikuj kod",
      "verificationCode": "Kod weryfikacyjny",
      "offGridContent": "Utracisz połączenie z siecią. Moc dostępna do wykorzystania będzie ograniczona.",
      "tryAgainContent": "Nie można nawiązać połączenia z bramą.",
      "verifyOtpEmail": "Wprowadź czterocyfrowy kod wysłany na adres e-mail użyty podczas rejestracji.",
      "verifyOtpEmailMobile": "Wprowadź czterocyfrowy kod wysłany na adres e-mail i numer telefonu komórkowego użyte podczas rejestracji.",
      "verifyOtpUpdateMobile": "Czterocyfrowy kod zostanie wysłany na adres e-mail użyty podczas rejestracji.",
      "onGridContent": "Czy chcesz teraz ponownie połączyć swój system z siecią?",
      "pleaseTryAgain": "Spróbuj ponownie",
      "enterValidOtp": "Wprowadź prawidłowy kod",
      "didntReceiveOtp": "Não recebeu o código?",
      "goOffGrid": "Odłącz od sieci",
      "goOnGrid": "Podłącz do sieci",
      "tryAgain": "spróbuj ponownie",
      "resend": "Wyślij ponownie",
      "alert": "Dostęp do kontroli sieci jest wyłączony, ponieważ trwa uaktualnianie systemu. Aktualizacja może potrwać do 24 godzin. Poczekaj na ukończenie aktualizacji.",
      "sendCode": "Wyślij kod",
      "mobileStatus": "aby otrzymać kod SMS-em.",
      "myInfoButton": "Zaktualizuj swój numer telefonu komórkowego,",
      "wpc1l1": "Twój obecny poziom zużycia jest wyższy niż dostępna produkowana energia słoneczna.  Zmniejsz zużycie energii, aby uniknąć wyłączenia systemu podczas zmiany trybu.​",
      "wpc1l2": "Aktualne dane dotyczące produkcji energii słonecznej i zużycia energii przez podstawowe obciążenia można sprawdzić w sekcji %{liveStatus}.",
      "wpc2l1": "Twoje średnie zużycie energii z ostatnich 15 minut jest większe niż średnia produkcja energii słonecznej. Upewnij się, że aktualna produkcja energii słonecznej jest wystarczająca do pokrycia zapotrzebowania na energię, aby uniknąć wyłączenia systemu w trybie odłączenia od sieci.",
      "wpcOnGrid": "System jest obecnie zasilany z generatora. Jeśli zużycie energii jest bardzo wysokie, przejście do trybu połączenia z siecią może spowodować tymczasową przerwę w dostawie prądu. Zmniejsz zużycie energii, aby uniknąć tego typu zakłóceń.",
      "wpcOnGrid2": "Bieżące zużycie można sprawdzić na stronie %{liveStatus}."
    },
    "viewDetails": "Wyświetl szczegóły",
    "socMessageError1": "Łączna zmagazynowana energia",
    "socMessageError2": "nie obejmuje procenta energii",
    "socMessageError3": "Akumulator(y)",
    "socMessageThreshold": "Stan naładowania akumulatorów jest nieznany, ponieważ żaden z akumulatorów nie przesłał danych podczas ostatniego cyklu sprawozdawczego"
  },
  "menu": {
    "supportHistory": "Historia pomocy technicznej",
    "supportHistorySearch": "",
    "connectedAppliances": "Podłączone urządzenia",
    "connectedAppliancesSubtitle": "Monitoruj i kontroluj inteligentne urządzenia",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Monitorowanie i sterowanie urządzeniami wyposażonymi w Home Connect",
    "appTutorial1": "Możesz zapoznać się ze wszystkimi samouczkami systemowymi w dowolnym momencie, przechodząc do",
    "appTutorial2": "Poznaj swój system",
    "appTutorial": "Poznaj swój system",
    "appTutorial3": "w sekcji",
    "appTutorial4": "System",
    "viewallsystutorial": "Zobacz wszystkie samouczki systemowe",
    "voiceAssistant": "Asystent głosowy",
    "voiceAssistantSubtitle": "Włącz sterowanie głosowe w Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Prognoza produkcji",
    "generator": "Generator",
    "dryContactLoads": "Obciążenia",
    "generatorDevice": "Generator",
    "loadControl": "Kontrola obciążenia",
    "advanceSettings": "Ustawienia zaawansowane",
    "advanceBatterySettings": "Ustawienia zaawansowane",
    "advancedBatterySettings2": "Ustawienia zaawansowane",
    "loadControlSubtitle": "Sterowanie zasilaniem odbiorników",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Powiadomienia",
    "newNotices": "Powiadomienia",
    "reports": "Raporty",
    "exploreEnphase": "Poznaj Enphase",
    "exploreEnphaseNewMenu": "Przeglądaj",
    "details": "Szczegóły",
    "detailSite": "SZCZEGÓŁY LOKALIZACJI",
    "detailsInstaller": "SZCZEGÓŁY INSTALATORA",
    "systemDescription": "Opis systemu",
    "systemStatistics": "Estatísticas do sistema",
    "settings": "Ustawienia ",
    "account": "Konto",
    "support": "Wsparcie",
    "supportFaq": "Często zadawane pytania",
    "emergencySupport": "Zadzwoń do nas",
    "contactUs": "Skontaktuj się z nami",
    "contactSupport": "Napisz do nas",
    "devices": "Urządzenia",
    "addStorage": "Dodaj akumulator",
    "devicesOld": "Urządzenia",
    "configure": "Skonfiguruj",
    "batteryStorage": "Akumulatory",
    "batteryStorageNewMenu": "Akumulator",
    "connectivity": "Łączność",
    "connectGateway": "Łączność",
    "batteryReserve": "Rezerwa akumulatora",
    "expertModeEdit": "Tryb eksperta",
    "eventsHistory": "Historia zdarzeń",
    "backupHistory": "Historia zasobów rezerwowych",
    "outageHistory": "Outage History",
    "event": "Zdarzenie",
    "events": "Zdarzenia",
    "totalEvents": "Łączna liczba zdarzeń",
    "totalBackup": "Całkowite zasoby rezerwowe",
    "backupDuration": "Czas zasilania rezerwowego",
    "hours": "h",
    "minutes": "min",
    "siteDetails": "Szczegóły lokalizacji",
    "wifi": "Typ połączenia",
    "liveVitals": "Parametry na żywo",
    "envoy": "Brama",
    "envoyNotReport": "Brama nie zgłasza się",
    "microInverterNotReporting": "Mikroinwertery nie zgłaszają",
    "enpowerNotReporting": "Sterownik systemu nie zgłasza się",
    "enchargeNotReporting": "Akumulator nie zgłasza się",
    "enchargeError": "Błąd akumulatora",
    "enpowerError": "Błąd sterownika systemu",
    "microinverters": "Mikroinwertery",
    "stringInverters": "Falownik łańcuchowy",
    "storage": "Akumulator",
    "reconnectToEnvoy": "Łączność",
    "configureWiFi": "Skonfiguruj sieć Wi-Fi",
    "envoyInternetConnection": "Aby zmienić połączenie internetowe bramy",
    "enpower": "Sterownik systemu",
    "theme": "Motyw",
    "darkmode": "Tryb ciemny",
    "devmode": "Tryb programisty",
    "registerOjasBox": "Portable Energy System",
    "appUpdate": "Aktualizacje aplikacji",
    "feedback": "Opinia",
    "logout": "Wyloguj się",
    "help": "Pomoc",
    "siteid": "Identyfikator obiektu",
    "visitTommorrowForReport": "Sprawdź ponownie jutro. Chmura Enphase nie zebrała danych wymaganych do wygenerowania raportów.",
    "email_report": "Raport e-mail",
    "will_send": "Zostanie wysłany do",
    "ojasSurroundLight": "Oświetlenie zewnętrzne",
    "ojasSurroundLightSt": "Zmodyfikuj ustawienia oświetlenia urządzenia",
    "batterySubtitle": "Zoptymalizuj akumulator na podstawie użytkowania i taryfy",
    "batteryEmeaSubtitle": "Zoptymalizuj akumulator na podstawie użytkowania",
    "connectivitySubtitle": "Zmień sposób w jaki Twoja bramka komunikacyjna Envoy łączy się z internetem",
    "generatorSubtitle": "Zoptymalizuj generator na podstawie ustawień",
    "eventsHistorySubtitle": "Wyświetl dziennik najważniejszych zdarzeń systemu",
    "backupHistorySubtitle": "Wyświetl historię przerw w dostawie prądu",
    "registerOjasBoxSubtitle": "Register your Portable Energy System",
    "accountSubtitle": "Dane osobowe, język, ustawienia prywatności",
    "wifiSubtitle": "Standardowe łącze, przekazywanie danych co 15 min",
    "liveVitalsSubtitle": "Wyświetl najważniejsze parametry systemu na żywo",
    "themeSubtitleOn": "Tryb ciemny jest włączony",
    "themeSubtitle": "Tryb ciemny jest wyłączony",
    "devmodeSubtitle": "Opcje trybu deweloperskiego",
    "appUpdateSubtitle": "Informacje o wydaniu najnowszych aktualizacji i dziennika zmian",
    "appUpdateSuccessSubtitle": "Aplikacja jest aktualna",
    "requestReplacement": "Poproś o wymianę",
    "changeShippingAddress": "Zmień adres wysyłki",
    "tariffEditor": "Stawka za energię elektryczną",
    "tariffEditorNewMenu": "Stawka za energię elektryczną",
    "currencyConversion": "Równowartość w walucie",
    "currencyConversionNewMenu": "Waluta",
    "currencySubtitle": "Przekształca dane dotyczące energii w stawki pieniężne",
    "showCurrency": "Pokaż równowartość w walucie",
    "showCurrencySubtitle": "Turn on to show conversion widget",
    "passwordReset": "Resetowanie hasłat",
    "tariffAdded": "Wyświetl/edytuj strukturę stawek za energię elektryczną swojego dostawcy prądu",
    "showCurrencySubtitleOff": "Wyłącz, aby ukryć widżet waluty",
    "tariffNotAdded": "Nie dodano struktury stawek za energię elektryczną",
    "enlightenManager": "Wyświetl w Enlighten Manager",
    "sgipIncentive": "Dofinansowanie do magazynowania energii (SGIP)",
    "gridServices": "Usługi sieciowe",
    "enphaseHome": "Właśnie wprowadziłem(-am) się do domu, który ma system Enphase",
    "systemAccess": "Wszystko jest skonfigurowane, ale potrzebuję dostępu do systemu",
    "woSiteSystemAccess": "Dostęp do systemu",
    "enphaseProducts": "Dowiedz się więcej o produktach Enphase",
    "enphaseTeam": "Uzyskaj pomoc od zespołu Enphase",
    "gridSwitch": "Kontrola sieci",
    "onGrid": "Podłączono do sieci",
    "chatWithUs": "Porozmawiaj z nami na czacie",
    "referFriends": "Polecaj znajomych",
    "referralTnC": "Regulamin",
    "hello": "Witamy!",
    "homeControls": "Funkcje kontroli domu",
    "systemDetails": "System",
    "pesDetails": "System",
    "community": "Społeczność",
    "settingsMenu": "Ustawienia ",
    "enphaseStore": "Sklep Enphase",
    "upgrades": "Aktualizacje",
    "services": "Usługi",
    "generatorSubtitle2": "Kontroluj generator, gdy jest poza siecią",
    "devicesSubtitle": "Wyświetl wszystkie urządzenia wraz ze statusem",
    "siteDetailsSubtitle": "Wyświetl szczegóły obiektów i instalatorów",
    "reportsSubtitle": "Wygeneruj i wyślij raporty",
    "appSettings": "Ustawienia aplikacji",
    "accountSettings": "Ustawienia konta",
    "addStorageSubtitle": "Dodaj akumulator, aby uniknąć przerw w zasilaniu",
    "addSolarPanels": "Dodaj panele słoneczne",
    "addSolarPanelsSubtitle": "Zwiększ samokonsumpcję",
    "sgipIncentiveSubtitle": "Złóż wniosek o ulgę SGIP",
    "gridServicesSubtitle": "Zyskuj, wspomagając sieć energetyczną akumulatorami IQ Battery",
    "incentives": "Ulgi",
    "accountMenu": "Konto",
    "myInformation": "Moje dane",
    "myNotificationPreferences": "Moje Powiadomienia",
    "myPrivacy": "Moja prywatność",
    "myAccessControl": "Moja kontrola dostępu",
    "myInformationSubtitle": "Zaktualizuj dane osobiste i szczegóły systemu",
    "myNotificationPreferencesSubtitle": "Zarządzaj powiadomieniami",
    "myPrivacySubtitle": "Kontroluj, jak Enphase wykorzystuje informacje dotyczące systemu",
    "myAccessControlSubtitle": "Zarządzaj dostępem do danych systemu",
    "systemSettings": "Ustawienia systemu",
    "deviceSettings": "Ustawienia urządzenia",
    "wirelessRangeExtender": "Wzmacniacz sygnału bezprzewodowego",
    "cacheAction": "Wyczyść lokalną pamięć podręczną",
    "cacheResult": "Dane energetyczne przeglądarki zostały wyczyszczone",
    "noActiveNotices": "Nie masz dostępnych powiadomień.",
    "appInfo": "Informacje o aplikacji",
    "whatsNew": "Co nowego",
    "privacyPolicy": "Polityka prywatności",
    "tos": "Warunki świadczenia usługi",
    "rateUs": "Oceń aplikację",
    "gridToggle": {
      "infoPopupTitle": "System rezerwowy zasilany światłem słonecznym",
      "infoPopupContentP1": "Twój system to system rezerwowy zasilanym światłem słonecznym, dlatego nie zalecamy przełączania go do trybu odłączenia od sieci poza godzinami nasłonecznienia.",
      "pIt1": "Gdy system przechodzi w tryb odłączenia od sieci, odbiorniki nieistotne pod względem działania systemu są odłączane od zasilania.",
      "pIt2": "Przejście w tryb odłączenia od sieci jest możliwy wyłącznie w godzinach, w których niezbędne odbiorniki mają być wg harmonogramu zasilane: %{scheduledMode}.",
      "pIt3": "Jeśli ilość światła słonecznego w trybie odłączenia od sieci będzie niewystarczająca, Twój system może zostać wyłączony.",
      "scheduledMode​": "Tryb harmonogramu",
      "infoPopupContentP2": "Gdy system przechodzi w tryb odłączenia od sieci, odbiorniki nieistotne pod względem działania systemu są odłączane od zasilania. Poza wyznaczonymi godzinami przełączanie w tryb odłączenia od sieci jest niedozwolone. Jeśli ilość światła słonecznego w trybie odłączenia od sieci będzie niewystarczająca, Twój system może zostać wyłączony."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Poznaj swoje urządzenie",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Zabierz swą moc ze sobą. Bezpieczeństwo energetyczne i energia w ruchu.",
      "enphasePESConnectDevice": "Podłącz urządzenie",
      "enphasePESLearnMore": "Dowiedz się więcej",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Zarejestruj urządzenie",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Upewnij się, że włączono łączność Bluetooth w telefonie.",
      "registerStep1": "Zaloguj się do / Załóż konto w Enphase",
      "registerStep2": "Sparuj urządzenie i telefon przez Bluetooth",
      "registerStep3": "Nazwij urządzenie​",
      "registerStep4": "Ligue-o à rede Wi-Fi",
      "register": "Zarejestruj",
      "start": "Rozpocznij",
      "later": "W przyszłości",
      "fserialNumber": "Wprowadź numer seryjny",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Nazwij swoje urządzenie",
      "enterBoxName": "Nazwa urządzenia",
      "connectToWiFi": "Połącz urządzenie z siecią Wi%{nbh}Fi",
      "connectToWiFiNotice": "Wybierz preferowaną sieć Wi-Fi i wprowadź hasło.",
      "takeFewMinutes": "Może to potrwać kilka minut",
      "connectingToWifi": "Łączenie z siecią Wi-Fi",
      "pleaseContactSupport": "Skontaktuj się z obsługą klienta, aby uzyskać pomoc.",
      "unableToCompleteConnect": "Nie można połączyć",
      "incomplete": "Nie ukończono",
      "congratulations": "Gratulujemy!",
      "incorrectPasswordTryAgain": "Nieprawidłowe hasło Spróbuj ponownie",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "została zarejestrowana",
      "startMonitoring": "Rozpocznij monitorowanie",
      "turnOnBluetoothOnNotice": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy System",
      "noOjasDevicesFound": "Nie znaleziono przenośnej stacji zasilania",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Nieprawidłowy kod",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Pobieranie szczegółów urządzenia",
      "capturedDeviceDetails": "Pobrano szczegóły urządzenia",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Błąd rejestracji",
      "registrationErrorNotice": "Powtórz rejestrację. Jeśli problem nie ustąpi, ",
      "deviceAlreadyRegistered": "Urządzenie jest już zarejestrowane",
      "deviceAlreadyRegisteredNotice": "Ten przenośny system energetyczny jest już zarejestrowany na innym koncie Enphase.",
      "proceed": "Kontynuuj",
      "rename": "Zmień nazwę",
      "nameAlreadyExist": "Nazwa już istnieje",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Nawiązano połączenie Bluetooth!",
      "enter4DigitCode": "Introduza o código de 4 dígitos",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Wyślij kod ponownie",
      "connWithOJASBLE": "Połącz z przenośną stacją zasilania przez Bluetooth",
      "noBLEDevicesFound": "Nie znaleziono urządzeń Bluetooth",
      "backupTime": "Czas zasobu rezerwowego",
      "timeToCharge": "Czas do naładowania",
      "powerSaving": "Oszczędzanie energii",
      "poweredOn": "Włączono",
      "powerOn": "Włącz",
      "powerOff": "Wyłącz",
      "close": "Zamknij",
      "powerSavingHeader": "Urządzenie oszczędza energię",
      "powerOnHeader": "Urządzenie jest włączone",
      "powerSavingSubHeader": "(wyjście AC wyłączone)",
      "powerSavingContent": "Możesz zdalnie włączać i aktywować wyjście AC lub wyłączać urządzenie i dezaktywować wszystkie źródła zasilania wejściowego i wyjściowego.",
      "powerOnContent": "Możesz zdalnie wyłączać urządzenie i dezaktywować wszystkie źródła zasilania wejściowego i wyjściowego.",
      "shuttingDown": "Wyłączenie w ciągu",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "Urządzenie nie jest podłączone do aplikacji Enphase!",
        "1_description": "Upewnij się, że Twoje urządzenie zostało włączone i ma połączenie z Wi-Fi. Jeśli jesteś w pobliżu swojego urządzenia, możesz sparować telefon z urządzeniem przez Bluetooth.",
        "1_action": "Połącz przez Bluetooth",
        "3_title": "Łączność Bluetooth nie jest obsługiwana!",
        "3_description": "Łączność Bluetooth nie jest obsługiwana przez Twoje urządzenie. Upewnij się, że urządzenie obsługuje Bluetooth i usługi lokalizacyjne.",
        "4_title": "Włącz Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Trwa skanowanie w poszukiwaniu urządzeń Bluetooth…",
        "7_title": "Urządzenia Bluetooth",
        "8_title_success": "Nie znaleziono urządzeń Bluetooth.",
        "8_title_error": "Problem utrzymywał się podczas skanowania.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Nawiąż połączenie Bluetooth...",
        "10_title": "Wprowadź PIN potwierdzający posiadanie dotyczący",
        "10_subTitle": "PIN potwierdzający posiadanie",
        "11_title": "Nawiązano połączenie Bluetooth!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " zostało pomyślnie ustanowione.",
        "12_title": "Bluetooth nie jest obsługiwany!",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " nie powiodło się. Spróbuj ponownie.",
        "13_title": "Szukanie sieci Wi-F...",
        "14_title": "Połącz PES z siecią Wi-Fi",
        "14_description": "Wybierz preferowaną sieć Wi-Fi i wprowadź hasło.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "Nie znaleziono sieci Wi-Fi.",
        "15_title_error": "Problem utrzymywał się podczas skanowania.",
        "15_description": "Keep the Wi-Fi router on and your Portable Energy System unit in the Wi-Fi range.",
        "18_title_1": "Wysyłanie danych logowania do Wi-Fi",
        "18_title_2": "Nawiązywanie połączenia Wi-Fi",
        "18_description": "zrealizowane pomyślnie,",
        "19_title": "Nie ukończono!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Identyfikator urządzenia",
      "ojasSettings": {
        "profile": "Profile",
        "acPorts": "Porty AC",
        "dcPorts": "Porty DC",
        "on": "Włączone",
        "off": "Wyłączone",
        "brightnesSettings": {
          "brightness": "Jasność",
          "customBrightness": "Jasność niestandardowa",
          "auto": "Automatyczna regulacja jasności"
        },
        "lightSettings": {
          "light": "Światło",
          "on": "Zawsze włączone",
          "off": "Zawsze wyłączone",
          "auto": "Automatycznie",
          "onMsg": "Pozostaje włączone",
          "autoMsg": "Włącza się, gdy ktoś jest w pobliżu",
          "offMsg": "Pozostaje wyłączone"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Zasilanie włączone",
          "powerOff": "Zasilanie wyłączone",
          "powerSave": "Oszczędzanie energii"
        },
        "ojasModes": {
          "on": "Wszystkie wyjściowe porty AC i DC są włączone. Urządzenie powinno pozostać w tym trybie, jeśli narzędzia lub urządzenia są podłączone do portu AC.",
          "save": "Tylko porty DC są włączone i gotowe do zasilania urządzeń elektronicznych. W tym trybie jest oszczędzana energia, ponieważ porty AC są wyłączone.",
          "off": "Wszystkie źródła zasilania na wejściu i wyjściu zostaną wyłączone."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Oszczędności",
    "appTutorialPage": {
      'all-topics-empty': 'Brak dostępnych tematów',
      'videos-empty': 'Brak dostępnych filmów',
      'articles-empty': 'Brak dostępnych artykułów',
      'noResults': "Brak wynik\xF3w dla \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Środowisko",
    "label": "Wpływ środowiska",
    "rightText": "Źródło: epa.gov",
    "equivalent": "Odpowiednik",
    "planted": "ZASADZONO",
    "carbon_offset": "KOMPENSACJA EMISJI",
    "charged": "NAŁADOWANO",
    "trees": {
      "zero": "drzewa",
      "one": "drzewo",
      "other": "drzewa"
    },
    "phone": {
      "one": "telefon",
      "other": "telefony"
    },
    "tonne": {
      "one": "tona",
      "other": "tony"
    },
    "lb": {
      "one": "lb",
      "other": "lb"
    },
    "ton": {
      "one": "tona",
      "other": "mnóstwo"
    }
  },
  "connectionType": {
    "wifi": "Wi-Fi",
    "cellular": "Modem komórkowy",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Przekazuje dane co 15 min",
    "reportsAt6Hrs": "Przekazuje dane co 6 h",
    "idle": "Bezczynny",
    "notAvailable": "Niedostępny",
    "configureWiFiSettings": "Skonfiguruj ustawienia komunikacji bezprzewodowej",
    "configureWiFiSettings2": "Skonfiguruj",
    "switchToWiFi": "Przełącz na łączność Wi-Fii",
    "connectToWiFi": "Połącz z siecią Wi-Fi",
    "bluetooth": 'Bluetooth',
    "bluetoothOff": 'Bluetooth WYŁĄCZONY'
  },
  "details": {
    "connection_type": "Typ połączenia",
    "description": "Opis systemu",
    "installer": "Zainstalowany przez",
    "maintainer": "Serwisant systemu",
    "micros": {
      "one": "Mikroinwerter",
      "other": "Mikroinwertery"
    },
    "acbs": {
      "one": "Akumulator",
      "other": "Akumulatory"
    },
    "arrays": {
      "one": "Układ",
      "other": "Arrays"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% więcej niż wczoraj o tej godzinie",
    "less_yesterday": "% mniej niż wczoraj o tej godzinie",
    "same_yesterday": "Mniej więcej tak samo, jak wczoraj o tej godzinie",
    "more_last_year": "% więcej niż w zeszłym roku o tej godzinie",
    "less_last_year": "% mniej niż w zeszłym roku o tej godzinie",
    "same_last_year": "Mniej więcej tak samo, jak w zeszłym roku o tej godzinie",
    "more_yesterday_prev": "% więcej niż o tej porze poprzedniego dnia",
    "less_yesterday_prev": "% mniej niż o tej porze poprzedniego dnia",
    "same_yesterday_prev": "Mniej więcej tak samo jak o tej porze poprzedniego dnia",
    "more_last_year_prev": "% więcej niż w tym czasie w poprzednim roku",
    "less_last_year_prev": "% mniej niż w tym czasie w poprzednim roku",
    "same_last_year_prev": "Mniej więcej tak samo jak w zeszłym roku",
    "system": "System",
    "emptyArray": "Brak dostępnego schematu układu",
    "storageArray": "Układ magazynowania energii",
    "solarArray": "Układ paneli słonecznych",
    "contactInstForpersonalizedLayout": "Skontaktuj się z instalatorem, aby uzyskać spersonalizowany widok układu magazynowania energii",
    "cntcInstPopP1": "Układ magazynowania energii pokazuje obraz jednostek magazynujących zainstalowanych w domu wraz z ich poziomami naładowania.",
    "cntcInstPopP2": "Skontaktuj się z instalatorem, aby zbudować układ magazynowania energii w aplikacji Installer Tool Kit lub w aplikacji Enlighten Manager i uzyskać bardziej spersonalizowany widok"
  },
  "support": {
    "enphase": "Pomoc techniczna-Enphase",
    "enphaseLink": "Pomoc techniczna-Enphase",
    "maintainer": "Wsparcie i utrzymanie systemu",
    "maintainerLink": "Skontaktuj się z serwisantem",
    "contactEnphase": "Kontakt z firmą Enphase",
    "enphaseSupport": "Pomoc techniczna-Enphase",
    "ensembleSupport": "Zadzwoń do obsługi klienta Ensemble",
    "writeToUs": "Napisz do nas",
    "visitSupport": "Odwiedź stronę obsługi klienta",
    "talkToUs": "Porozmawiaj z nami",
    "talkToUsAnytime": "Możesz z nami porozmawiać w każdej chwili",
    "customerSupport24by7": "Obsługa klienta dostępna codziennie i przez całą dobę",
    "needHelpTitle": "Jak Możemy Pomóc",
    "envoyNotReporting": "System lub brama nie zgłaszają się",
    "microinvertersNotReporting": "Mikroinwertery nie zgłaszają",
    "productionIssue": "Problem z produkcją energii",
    "productionDifference": "Różnice w produkcji energii przez poszczególne panele",
    "needMoreHelpTitle": "Potrzebuję więcej pomocy",
    "askEnphaseCommunity": "Zadaj pytanie społeczności Enphase",
    "browseTopics": "Przeglądaj wszystkie tematy pomocy",
    "chatWithUs": "Porozmawiaj z nami na czacie",
    "contactUs": "Skontaktuj się z nami",
    "helpTopics": "Tematy Pomocy",
    "brwsAllFaqs": "Przeglądaj wszystkie często zadawane pytania",
    "askEnphaseCommunitySubtitle": "Nawiąż kontakt z innymi klientami Enphase w regionie",
    "systemOwnerGuide": "Patrz Podręcznik użytkownika systemu",
    "faq": {
      "usingManualOverride": "Korzystanie ze sterowania ręcznego",
      "understandingEnpower": "Sposób działania inteligentnego przełącznika IQ System Controller",
      "understandingEncharge": "Sposób działania akumulatora IQ Battery",
      "understandIQCombiner": "Objaśnienie działania urządzenia IQ Combiner, bramy, zestawu do komunikacji i modemu komórkowego",
      "stormGaurdFeatureDetails": "Szczegóły funkcji zabezpieczenia przeciwburzowego",
      "settingElectricityRateStructure": "Ustawienie struktury stawek za energię elektryczną",
      "recoverShutdownLL": "Przywracanie sprawności po wyłączeniu spowodowanym dużym obciążeniem",
      "recoverShutdownCF": "Przywracanie sprawności po wyłączeniu spowodowanym awarią komunikacji",
      "recoverShutdownBD": "Przywracanie działania po wyłączeniu z powodu rozładowania akumulatora",
      "PowerHomeInBCK": "Zasilanie urządzeń domowych podczas korzystania z zasobów rezerwowych",
      "partialHomeBCK": "Konfiguracja zasilania części domu z zasobów rezerwowych",
      "monitorUrSys": "Monitorowanie systemu",
      "mngLgApplianceBck": "Używanie dużych urządzeń podczas korzystania z zasobów rezerwowych",
      "incentivesAvlbTou": "Dostępne programy dofinansowania",
      "grdTrnxToOffGrd": "Przełączanie w tryb Off Grid",
      "allHomeBck": "Zasilanie całego domu z zasobów rezerwowych",
      "envLEDstatus": "Status diody LED bramy",
      "dsgnUrSys": "Projektowanie systemu",
      "cntctCustSupp": "Kontakt z obsługą klienta",
      "batSmrtPrfSel": "Wybór inteligentnego profilu akumulatorów",
      "accsEnchrgDcswtch": "Dostęp do przełącznika DC w akumulatorze",
      "mcrInvNtReprt": "Mikroinwerter nie zgłasza się",
      "sysEnvNtReprt": "Brama nie zgłasza się",
      "hwUrSysWrk": "Jak działa Twój system?",
      "enchrLedStatus": "Status diody LED akumulatora",
      "noPwNebDo": "Brak zasilania pomimo połączenia z siecią",
      "consBatDurGridOut": "Oszczędność energii podczas przerwy w dostawie prądu",
      "emgSupCallSteps": "Wybierz 2 dla obsługi klienta i 1 dla właścicieli systemu. Wybierz 2 w podmenu dla systemów pamięci masowej.",
      "preLoginCallSteps": "Wybierz cyfrę 2, aby skontaktować się z obsługą klienta lub cyfrę 4, aby skontaktować się z działem sprzedaży.",
      "sysProdIssue": "Problem z produkcją energii przez system",
      "diffInPerPanProd": "Różnice w produkcji energii przez poszczególne panele",
      "installCellModem": "Instrukcja instalacji modemu komórkowego",
      "whatIsEI": "Ocena niezależności energetycznej",
      "howEnHomeEngSysWork": "Jak działa domowy system produkcji energii Enphase?",
      "understandEnv": "Objaśnienie działania bramy",
      "findEnv": "Znajdowanie bramy",
      "envReplaced": "Wymieniono bramę",
      "rebootEnv": "Ponowne uruchamianie bramy",
      "hwChangeEmail": "Jak zmienić adres e-mail?",
      "hwResetPasswd": "Jak zresetować hasło?",
      "accessEnvLocalIntf": "Dostęp do lokalnego interfejsu bramy",
      "envLocIntfLogCred": "Poświadczenia logowania do lokalnego interfejsu bramy",
      "hwDisbaleNotification": "Jak włączyć lub wyłączyć sprawozdania miesięczne i inne powiadomienia e-mail?",
      "MontEngProd": "Monitorowanie produkcji energii",
      "whyNotSeeConsumption": "Dlaczego nie widzę swojego zużycia energii?",
      "hwMonConsumpt": "Jak monitorować zużycie energii w domu?",
      "calEngUsageWoConsumptionMonitoring": "Obliczanie zużycia energii bez monitorowania zużycia",
      "undersNetEng": "Objaśnienie terminu opomiarowania netto",
      "understTrueUpStmt": "Objaśnienie terminu rachunku wyrównawczego",
      "diffPaidENLMvsPerpanelDataaoffering": "Różnica między płatną wersją narzędzia Enlighten Manager a bezpłatną wersją oferującą dane dotyczące produkcji energii przez poszczególne panele",
      "blkInPerpanMon": "Czarny panel w widoku paneli",
      "gryorBlnkInPerpanMon": "Szary (pusty) panel w widoku paneli",
      "hwToMovePnl": "Jak przenieść panel?",
      "hwfindInst": "Jak znaleźć nowego instalatora?",
      "whtdoIfonePanelNotreproduc": "Co zrobić, jeśli jeden z paneli nie produkuje energii lub działa niewydajnie?",
      "haveaSelfPoweredHome": "Co to znaczy mieć dom z samowystarczalnym zasilaniem?",
      "yourSystemPaysForItself": "Po jakim czasie inwestycja w system się zwróci?",
      "enphaseSystemsAreSafe": "Dlaczego systemy Enphase są bezpieczne?"
    },
    "webBackButton": "Wstecz",
    "supportHistory": "Historia pomocy technicznej"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Dodaj pojazd elektryczny",
    "addevSub": "Daj nam znać, czy używasz systemu Enphase do ładowania pojazdu elektrycznego, abyśmy mogli dostarczyć informacje i zalecić optymalne czasy ładowania.",
    "haveEv": "Mam samochód elektryczny.",
    "qbrand": "Jakiej marki jest Twój pojazd elektryczny?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "Jak nazywa się model Twojego pojazdu elektrycznego?",
    "diffcharger": "Ładuję samochód elektryczny w domu, korzystając z ładowarki innej firmy",
    "qcharger": "Jakiej marki jest Twoja ładowarka?",
    "qcapacity": "Jaka jest pojemność akumulatora/baterii Twojego pojazdu elektrycznego (w kWh)?",
    "notcompulsory": "*to pytanie nie jest obowiązkowe. Możesz je pominąć, jeśli nie znasz odpowiedzi.",
    "qtime": "Kiedy ładujesz samochód?",
    "morning": "Ranek",
    "afternoon": "Popołudnie",
    "evening": "Wieczór",
    "night": "Noc",
    "other": "Inna pora (wpisz)",
    "qmiles": "Jaki dystans pokonujesz zwykle w ciągu dnia?",
    "brand": "Szczegóły marki",
    "tech": "Szczegóły techniczne",
    "operational": "Szczegóły operacyjne",
    "ev": "Pojazd elektryczny:",
    "suggsch": "Proponowany harmonogram",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Usuń pojazd elektryczny",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Włącz aplikację Storm Guard",
    "stormGuardEnablePopUpFooter": "Czy chcesz włączyć aplikację Storm Guard?",
    "stormGuardDisablePopUpHeader": "Wyłącz aplikację Storm Guard",
    "stormGuardDisablePopUpFooter": "Czy nadal chcesz wyłączyć aplikację Storm Guard?",
    "backupTime": "Czas tworzenia kopii zapasowej",
    "encharge_battery": "Wybierz inteligentny profil, aby sterować swoim akumulatorem",
    "encharge_battery_emea": "Inteligentny profil do kontrolowania baterii",
    "savings": "Tryb oszczędzania",
    "expert": "Tryb eksperta",
    "self-consumption": "Zużycie Własne",
    "battery_bkup": "Pełna Kopia Zapasowa",
    "savings_text": "Zminimalizuj zużycie energii elektrycznej z sieci, gdy stawka za energię elektryczną jest wyższa. W godzinach szczytu dom jest zasilany przez: akumulator, energię słoneczną i sieć w tej kolejności. Wszelka dodatkowa energia słoneczna jest eksportowana do sieci.",
    "consumption_text": "Wykorzystaj zmagazynowaną energię słoneczną do zasilania domu po zachodzie słońca. Akumulator jest używany, gdy energia słoneczna nie jest dostępna.",
    "consumption_text_pv_yield": "Ładuj akumulator w godzinach szczytu, aby zoptymalizować produkcję PV. Bateria jest używana, gdy energia słoneczna nie jest dostępna.",
    "bkup_text": "Energia z akumulatora jest w 100% przeznaczona na potrzeby rezerwowe.",
    "reserve": "Rezerwa",
    "optimization": "Optymalizacja na podstawie",
    "utility_rates": "Stawki za energię",
    "increase_consumtion": "Zwiększ zużycie własne do",
    "max_consumption": "Maksymalizuj niezależność energetyczną",
    "optimize_pv_production": "Optymalizacja produkcji fotowoltaicznej",
    "activate": "Aktywuj",
    "active": "Aktywny",
    "save": "Zapisz",
    "edit": "EDYTUJ",
    "error": "Nie można zapisać ustawień magazynowania.",
    "requestTakingLonger": "Żądanie trwa dłużej niż oczekiwano. Sprawdź ponownie później",
    "batterySettingsTakingLonger": "Aktualizacja ustawień akumulatora trwa dłużej niż oczekiwano. Sprawdź ponownie później",
    "completed": "Pomyślnie zaktualizowano konfigurację akumulatora.",
    "completedAdvance": "Ustawienia zaawansowane akumulatora zostały pomyślnie zaktualizowane.",
    "requestPending": "Żądanie w toku. Oczekiwanie na potwierdzenie z bramy. Sprawdź ponownie później.",
    "editRequest": "Masz aktywne żądanie. Poczekaj na potwierdzenie lub anuluj to żądanie, aby kontynuować wybieranie.",
    "editRequestVls": "Masz aktywne żądanie w Ustawieniach zaawansowanych akumulatora. Aby kontynuować z wyborem, musisz poczekać na potwierdzenie lub anulować zgłoszenie.",
    "cancelRequest": "Żądanie zostało anulowane.",
    "timeoutRequest": "Upłynął limit czasu żądania. Spróbuj ponownie później",
    "updatedSuccesfully": "Pomyślnie zaktualizowano",
    "pendingRequestText": "oczekujące żądanie",
    "cancelRequestText": "Anuluj żądanie",
    "pendingText": "Oczekujące",
    "processingText": "Przetwarzanie",
    "battery_reserve": "zmagazynowanej energii będzie przeznaczone na potrzeby zasilania rezerwowego",
    "cancelFailed": "Nie udało się anulować zadania.",
    "noPendingTask": "System nie ma żadnych oczekujących zadań do anulowania",
    "noEncharges": "System nie jest wyposażony w akumulatory",
    "severeWeatherText": "Zabezpieczenie przeciwburzowe",
    "disabled": "Wyłączono",
    "enabled": "Włączono",
    "weatherWatchDescription": "Przestawia profil akumulatora w tryb pełnych zasobów rezerwowych, gdy dla Twojej lokalizacji zostanie wystosowane ostrzeżenie o trudnych warunkach atmosferycznych.",
    "disabledModeInfo": "Po włączeniu tej funkcji aplikacja Enphase komunikuje się z serwisem {%s} w celu wykrywania ostrzeżeń o gwałtownych zjawiskach pogodowych. Gdy to konieczne, przestawia akumulator w tryb pełnego podtrzymania, aby zapewnić podtrzymanie zasilania podczas zdarzenia pogodowego. Gdy zdarzenie dobiegnie końca, profil akumulatora zostanie zmieniony na poprzedni.",
    "enabledModeInfo": "Aplikacja Enphase będzie komunikować się z serwisem {%s}, aby wykrywać ostrzeżenia o gwałtownych zjawiskach pogodowych. W razie potrzeby przestawi akumulator w tryb pełnego podtrzymania zasilania. Po zdarzeniu profil akumulatora zostanie zmieniony na poprzedni.",
    "activeModeInfo": "Aplikacja Enphase wykryła w serwisie {%s} ostrzeżenie o gwałtownym zjawisku pogodowym. Profil akumulatora został zmieniony na tryb pełnego podtrzymania zasilania. Gdy zdarzenie dobiegnie końca, profil akumulatora zostanie zmieniony na poprzedni.",
    "stormGuardModeInfo": "W stanie %{status} funkcja zabezpieczenia przeciwburzowego monitoruje ostrzeżenia o trudnych warunkach atmosferycznych wydawane przez %{nws}. Przestawia profil baterii w tryb 'Full Backup', gdy dla Twojej lokalizacji wystosowane zostanie ostrzeżenie. Pozwala to zarezerwować całą energię zgromadzoną w akumulatorze na wypadek ewentualnej przerwy w dostawie prądu.%{nl}Gdy wystosowane zostanie ostrzeżenia dla Twojej lokalizacji, przy profilu %{profile} wyświetla się status %{stormAlertOn} na stronie statusu i stronie podglądu status na żywo.%{nl}Po wyłączeniu ostrzeżenia profil akumulatora jest przestawiany do poprzednich ustawień.",
    "editActiveWeatherAlert": "Zabezpieczenie przeciwburzowe jest aktywne. Poczekaj na zakończenie zdarzenia (zalecane) lub wyłącz funkcję zabezpieczenia przeciwburzowego, aby kontynuować wybieranie.",
    "enabledToActiveAlert": "Aplikacja Enphase wykryła w krajowym serwisie pogodowym ostrzeżenie o gwałtownym zjawisku pogodowym. Profil akumulatora został zmieniony na tryb pełnego podtrzymania zasilania. Gdy zdarzenie dobiegnie końca, profil akumulatora zostanie zmieniony na poprzedni.",
    "activeToEnabledAlert": "Trudne warunki pogodowe przeminęły, więc profil akumulatora powróci do poprzedniego ustawienia.",
    "okayText": "Rozumiem!",
    "disclaimerText": "Funkcja zabezpieczenia przeciwburzowego wykorzystuje informacje pozyskiwane od amerykańskich agencji National Oceanic and Atmospheric Administration lub National Weather Service, takie jak (między innymi) ostrzeżenia o trudnych warunkach atmosferycznych. Są to informacje dostępne publicznie, które nie podlegają ochronie praw autorskich. Firma Enphase nie rości sobie prawa do posiadania ani kontrolowania takich informacji. Jednoznacznie zgadzasz się korzystać z tej funkcji na własne ryzyko. Oprócz tego ponosisz pełne ryzyko związane z włączeniem i wykorzystywaniem tej funkcji. Firma Enphase przedstawia informacje w ramach funkcji zabezpieczenia burzowego w stanie takim, jakie są, i wyłącza wszelkie gwarancje wyraźne i dorozumiane, w tym między innymi wszelkie dorozumiane gwarancje przydatności handlowej i do określonego celu. W żadnym wypadku firma Enphase nie będzie ponosić odpowiedzialności wobec Ciebie ani osób trzecich za bezpośrednie, pośrednie, przypadkowe, wynikowe ani specjalne szkody tudzież utratę profilu w wyniku wykorzystania lub niewłaściwego wykorzystania danych.",
    "disclaimer": "Zastrzeżenie odpowiedzialności",
    "agreeText": "Zgadzam się i kontynuuję",
    "disagreeText": "Nie zgadzam się",
    "nationalWeather": "National Weather Service (NWS)",
    "dataNotAvailable": "Nd",
    "errorTitle": "Błąd",
    "errorCode": "Kod błędu",
    "thresholdError": "Błąd raportowania",
    "PopupError": "Nr seryjny akumulatora",
    "thresholdPopupError": "Nie przesyłał danych podczas ostatniego cyklu sprawozdawczego? Dlatego łączny % zmagazynowanej energii nie uwzględnia % zmagazynowanej energii przez ten akumulator. Akumulator powinien zacząć przesyłać dane w następnym cyklu sprawozdawczym. Jeśli problem nie ustąpi, skontaktuj się z obsługą klienta.",
    "errorPopup1": "ma problem (opis błędu:",
    "errorPopup2": ", Kod błędu:",
    "errorPopup3": "). Ten błąd sprawia, że zgłaszany % energii zmagazynowanej przez ten akumulator jest niewiarygodny. Dlatego łączny % zmagazynowanej energii wskazany powyżej nie uwzględnia % zmagazynowanej energii przez ten akumulator. Jeśli problem nie ustąpi, skontaktuj się z obsługą klienta.",
    "contactSupport": "Skontaktuj się z obsługą klienta",
    "errorSubmitButton": "Rozumiem",
    "microinvertorError": "Mikroinwerter akumulatora jest nieaktywny",
    "microinvertorsError": "Mikroinwertery akumulatora są nieaktywne",
    "touAlert": "Tryb oszczędzania działa tylko wówczas, gdy stawka za pobór energii elektrycznej różni się w zależności od czasu. Aby włączyć ten tryb, zaktualizuj stawkę za pobór energii elektrycznej.",
    "touAlert2": "Aby włączyć tryb oszczędnościowy, ustaw stawkę importu energii elektrycznej jako ToU oraz plan stawek eksportu jako NEM.%{nl}Tryb oszczędnościowy działa tylko wtedy, gdy użytkownik ma licznik energii netto (NEM), a stawka za energię elektryczną zmienia się w zależności od czasu użytkowania (ToU).",
    "touAlert3": "Aby włączyć tryb oszczędnościowy, ustaw stawkę importu energii elektrycznej jako ToU.",
    "touAlert4": "Aby włączyć tryb oszczędnościowy, ustaw plan eksportu energii elektrycznej.",
    "updateElectricityRate": "Zaktualizuj stawkę za energię elektryczną",
    "batteryChangeAlert": "Zmieniono profil akumulatora na tryb wykorzystania energii na potrzeby własne, ponieważ tryb oszczędzania działa tylko wówczas, gdy stawka za pobór energii elektrycznej różni się w zależności od czasu.",
    "batteryChangeAlert2": "Profil akumulatora zmienił się na tryb samokonsumpcji, ponieważ tryb oszczędnościowy działa tylko wtedy, gdy użytkownik ma licznik energii netto (NEM), a stawka za energię elektryczną zmienia się w zależności od czasu użytkowania (ToU).",
    "viewDetails": "Wyświetl szczegóły",
    "ok": "Ok",
    "systemRequest": "Nie można anulować żądań generowanych przez system.",
    "featureDetailsButton": "Szczegóły funkcji zabezpieczenia przeciwburzowego",
    "stormGuardEnablePopUp": "Włączenie aplikacji Storm Guard umożliwia zarezerwowanie pełnej pojemności akumulatora do użytku podczas możliwej awarii zasilania poprzez nadpisanie profilu akumulatora „Pełne naładowanie” w przypadku alertów o trudnych warunkach pogodowych.",
    "stormGuardDisablePopUp": "Wyłączenie aplikacji Storm Guard jest niezalecane. W przypadku alertów o trudnych warunkach pogodowych pomaga chronić przed skutkami poważnych awarii sieci związanych z pogodą.",
    "batterySmartProfile": {
      "title": "Wybór inteligentnego profilu akumulatorów",
      "description": "Dowiedz się, jak wybrać odpowiedni profil swojego systemu akumulatorów",
      "viewDetails": "Wyświetl szczegóły"
    },
    "reserveDisclaimer": "Nie można ustawić rezerwy akumulatora na poziomie poniżej  %{minSoc}%. W akumulatorze przechowywane jest co najmniej  %{minSoc}% energii w celu zasilenia najważniejszych urządzeń domowych podczas przerwy w dostawie prądu.",
    "eIpopDesc": "%{enabled}: akumulator będzie rozładowywany, aby zwiększyć oszczędności w godzinach szczytu, gdy stawki za energię elektryczną są wysokie. Następnie priorytet będzie mieć niezależność energetyczna. Do czasu osiągnięcia poziomu rezerwy akumulatora zwiększy się Twoja samowystarczalność energetyczna. Akumulator będzie ładowany z paneli słonecznych rano, aby przygotować instalację na kolejny okres szczytowy. %{nl}%{disabled}: akumulator będzie rozładowywany tylko w godzinach szczytu, gdy stawki za energię elektryczną są wysokie. W pozostałym okresie akumulator będzie nieobciążony lub ładowany rano z paneli słonecznych, aby przygotować instalację na kolejny okres szczytowy.",
    "errActiveCostSave": "Aby skorzystać z tej funkcji, aktywuj tryb oszczędzania",
    "eiDescreption": "Niezależność energetyczna po godzinach szczytu",
    "advSetting": {
      "cfg": {
        "title": "Ładuj akumulator z sieci",
        "descrDisable": "Akumulator jest ładowany przez instalację fotowoltaiczną.",
        "descrEnabled": "Akumulator jest ładowany przez instalację fotowoltaiczną. Może być również ładowany z sieci, gdy akumulator jest w trybie pełnych zasobów rezerwowych lub gdy poziom naładowania akumulatora jest poniżej pojemności rezerwowej w trybach oszczędności lub wykorzystania na potrzeby własne.",
        "descrEnabledFR": "Akumulator będzie ładowany z sieci w zaplanowanym przedziale czasu. W tym okresie nie będzie się rozładowywać.",
        "popUpDescrFR": "%{enabled}: Akumulator będzie ładowany z sieci w zaplanowanym przedziale czasu. W tym okresie nie będzie się rozładowywać. %{nl}%{disabled}: Akumulator jest ładowany przez instalację fotowoltaiczną.",
        "popUpDescr": "%{enabled}: Akumulator jest ładowany przez instalację fotowoltaiczną. Może być również ładowany z sieci, gdy akumulator jest w trybie pełnych zasobów rezerwowych lub gdy poziom naładowania akumulatora jest poniżej pojemności rezerwowej w trybach oszczędności lub wykorzystania na potrzeby własne.%{nl}%{disabled}: Akumulator jest ładowany przez instalację fotowoltaiczną.",
        "disclaimer": "Korzystanie z nieodnawialnego źródła energii do ładowania systemu magazynowania energii firmy Enphase może wpłynąć na możliwość ubiegania się o ulgę inwestycyjną. Aby uzyskać więcej informacji, skonsultuj się ze swoim doradcą podatkowym.",
        "dlgTitle": "Ładowanie z sieci?",
        "dlgInfo": "Po włączeniu tej funkcji akumulator będzie ładowany z sieci w zaplanowanym przedziale czasu. W tym okresie nie będzie się rozładowywać. Przed włączeniem tej opcji należy sprawdzić przepisy dostawcy energii.",
        "selfDeclrFR": "Rozumiem, że ładowanie z sieci może być niezgodne z regulaminem zakładu energetycznego.",
        "selectSchedule": "SWybierz harmonogram ładowania akumulatora z sieci.",
        "titleFR": "Zaplanuj ładowanie z sieci",
        "saveSch": "Zapisz harmonogram",
        "chargeSch": "Harmonogram ładowania",
        "selfDeclr": "Rozumiem, że może to mieć wpływ na możliwość ubiegania się o ulgę inwestycyjną.​",
        "disclaimer_itk": "Using a non-renewable energy source to change Enphase Storage system may affect eligibility to claim the ITC. Please consult with homeowner for his/her approval.",
        "selfDeclr_itk": "Homeowner understands that eligibility to claim Investment Tax Credit may be affected.",
        "activeStormAlert": "Alert burzowy jest włączony w Twoim systemie. Poczekaj na zakończenie alertu, aby zaktualizować to ustawienie."
      }
    },
    "exM": {
      "title": "Tryb eksperta",
      "subTitle1": "Zaplanuj profile akumulatorów",
      "subTitle2": "Zaplanowane profile akumulatorów",
      "schedule": "Zaplanuj",
      "tariffNotSetDlgtitle": "Nie ustawiono stawki za energię elektryczną",
      "tariffNotSetDlgContent": "Ustaw stawkę za energię elektryczną, aby włączyć tryb oszczędnościowy.%{nl}Aplikacja Enphase potrzebuje wysokości stawki, aby określić najlepszy harmonogram dla akumulatora.",
      "setRate": "Ustaw stawkę",
      "tariffUpdateDlgtitle": "Zaktualizuj stawkę za energię elektryczną",
      "tariffUpdateDlgContent": "Tryb oszczędzania działa tylko wówczas, gdy korzystasz z opomiarowania netto (NEM), a stawka za energię elektryczną różni się z uwagi na taryfę wielostrefową (ToU)",
      "updateRate": "Zaktualizuj stawkę",
      "setNemDlgTitle": "Nie ustawiono stawki za eksport energii elektrycznej",
      "setNemDlgContent": "Aby włączyć ten tryb, ustaw stawkę za pobór energii elektrycznego jako opomiarowanie netto (NEM)",
      "setNemCta": "Ustaw jako opomiarowanie netto (NEM)",
      "preview": "Podgląd",
      "pViewPop": {
        "l1": "Wykres prezentuje zaplanowane profile akumulatorów na okres 24 godzin.",
        "l2": "Rezerwa akumulatora ma zastosowanie wyłącznie do trybów wykorzystania energii na potrzeby własne i oszczędzania. W trybie pełnych zasobów rezerwowych rezerwa akumulatora będzie wynosić 100%.",
        "l3": "Zmaksymalizuj niezależność energetyczną​",
        "l4": "Maksymalizuje oszczędności na podstawie stawek za energię elektryczną​",
        "l5": "Zachowuje 100% energii zgromadzonej w akumulatorach na potrzeby zasilania rezerwowego",
        "batteryProfiles": "Profile akumulatorów"
      },
      "batReserveDisclaimer": "Rezerwa akumulatora ma zastosowanie wyłącznie do trybów wykorzystania energii na potrzeby własne i oszczędzania. W trybie pełnych zasobów rezerwowych rezerwa akumulatora będzie wynosić 100%."
    },
    "prfAssist": {
      "t0": "Już w polecanym profilu",
      "t1": "Rekomendujemy",
      "t2": "Tryb oszczędzania z włączonymi opcjami niskiego poziomu rezerwy akumulatora i niezależności energetycznej.",
      "t3": "Tryb oszczędzania z wyłączonymi opcjami niskiego poziomu rezerwy akumulatora i niezależności energetycznej.",
      "t4": "Tryb zużycia na potrzeby własne z niską rezerwą akumulatora.",
      "t5": "Tryb zużycia na potrzeby własne ze średnią rezerwą akumulatora.",
      "t6": "Tryb pełnych zasobów rezerwowych.",
      "t7": "Tryb oszczędzania z wyłączonymi opcjami wysokiego poziomu rezerwy akumulatora i niezależności energetycznej.",
      "t8": "Tryb zużycia na potrzeby własne z wysoką rezerwą akumulatora.",
      "batResText": "Rezerwa akumulatora między",
      "learnHowEmea": "Dowiedz się więcej o profilu baterii",
      "learnHow": "Dowiedz się, jak działają profile akumulatora",
      "editPref": "Edytuj preferencje",
      "c1": "Oszczędność pieniędzy",
      "c1Sub": "Maksymalizacja oszczędności na miesięcznych rachunkach",
      "c2": "Niezależność energetyczna",
      "c2Sub": "Zasilanie domu i ekologia",
      "c3": "Zasilanie awaryjne",
      "c3Sub": "Dostęp do zasilania awaryjnego podczas przerw w dostawie",
      "p1": "Najwyższy priorytet",
      "p2": "Niższy priorytet",
      "optional": "Opcjonalnie",
      "ques": "Jakie są Twoje oczekiwania wobec systemu Enphase?",
      "priority": "Przeciągnij i upuść cele w kolejności od najważniejszych do najmniej ważnych.",
      "ftrpTutorialText": "Wybierz i przeciągnij karty w górę lub w dół, aby uporządkować je zgodnie z priorytetami. Pierwsza karta od góry oznacza wyższy priorytet.",
      "updateBatteryProfile": "Zaktualizuj profil akumulatora",
      "activatedSavingsMode": "Twój akumulator jest obecnie w trybie oszczędzania z rezerwą wynoszącą %{soc}%, a niezależność energetyczna po godzinach szczytu wynosi %{eiStatus}.",
      "activatedSelfConsumptionMode": "Twój akumulator jest obecnie w trybie wykorzystania energii na potrzeby własne z rezerwą wynoszącą %{soc}%.",
      "activatedFullBackupMode": "Twój aktualny profil akumulatora to Tryb pełnych zasobów rezerwowych.",
      "activatedSavingsModeWithoutSoc": "Akumulator pracuje obecnie w trybie oszczędzania, a niezależność energetyczna poza godzinami szczytu wynosi %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Akumulator pracuje obecnie w trybie samokonsumpcji.",
      "activateProfile": "Czy chcesz aktywować zalecany profil?"
    }
  },
  "envoy": {
    "all": "Wszystkie bramki",
    "pvAll": "Caly",
    "dropDwnHelper": "Pokaż dane z",
    "envSN": "Gateway SN:",
    "reconnect": "Ponownie połącz się z bramką.",
    "extraContent": "W międzyczasie, jeśli znajdujesz się w pobliżu swojego systemu, możesz połączyć się lokalnie z bramką, aby sprawdzić jej bieżący stan.",
    "btnText": "Dowiedz się, jak nawiązać połączenie z siecią bramki",
    "getHelp": "Połącz bramę z domową siecią Wi-Fi",
    "envoyConfirmation": "Połącz się z bramą w trybie AP, aby przejść dalej.",
    "title": "Zauważyliśmy, że używasz Envoy-S lub IQ Gateway i korzystasz z sieci Wi-Fi.",
    "steps": "Wykonaj przedstawione kroki, aby podłączyć bramę do sieci Wi-Fi",
    "steps_ap": "Wykonaj poniższe czynności, aby połączyć się z siecią bramki",
    "ap_button": "Wciśnij przycisk trybu AP",
    "ap_modeDescription": "Naciśnij i zwolnij (nie przytrzymuj) przycisk menu Brama poniżej ikony telefonu. Spowoduje to włączenie trybu AP w bramie. Tworzy on sieć bezprzewodową, do której możesz dołączyć za pomocą telefonu.",
    "disable_data": "Wyłącz dane mobilne",
    "disable_dataDescription": "Wyłącz dane mobilne (dane komórkowe) w ustawieniach urządzenia mobilnego. Przejdź do Ustawienia > Dane mobilne i wyłącz je.",
    "envoy_network": "Dołącz do sieci bramki komunikacyjnej.",
    "envoy_description": "Połącz się z siecią bramki komunikacyjnej wykorzystując ustawienia Wi-Fi w Twoim telefonie. Envoy_XXXXXX to nazwa „mini-sieci”, do której dołączysz, gdzie „XXXXXX” to 6 ostatnich cyfr numeru seryjnego Twojej bramki komunikacyjnej.",
    "home_wifi": "Połącz bramkę komunikacyjną z siecią Wi-Fi.",
    "wifi_description": "Kliknij przycisk konfiguracji domowej sieci Wi-Fi, wybierz sieć domową i wprowadź hasło Wi-Fi.",
    "configure_wifi": "Skonfiguruj domową sieć Wi-Fi",
    "cancel": "Anuluj",
    "stickyNotification": "Nie klikaj przycisku Wstecz ani nie zamykaj aplikacji poprzez szybkie przesunięcie podczas próby ponownego nawiązania połączenia z bramą (możesz ją natomiast zminimalizować).",
    "enter_password": "Wprowadź hasło do",
    "password": "Hasło",
    "incorrect_password": "Nieprawidłowe hasło",
    "wifi_failureMsg": "Brama nie mogła połączyć się z siecią Wi-Fi",
    "wifi_successMsg": "Pomyślnie połączono bramę z siecią Wi-Fi",
    "envoyConnectToCellular": "Możesz teraz odłączyć swoje urządzenie mobilne od sieci bramy i podłączyć je do sieci Wi-Fi / włączyć komórkową transmisję danych.",
    "envoyToastMessage": "Pomyślnie podłączono bramę. Aktualizacja stanu bramy może potrwać do 30 minut.",
    "wifi_congratsMsg": "Gratulujemy! Znów jesteś online. Teraz możesz ponownie połączyć telefon komórkowy z domową siecią Wi-Fi.",
    "tryagain": "spróbuj ponownie",
    "okay": "Rozumiem",
    "failedToFetchWiFiNetworks": "Wystąpił problem z pobraniem listy sieci Wi-Fi. Spróbuj ponownie za jakiś czas.",
    "noWifiNetworkFound": "Nie znaleziono sieci Wi-Fi. Zrestartuj router Wi-Fi i spróbuj ponownie.",
    "option2": "Jeśli powyższe kroki nie zadziałały, dowiedz się jak możesz to zrobić ręcznie.",
    "learnhow": "„Dowiedz się więcej”",
    "ensureOn": "Upewnij się, że bramka komunikacyjna jest włączona.",
    "connectToPower": "Sprawdź, czy bramka komunikacyjna jest podłączona do zasilania."
  },
  "whatsnews": {
    "monitorTitle": "Monitor",
    "monitorContent": "Sprawdź stan swojego systemu w mgnieniu oka dzięki kluczowym wskaźnikom znajdującym się na jednym ekranie",
    "trackTitle": "Śledź",
    "trackContent": "Śledź trendy produkcji i zużycia energii oraz poruszaj się między nimi w widoku dziennym, miesięcznym, rocznym lub w całym okresie użytkowania",
    "reportTitle": "Report",
    "reportContent": "Generuj raporty o produkcji i zużyciu energii z aplikacji w wybranym przez Ciebie okresie dziennym, tygodniowym, miesięcznym lub niestandardowym"
  },
  "theme": {
    "instructions": "Aktualny schemat kolorów",
    "night": "noc",
    "day": "Dzień"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Obciążenia",
    "generator": "Generator",
    "noDeviceFound": "Nie znaleziono urządzenia",
    "searchMicroinverters": "Szukaj numerów seryjnych mikroinwerterów",
    "serialNumber": "Nr seryjny",
    "configure": "Skonfiguruj",
    "connect": "Połącz",
    "envoy": "Brama",
    "microinverters": "Mikroinwertery",
    "microinverter": "Mikroinwerter",
    "stringInverters": "Falownik łańcuchowy",
    "storage": "Akumulator",
    "enpower": "Sterownik systemu",
    "skuNumber": "SKU",
    "firmwareVersion": "Oprogramowanie sprzętowe",
    "cycleCount": "Liczba cykli",
    "cycleCountInfo": "Liczba cykli akumulatora to łączna liczba kompletnych cykli ładowania i rozładowania. Oblicza się ją przez podzielenie całkowitej skumulowanej energii przez dostępną pojemność akumulatora. Wyświetlona tutaj liczba oznacza ukończony cykl.",
    "status": "Status",
    "array": "Układ",
    "help": "Pomoc",
    "not_reporting": "Nie zgłasza się",
    "not_reporting_lowercase": "Nie zgłasza się",
    "normal": "Normalny",
    "home": "Strona główna",
    "no_microinverters": "Nie znaleziono mikroinwertera",
    "no_storage": "Nie znaleziono akumulatora",
    "no_envoy": "Nie znaleziono bramy",
    "no_enpower": "Nie znaleziono żadnego sterownika systemu",
    "wirelessRangeExtender": "Wzmacniacz sygnału bezprzewodowego",
    "no_wirelessRangeExtender": "Nie znaleziono wzmacniacza sygnału bezprzewodowego",
    "lastReported": "Ostatni raport",
    "manufacturer": "Nazwa producenta",
    "startType": "Typ uruchamiania",
    "fuelType": "Typ paliwa",
    "modelNumber": "Numer modelu",
    "onOffCycles": "Suma cykli Włączony/Wyłączony",
    "maintainenceInfo": "Informacje dotyczące konserwacji",
    "maintainenceSub": "Zaktualizuj te dane, aby otrzymywać powiadomienia o konserwacji generatora i zapotrzebowaniu na paliwo.",
    "lastMaintainenceDate": "Data ostatniej konserwacji",
    "lastRefuellingDate": "Data ostatniego dodawania paliwa",
    "lastRefuellingTime": "Godzina ostatniego dodawania paliwa",
    "lastMaintainenceTime": "Godzina ostatniej konserwacji",
    "litresOfFuel": "Litry wlanego paliwa",
    "additionalInfo": "Aby uzyskać dodatkowe informacje,",
    "statistics": "Twoje statystyki od ostatniej konserwacji:",
    "timeElapsed": "Upłynęło czasu:",
    "cycles": "Cykle wł./wył.:",
    "runningHours": "Czas pracy:",
    "Days": "dni",
    "update": "Zaktualizuj",
    "clickHere": "kliknij tutaj",
    "savedSuccessfully": "Ustawienia zostały pomyślnie zapisane.",
    "loads": {
      "status": "Status",
      "smartControl": "Inteligentne sterowanie",
      "auxillaryContact": "Styk pomocniczy"
    },
    "devicegenerator": {
      "on": "Wł",
      "off": "Wył"
    },
    "connected": {
      "true": "Połączono z chmurą Enphase",
      "false": "Rozłączono z chmurą Enphase"
    },
    "envoyConnected": {
      "wait": "Wyszukiwanie bramy…",
      "true": "Pomyślnie znaleziono bramę.",
      "false": "Nie wykryto bramy."
    },
    "stepOne": "Połącz się bezpośrednio z bramą. Aby to zrobić, naciśnij przycisk połączenia na bramie.",
    "stepTwo": "Następnie przejdź do ustawień sieci Wi-Fi i połącz się z siecią bramy:",
    "stepThree": "Po nawiązaniu połączenia wróć do tego ekranu. Nastąpi tymczasowe odłączenie od internetu.",
    "connectLocally": "Połącz lokalnie",
    "connectEnvoy": "Połącz się z bramą za pomocą",
    "connectEnvoyUser": "Nazwa użytkownika",
    "connectEnvoyPassword": "Password",
    "notAllowAPMode": "Brama nie obsługuje łączności lokalnej.",
    "localEnvoyConnected": {
      "true": "Pomyślnie znaleziono bramę",
      "false": "Nie znaleziono bramy w sieci lokalnej",
      "wait": "Zaczekaj..."
    },
    "envoyPwd": {
      "urenvPwd": "Hasło do Twojej bramy",
      "retrivePwd": "Aby odzyskać hasło do bramy:",
      "infoTitle": "Hasło do bramy",
      "infoDescription": "Będziesz potrzebować tego hasła, aby ponownie połączyć bramę z siecią Wi-Fi. Dzieje się tak zwykle, gdy nastąpiła zmiana hasła sieci Wi-Fi lub dostawcy usług.",
      "infoLearnMore": "Kliknij tutaj, aby dowiedzieć się więcej"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Włącz Bluetooth w telefonie, aby połączyć się z bramką IQ Gateway",
      "tryApMode": "Spróbuj w trybie AP",
      "gatewayNotFound": "Nie można wykryć bramki IQ Gateway. Upewnij się, że bramka IQ Gateway znajduje się w pobliżu i jest włączona.",
      "bleNotSupported": "Komunikacja Bluetooth nie jest obsługiwana",
      "bleNotSupportedDesc": "Komunikacja Bluetooth nie jest obsługiwana przez urządzenie. Upewnij się, że urządzenie obsługuje komunikację Bluetooth i ustalanie lokalizacji.",
      "bleConnected": "Podłączono przez Bluetooth",
      "scanningGateway": "Skanowanie w poszukiwaniu bramki IQ Gateway",
      "fewMints": "Może to zająć kilka minut",
      "noWifi": "Nie znaleziono urządzeń Wi-Fi",
      "password": "Hasło",
      "gatewayConnected": "Bramka IQ Gateway została pomyślnie połączona z siecią Wi-Fi.",
      "okGotIt": "OK, rozumiem",
      "noGateway": "Nie znaleziono bramki IQ Gateway",
      "gatewayNearByWarning": "Upewnij się, że bramka znajduje się w pobliżu i jest włączona.",
      "noNetwork": "Brak sieci",
      "wifiRouterWarning": "Nie wyłączaj routera Wi-Fi i upewnij się, że bramka IQ Gateway jest w zasięgu sieci Wi-Fi.",
      "connectionError": "Błąd połączenia",
      "turnOn": "Włącz",
      "failedWifiConnect_1": "Nie udało się połączyć z siecią Wi-Fi. ",
      "failedWifiConnect_2": "Kontakt z pomocą techniczną",
      "failedWifiConnect_3": " aby uzyskać pomoc.",
      "failedIQConnect_1": "Nie udało się połączyć z bramką IQ Gateway. ",
      "failedIQConnect_2": "Kontakt z pomocą techniczną",
      "failedIQConnect_3": " aby uzyskać pomoc.",
      "bleDevices": "Urządzenia Bluetooth",
      "wifiNetworks": "Sieci Wi-Fi",
      "connectBle": "Połącz z Bluetooth",
      "gatewayToWifi": "Łączenie bramki IQ z siecią Wi-Fi...",
      "bleStatus": "Sprawdzanie stanu Bluetooth...",
      "searchingWifi": "Wyszukiwanie sieci Wi-Fi...",
      "connectingBle": "Łączenie z Bluetooth",
      "turnOnBle": "Włącz Bluetooth",
      "tryAgain": "spróbuj ponownie",
      "wifiSsIdConfigFailedDesc": "Wystąpił nieznany błąd podczas łączenia się z siecią Wi-Fi. Spróbuj później lub połącz się z inną siecią.",
      "wifiCommunicationError": "Błąd komunikacji Wi-Fi",
      "wifiCommunicationErrorDesc": "Nie można nawiązać połączenia z modułem IQ Gateway BLE. Proszę spróbuj później.",
      "networkNotFound": "Nie znaleziono sieci",
      "networkNotFoundDesc": "Nie znaleziono sieci, z którą próbujesz się połączyć. Upewnij się, że router Wi-Fi jest włączony lub wypróbuj inną sieć."
    }
  },
  "notification": {
    "offline": "Offline",
    "apmode": "Tryb AP"
  },
  "siteempty": {
    "nosystemassociated": "Twoje konto nie jest obecnie powiązane z żadnymi systemami.",
    "systemowner": "Czy jesteś właścicielem systemu Enphase?",
    "contactyourinstaller": "Skontaktuj się z instalatorem, aby zweryfikować konto powiązane z systemem.",
    "interestedonsystem": "Czy interesuje Cię system Enphase?",
    "initiatetransferofwarranty": "Initiate transfer of warranty in case you have bought a property with an Enphase system.",
    "applytransferownership": "Złóż wniosek o przeniesienie własności tutaj.",
    "ownershiptransfer": "Przeniesienie własności",
    "visita": "Odwiedź",
    "publicsystempage": "stronę systemu publicznego,",
    "monitoringexperience": "aby zobaczyć, jak wygląda monitorowanie systemu Enphase."
  },
  "recaptcha": {
    "verification_failed": "Weryfikacja reCAPTCHA nie powiodła się. Spróbuj ponownie.",
    "recaptcha_unreachable": "Ups, nie udało się zweryfikować Twojej odpowiedzi reCAPTCHA. Spróbuj ponownie."
  },
  "mobile_app_rating": {
    "enjoying_app": "Czy aplikacja Enphase przypadła Ci do gustu?",
    "rate_on_play_store": "Oceń swoje doświadczenia",
    "rate_on_play_store2": "W sklepie Play",
    "rate_us": "Oceń nas teraz",
    "may_be_next": "Może następnym razem"
  },
  "consumptionMtr": {
    "btnText": "Dodaj miernik zużycia",
    "infoText": "Miernik zużycia pomaga śledzić ogólne zużycie energii"
  },
  "replacement": {
    "microinverter_not_reporting": "Mikroinwertery nie zgłaszają.",
    "batteryWarning": 'Może się to zdarzyć, gdy jakość komunikacji bezprzewodowej między bramką a akumulatorem jest słaba. Może to być chwilowa usterka i powinna zostać wkrótce usunięta. Jeśli problem będzie się powtarzać, skontaktuj się z opiekunem, aby uzyskać pomoc.',
    "controllerWarning": 'Może się to zdarzyć, gdy jakość komunikacji bezprzewodowej między bramką a sterownikiem System Controller jest słaba. Może to być chwilowa usterka i powinna zostać wkrótce usunięta. Jeśli problem będzie się powtarzać, skontaktuj się z opiekunem, aby uzyskać pomoc.',
    "batteryError": 'Akumulator nie przesyła danych.',
    "controllerError": 'Sterownik System Controller nie przesyła danych.',
    "contactMaintainer": 'Skontaktuj się z serwisantem, aby uzyskać pomoc.',
    "systemWarning": 'ostrzeżenie systemowe',
    "array_details": "Szczegóły układu",
    "replacement_warranty1": "",
    "replacement_warranty": "Mikroinwertery są objęte gwarancją i kwalifikują się do wymiany.",
    "shipping_address": "Adres wysyłki",
    "site_address": "Adres lokalizacji",
    "change": "ZMIANA",
    "select_microinverters": "WYBIERZ MIKROINWERTERY",
    "serial_number": "Znajdź numer seryjny",
    "status": "Status",
    "normal": "Normalne",
    "not_reporting": "Nie zgłasza się",
    "submit_request": "Prześlij żądanie",
    "dear": "Drogi/-a",
    "replacement_message1": "Może być konieczne skontaktowanie się z instalatorem",
    "replacement_message2": "wykonaj wymianę po otrzymaniu urządzenia zastępczego. Instalator może naliczyć opłaty za wymianę.",
    "request_submitted": "Pomyślnie przesłano żądanie zwrotu.",
    "response_message": "Skorzystaj z identyfikatora żądania, aby śledzić stan wymiany podczas kontaktowania się z pomocą techniczną.",
    "request_id": "Identyfikator żądania",
    "ok": "Rozumiem",
    "replacement_delivery": "Urządzenie zastępcze zostanie dostarczone do Twojej lokalizacji",
    "replacement_delivery_installer": "Urządzenie zastępcze zostanie dostarczone do lokalnego instalatora",
    "installer_address": "ADRES INSTALATORA",
    "understand": "Rozumiem",
    "continue_button": "Kontynuuj",
    "error_message": "Nie udało się wygenerować identyfikatora żądania.",
    "failed_to_fetch": "Nie udało się pobrać szczegółów mikroinwertera. Spróbuj ponownie",
    "change_address": "Zmień adres wysyłki"
  },
  "tariff": {
    "tariff": "Taryfa",
    "tariffNotAdded": "Nie dodano taryfy",
    "tariffNotSet": "Nie ustawiono taryfy",
    "tariffType": "Rodzaj taryfy",
    "buying": "Kupno",
    "selling": "Sprzedaż",
    "flat": "Stawka stała",
    "tou": "Czas użytkowania",
    "tiered": "Stawka zmienna",
    "copyFromBuyingTariff": "Skopiuj z taryfy kupna",
    "copyFromSellingTariff": "Skopiuj z taryfy sprzedaży",
    "dayBasedTariff": "Czy Twoja taryfa zmienia się w ciągu dnia?",
    "unitsBasedTariff": "Czy Twoja taryfa zmienia się w zależności od zużytych jednostek?",
    "seasonalTariff": "Czy Twoja taryfa zmienia się sezonowo?",
    "weekendTariff": "Czy Twoja taryfa zmienia się w weekendy?",
    "baseRateTariff": "Jaka jest stawka bazowa?",
    "flatLabel": "Koszt energii jest stały w ciągu dnia.",
    "touLabel": "Koszt energii zmienia się w godzinach szczytu.",
    "tieredLabel": "Koszt energii zmienia się wraz ze wzrostem zużycia jednostkowego.",
    "rate": "Stawka",
    "addSeason": "Dodaj sezon",
    "season": "Sezon",
    "next": "Następne",
    "noSeasonWeekend": "Taryfa nie zmienia się sezonowo ani w weekendy.",
    "weekendOnly": "Taryfa zmienia się tylko w weekendy.",
    "seasonAndWeekend": "Taryfa zmienia się sezonowo i w weekendy.",
    "seasonOnly": "Taryfa zmienia się tylko w sezonowo.",
    "infoText": "Informacje",
    "baseRate": "Stawka bazowa",
    "remove": "Usuń",
    "from": "Od",
    "to": "do",
    "addPeak": "Dodaj szczyt",
    "tariffDetails": "Szczegóły taryfy",
    "off-peak": "Poza szczytem",
    "above": "Powyżej",
    "between": "Pomiędzy",
    "and": "oraz",
    "weekdays": "dni tygodnia",
    "weekend": "weekend",
    "winter": "Zima",
    "summer": "Lato",
    "fall": "Jesień",
    "spring": "Wiosna",
    "confirmAndSave": "Potwierdź i zapisz",
    "buyingTariff": "Taryfa kupna",
    "sellingTariff": "Taryfa sprzedaży",
    "edit": "Edytuj",
    "offPeak": "Poza szczytem",
    "peak": "Szczyt",
    "period": "Szczyt",
    "addTier": "Dodaj poziom",
    "tier": "Poziom",
    "yesLabel": "Tak",
    "noLabel": "Nie",
    "manualConfiguration": "Konfiguracja ręczna",
    "added": "dodano",
    "modified": "zmodyfikowano",
    "successfully": "pomyślnie",
    "alreadySelected": "już wybrano",
    "alreadyAdded": "już dodano",
    "buyingTariffAdded": "Pomyślnie dodano taryfę kupna",
    "sellingTariffAdded": "Pomyślnie dodano taryfę sprzedaży",
    "buyingTariffModified": "Pomyślnie zmieniono taryfę kupna",
    "sellingTariffModified": "Pomyślnie zmieniono taryfę sprzedaży",
    "buyingTariffReset": "Pomyślnie zresetowano taryfę kupna",
    "sellingTariffReset": "Pomyślnie zresetowano taryfę sprzedaży",
    "reset": "Zresetuj",
    "resetConfirmationText": "Czy na pewno chcesz zresetować szczegóły taryfy?",
    "resetErrorText": "Nie można zresetować szczegółów taryfy",
    "updateErrorText": "Nie można zaktualizować szczegółów taryfy",
    "tariffErrorText": "Nieprawidłowy wpis. Ta wartość już istnieje w poziomie ",
    "tierInvalidEntry": "Nieprawidłowy wpis. Wartość powinna być większa niż \"Tier 1\"",
    "timeInvalidEntry": "Nieprawidłowy wpis. Wartość powinna być większa niż \"From\"",
    "invalidValue": "Wartość powinna być większa niż 0"
  },
  "currency": {
    "currencyEquivalent": "Zobacz równowartość wartości energetycznych w walucie",
    "currencyConversion": "Ustaw współczynnik przeliczania walut",
    "currencyInfo": "Podana wartość waluty ma charakter orientacyjny. Podatki, opłaty, poziomy, popyt lub ceny zależne od czasu użytkowania nie są brane pod uwagę.",
    "currencyFactor": "Współczynnik przeliczania walut",
    "currencyFactorSubtitle": "Dane dotyczące energii są przeliczane na równowartość w walucie poprzez pomnożenie ich przez współczynnik przeliczenia waluty.",
    "currencyNote": "Uwaga! Podana wartość waluty ma charakter orientacyjny. Podatki, opłaty, poziomy, popyt lub ceny zależne od czasu użytkowania nie są brane pod uwagę.",
    "conversionFactor": "Współczynnik przeliczania",
    "currencyEquivalentHeader": "Równowartość w walucie",
    "energyImported": "Energia zaimportowana",
    "energyExported": "Energia wyeksportowana",
    "netEnergyImported": "Zaimportowana energia netto",
    "netEnergyExported": "Wyeksportowana energia netto",
    "currencyConversionHeader": "Przeliczanie waluty",
    "confirmationMessage": "Czy chcesz kontynuować bez zapisania zmian?",
    "confirmationYes": "Sim",
    "confirmationNo": "Nie",
    "invalidInput": "Nieprawidłowe dane wejściowe"
  },
  "demo": {
    "appDemo": "Wersja demonstracyjna aplikacji",
    "message": "Oto wersja demonstracyjna aplikacji",
    "enphaseInstaller": "Instalator Enphase",
    "mainHeader": "Kompleksowy, inteligentny system energii",
    "subHeader": "Kup system wytwarzania i magazynowania energii słonecznej",
    "getStarted": "Wprowadzenie",
    "appDemoDesc": "Naciśnij, aby zobaczyć, jak działa system",
    "loginDesc": "Dla zarejestrowanych użytkowników",
    "selectLanguage": "Wybór języka"
  },
  "connectionBandwidth": {
    "low": "Mała przepustowość. Przekazuje dane co 6 h",
    "high": "Standardowa przepustowość. Przekazuje dane co 15 min"
  },
  "release_notes": {
    "appUpdateHeading": "Nowa aktualizacja aplikacji Enphase",
    "appUpdateSuccessHeading": "Zaktualizowano aplikację Enphase.",
    "later": "W przyszłości",
    "updateNow": "Zaktualizuj teraz",
    "update": "Zaktualizuj",
    "whatsNew": "Oto, co nowego",
    "askWhatsNew": "Co nowego?",
    "new": "Nowości",
    "version": "Wersja",
    "readMore": "Więcej informacji"
  },
  "storageCapacity": {
    "availableEnergy": "Dostępna energia",
    "totalStorage": "Total Storage",
    "encharge": "IQ Battery",
    "acBattery": "AC Battery",
    "of": "of",
    "availablePower": "Dostępna moc",
    "activeMicroinverters": "Aktywny(-e) mikroinwerter(y)",
    "activeEncharge": "Aktywny(-e) akumulator(y)",
    "microinverters": "Mikroinwerter(y)"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Prześlij wybrany obraz witryny",
    "selectImage": "Wybierz Obraz",
    "imageSizeError": "*Rozmiar obrazu powinien być mniejszy niż 5 MB",
    "hide": "Ukrywać",
    "apply": "Zastosuj",
    "hideSiteImage": "Ukryj obraz witryny",
    "hideSiteImageDesc1": "Obraz witryny nie będzie wyświetlany na stronie Stan. Możesz zmienić preferencje, przechodząc do Menu -> System -> Szczegóły witryny.",
    "hideSiteImageDesc2": "Czy chcesz kontynuować?",
    "uploadSuccessToast": "Obraz Twojej witryny został pomyślnie zaktualizowany",
    "maxImageLimit": "Możesz przesłać maksymalnie cztery obrazy do swojej witryny. Usuń obraz, aby dodać nowy.",
    "okGotIt": "OK, rozumiem!",
    "imageSIzeErrorSiteDetails": "Rozmiar obrazu powinien być mniejszy niż 5 MB. Prześlij inny obraz.",
    "apiError": "Nie udało się zrealizować żądania. Spróbuj ponownie później",
    "displayOnStatusPage": "Wyświetlanie na stronie statusu",
    "displayOnStatusPageWarning": "Czy na pewno chcesz zaktualizować obraz na stronie Stan?",
    "displayOnStatusPageNote": "Uwaga: Obraz zostanie automatycznie dostosowany do wyświetlania. Zawsze możesz to zmienić na stronie Status",
    "deleteSiteImage": "Usuń zdjęcie",
    "deleteSiteImageWarning": "Czy na pewno chcesz usunąć obraz?",
    "imageDeleteSuccess": "Obraz został pomyślnie usunięty",
    "imageUploadSuccess": "Obraz został pomyślnie przesłany",
    "imageUploadSuccessStatusPage": "Obraz został pomyślnie zaktualizowany na stronie Status",
    "displayedOnStatusPage": "Wyświetlane na stronie statusu",
    "uploadImage": "Załaduj obrazek",
    "imagePreferenceSaved": "Twoje preferencje dotyczące obrazu witryny zostały zapisane",
    "siteImage": "Obraz witryny",
    "statusPageMaxImagePopUpDesc1": "Możesz przesłać maksymalnie cztery obrazy do swojej witryny. Usuń obraz z ",
    "statusPageMaxImagePopUpDesc2": ", aby dodać nowy tutaj",
    "addSiteImage": "DODAJ OBRAZ STRONY",
    "wrongFileType": "Prześlij tylko obraz JPEG lub PNG"
  },
  "nps": {
    "question": "Jak oceniasz swoje doświadczenie z naszymi produktami?",
    "description": "W oparciu o Twoje ostatnie doświadczenia z produktami Enphase, jakie jest prawdopodobieństwo, że polecisz nas znajomym lub współpracownikom?",
    "dontAskAgain": "Nie pytaj mnie ponownie",
    "notNow": "Nie teraz",
    "notLikely": "Raczej nie",
    "mostLikely": "Raczej tak",
    "confirmationHeader": "Dziękujemy za odpowiedź! Pomóż nam lepiej zrozumieć Twoją odpowiedź.",
    "surveyButton": "Wypełnij 2-minutową ankietę",
    "notInterested": "Nie interesuje mnie to",
    "survey": "Ankieta",
    "internetError": "Sprawdź połączenie internetowe i spróbuj ponownie.",
    "rateEnphaseTitle": "Oceń firmę Enphase",
    "rateEnphaseDescription": "Jakie jest prawdopodobieństwo, że polecisz nas znajomym lub współpracownikom?",
    "rateInstallerTitle": "Oceń instalatora",
    "rateInstallerDescription1": "Jakie jest prawdopodobieństwo, że polecisz",
    "rateInstallerDescription2": "znajomym lub współpracownikom?",
    "feedbackSuccess": "Dziękujemy za opinię, to dla nas ważne.",
    "ratingSuccess": "Dziękujemy za opinię.",
    "feedbackEnphaseTitle": "Twoja ocena Enphase",
    "feedbackInstallerTitle": "Twoja ocena instalatora",
    "detractors": "Co moglibyśmy robić lepiej?",
    "passive": "Co możemy zrobić, aby poprawić Twoje doświadczenia?",
    "promoters": "Pomóż nam, wyjaśniając swoje oceny.",
    "legalDisclaimer": "Twoje imię, nazwisko i uwagi/komentarze zostaną przekazane instalatorom."
  },
  "liveStatus": {
    "title": "Status na żywo",
    "subTitle": "Wyświetl pomiar mocy w czasie rzeczywistym",
    "offlineMsg": "Używaj STAN NA ŻYWO w trybie offline",
    "streamingLocally": "Lokalne przesyłanie strumieniowe z bramy",
    "closingMinutes": "Zamknięcie nastąpi w ciągu",
    "cfgMsg": "Baterie mogą ładować się z sieci, ponieważ włączono ustawienie %{cfglink}.",
    "learn": "Uczyc się",
    "pvOnlyCta": "%{learn}, jak zoptymalizować i śledzic zuzycie energii za pomoca pomiaru zuzycia",
    "cfgFiller": "Ładuj akumulator z sieci",
    "cfgVls": "Baterie mogą ładować się z sieci, ponieważ poziom naładowania baterii jest poniżej poziomu wyłączenia.",
    "solar": {
      "title": "Energia słoneczna",
      "producing": "Produkcja",
      "energyProducing": "Produkcja energii"
    },
    "home": {
      "title": "Strona główna",
      "consuming": "zużywanie",
      "energyConsuming": "Energy Consuming"
    },
    "grid": {
      "title": "Sieć",
      "gridConnectivity": "Łączność z siecią",
      "waiting": "Oczekiwanie na informacje",
      "unknown": "Nieznany status sieci",
      "notAvailable": "Sieć jest niedostępna",
      "systemConnected": "System jest podłączony do sieci",
      "notSystemConnected": "System jest odłączony od sieci",
      "outage": "Grid Outage",
      "updating": "Aktualizowanie statusu sieci",
      "exporting": "Eksportowanie",
      "importing": "Importowanie",
      "notConnected": "Brak połączenia",
      "offGrid": "Odłączono od sieci",
      "onGrid": "Podłączono do sieci",
      "goOnGrid": "Podłącz do sieci",
      "goOffGridDisabled": "Odłączenie od sieci niedozwolone",
      "goOffGrid": "Odłącz od sieci",
      "gridUpdatingMessage": "Potwierdzanie statusu sieci trwa dłużej niż oczekiwano. Sprawdź ponownie później.",
      "gridConnectedMessage": "Twój system jest teraz podłączony do sieci",
      "gridDisconnectedMessage": "Twój system jest teraz odłączony od sieci",
      "disconnectingGrid": "Odłączanie od sieci…",
      "connectingGrid": "Podłączanie do sieci…",
      "unableToConnect": "Nie można połączyć z bramą",
      "initialisingOnGrid": "Inicjowanie kontroli sieci…",
      "gridOutage": "System jest odłączony od sieci z powodu awarii sieci",
      "gridOutageToastAuto": "Nie można połączyć z siecią z powodu przerwy w dostawie prądu. Gdy zasilanie zostanie przywrócone, system połączy się ponownie z siecią energetyczną.",
      "gridOutageToastUser": "Nie można połączyć z siecią z powodu przerwy w dostawie prądu. Połączenie z siecią będzie możliwe po przywróceniu zasilania sieci."
    },
    "generator": {
      "title": "Generator",
      "onGenerator": "Generator wł",
      "offGenerator": "Generator wył",
      "unknown": "Nieznany status generatora",
      "notConnected": "Brak połączenia",
      "genDisconnecting": "Rozłączanie...",
      "waiting": "Oczekiwanie",
      "updating": "Aktualizacja"
    },
    "fuelCell": {
      "title": "Ogniwo paliwowe",
      "on": "Ogniwo paliwowe włączone",
      "off": "Ogniwo paliwowe wyłączone",
      "warmingUp": "Rozgrzewania ogniwa paliwowego",
      "coolDown": "Chłodzenie ogniwa paliwowego",
      "unknown": "Status ogniwa paliwowego nieznany",
      "notConnected": "Nie podłączono",
      "genDisconnecting": "Odłączanie...",
      "waiting": "Oczekiwanie",
      "updating": "Aktualizowanie"
    },
    "systemNotReporting": {
      "title": "Sterownik System Controller nie przesyła danych",
      "subTitle": "Nie możemy wyświetlić danych bieżących, ponieważ sterownik System Controller nie przesyła informacji do bramki. Może to być chwilowa usterka i powinna zostać wkrótce usunięta."
    },
    "envoy": {
      "connecting": "Łączenie z bramą…",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Nie można połączyć",
      "notAbleToConnectMultiEnv": "Nie można nawiązać połączenia z bramką o numerze seryjnym:",
      "negativeConsumptionTitle": "Błąd komunikacji",
      "negativeConsumptionDesc": "Z powodu utraty komunikacji między urządzeniami nie możemy wyświetlić pełnego stanu bieżącego. To jest chwilowa usterka i powinna zostać wkrótce usunięta."
    },
    "onDifferentNetwork": "Brama i to urządzenie są w innej sieci",
    "connectOnSameNetworkorAPMode": "Połącz bramę i urządzenie z tą samą siecią lub włącz tryb AP w bramie, aby połączyć to urządzenie z siecią Wi-Fi %{ssid}",
    "connectOnSameNetwork": "Połącz to urządzenie z siecią Wi-Fi %{ssid}, a następnie spróbuj ponownie wyświetlić stan na żywo w trybie offline.",
    "apModeTutorial": "Samouczek trybu AP",
    "apMT1": "Naciśnij i zwolnij (nie przytrzymuj) ",
    "apMT2": "przycisk trybu AP",
    "apMT3": " dopóki dioda LED trybu AP (",
    "apMT4": ") zacznie świecić na zielono. Brama pozostanie w trybie AP przez osiem godzin."
  },
  "desktop": {
    "status": {
      "power": "Moc",
      "energy": "Energia",
      "battery": "Akumulator",
      "solarEquivalent": "Równowartość w energii słonecznej",
      "dataUnavailable": "Dane nie są dostępne"
    },
    "array": {
      "title": "Układ",
      "totalProduced": "Łącznie wyprodukowano",
      "totalConsumed": "Łącznie zużyto",
      "lifetimeProduced": "Wyprodukowano w całym okresie użytkowania",
      "lifetimeConsumed": "Zużyto w całym okresie użytkowania",
      "status": "Status",
      "azimuth": "Azimuth",
      "tilt": "Tilt",
      "microinverter": "Mikroinwerter"
    },
    "energy": {
      "totalEnergy": "Energia całkowita",
      "graphControls": "Sterowanie wykresem"
    },
    "header": {
      "switchToClassic": "Przełącz na widok klasyczny"
    },
    "footer": {
      "change": "Zmiana",
      "changeSite": "Zmień lokalizację",
      "copyRightsText": "©2008-%{currYear} Enphase Energy, Inc. Wszelkie prawa zastrzeżone",
      "privacyText": "Prywatność",
      "termsText": "Warunki",
      "weatherCompany": "The Weather Company",
      "weatherDataText": "Dane pogodowe dostarczane przez"
    }
  },
  "customPeriod": {
    "dialogLabel": "Widok na podstawie",
    "billingCycle": "Cykl rozliczeniowy",
    "billingLabel": "Dopasuj wykres energii do swojego cyklu rozliczeniowego",
    "billingLabelStatusPage": "Okres od wybranej daty rozpoczęcia dla wybranego czasu trwania",
    "startDate": "Data rozpoczęcia rozliczania",
    "frequency": "Częstotliwość rozliczania",
    "months": "Miesiące",
    "days": "dni",
    "every": "Co",
    "customDate": "Niestandardowy zakres dat",
    "customDateLabel": "Wybierz niestandardowy zakres dat, aby wyświetlić go na wykresie energii",
    "customRange": "Wybierz zakres dat od 1 do 100 dni"
  },
  "systemEstimator": {
    "heading": "Narzędzie do oceny kosztów systemu",
    "exitConfirmation": "Czy na pewno chcesz zamknąć przepływ Dodaj akumulator?",
    "resumeButton": "Wznów",
    "systemAccess": "Uzyskaj dostęp do systemu,",
    "statusAddStorage": "aby uniknąć przerw w dostawie prądu",
    "addStorageLeadInfo": "wyświetl status",
    "postLoginWoSiteTitle": "Poznaj jedyny kompleksowy system produkowania i magazynowania energii słonecznej",
    "videoCTABtn": "Obejrzyj film",
    "addStorageTitle": "Kup nowy system Enphase",
    "orderNowBtn": "Zamów teraz"
  },
  "sgipIncentive": {
    "gotItButton": "Rozumiem",
    "exitButton": "Zamknij",
    "dontExitButton": "Não sair",
    "sgipPaymentNotDone": "Twój wniosek o dołączenie do programu SGIP jest niekompletny. Czy chcesz wyjść bez dokończenia wniosku?",
    "sgipPaymentDone": "W dowolnej chwili możesz wrócić, aby sprawdzić status swojego wniosku o dołączenie do programu SGIP",
    "sgipApplyAlert": "Dofinansowanie dostępne w ramach programu SGIP ma zastosowanie wyłącznie do systemów montowanych w stanie Kalifornia (Stany Zjednoczone). Jeśli czekasz na aktywację systemu w stanie Kalifornia, poproś instalatora o zainicjowanie procesu tworzenia obiektu w aplikacji Enphase.",
    "sgipGetStorage": "Kup nowy system magazynowania Enphase"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "Zmieniono stan siatki na",
    "gridOn": "Podłączono do sieci",
    "gridOff": "Odłączono od sieci",
    "batteryChangeDesc": "Zmieniono profil akumulatora na",
    "costSavings": "Oszczędności",
    "selfConsumption": "Wykorzystywanie energii na potrzeby własne",
    "savingsMode": "Tryb oszczędzania",
    "backupOnly": "Tylko zasoby rezerwowe",
    "stormGuardDesc": "Ochrona przed burzą:",
    "alertIssued": " alarm ogłoszony",
    "alertHasEnded": " alarm został odwołany"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normalny",
    "unknown": "Nieznany",
    "undefined": "Nie zdefiniowano",
    "loads": "Sterowanie odbiornikami",
    "loadsInfoPart1": "Instalator odwzorował odbiorniki na ",
    "loadsInfoPart2": "Styki pomocnicze sterownika systemu",
    "loadsInfoPart3": ". Możesz skonfigurować te odbiorniki w obszarze ",
    "loadsInfoPart4": "Ustawienia systemu",
    "powered": "Zasilanie",
    "niu": "Nie w użyciu",
    "invalidState": "Stan nieprawidłowy",
    "viewMore": "Wyświetl więcej",
    "viewLess": "Wyświetl mniej",
    "ECA_BAT_IDLE": "Bezczynny",
    "ECA_BAT_CHARGING": "Ładowanie",
    "ECA_BAT_DISCHARGING": "Rozładowywanie",
    "MAX_ECA_BAT_STATE": "Nieznany",
    "systemIsOnGrid": "System jest podłączony do sieci",
    "systemIsOffGrid": "System jest odłączony od sieci",
    "infoIsOnGrid": "System działa w trybie podłączenia do sieci.",
    "infoIsOffGrid": "System działa w trybie mikrosieci.",
    "wiredCANConn": "Połączenie przewodowe CAN ",
    "infoWiredCAN": "Sterownik IQ System Controller komunikuje się z bramką IQ Gateway za pomocą połączenia przewodowego. Ikona informuje, czy akumulator jest połączony i czy komunikuje się z bramką.",
    "infoIsOffGridAvailable": "System działa w trybie mikrosieci. Jednakże sieć jest dostępna i w dowolnej chwili możesz przejść w tryb On Grid.",
    "voltageL1": {
      "val": "Napięcie L1",
      "info": "Napięcie między linią 1 (L1) a punktem neutralnym."
    },
    "voltageL2": {
      "val": "Napięcie L2",
      "info": "Napięcie między linią 2 (L2) a punktem neutralnym."
    },
    "voltageL3": {
      "val": "Napięcie L3",
      "info": "Napięcie między linią 3 (L3) a punktem neutralnym."
    },
    "voltage": {
      "val": "Napięcie",
      "info": "Napięcie między linią 1 (L1) a punktem neutralnym."
    },
    "frequency": {
      "val": "Częstotliwość",
      "info": "Znamionowa częstotliwość prądu przemiennego (AC)"
    },
    "gridParameters": "Parametry sieci elektroenergetycznej",
    "auxiliaryContactsParameters": "Sterowanie odbiornikami",
    "infoauxiliaryContactsParam": "Sterownik systemu ma cztery styki pomocnicze do sterowania urządzeniami. Nazwa urządzenia wskazuje, że odpowiedni styk jest przypisany do tego urządzenia. Styki, których nie przypisano do żadnego urządzenia, mają oznaczenie Nieużywany.",
    "infoGridParam": "Napięcie i częstotliwość sieci są mierzone po stronie sieci elektroenergetycznej urządzenia MID. Gdy sieć jest niedostępna, napięcie i częstotliwość sieci wynoszą 0.",
    "microgridParameters": "Parametry mikrosieci",
    "infoMicrogridParam": "Napięcie i częstotliwość mikrosieci są mierzone po stronie obciążenia urządzenia MID. Gdy urządzenie MID jest w położeniu otwartym, system jest w trybie Off Grid / mikrosieci.",
    "generatorParameters": "Parametry generatora",
    "infoGeneratorParam": "Napięcie i częstotliwość generatora są mierzone po stronie obciążenia urządzenia GID (Generator Interconnect Device). Gdy urządzenie GID jest w położeniu zamkniętym, system jest w trybie Off Grid / mikrosieci.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Sygnał łączności",
    "infoZigbeeSignal": "Oznacza moc sygnału łączności bezprzewodowej 2,4 GHz z bramą. Więcej pasków lub wyższa wartość dBm oznacza silniejszy sygnał.",
    "commStatus": "Stan komunikacji",
    "infoCommSignal": "SYGNAŁ ŁĄCZNOŚCI",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "Przełącznik IQ System Controller komunikuje się z bramką IQ Gateway za pomocą połączenia USB. Ikona informuje, czy pamięć USB jest podłączona i czy komunikuje się z przełącznikiem IQ Gateway.",
    "commStatusDesc": "Akumulator IQ Battery komunikuje się z przełącznikiem IQ System Controller za pomocą połączenia przewodowego. Ikona informuje, czy akumulator IQ Battery jest połączony i czy komunikuje się z przełącznikiem IQ System Controller.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Nieznany"
    },
    "ENCMN_STATE_MISSING": {
      "val": "Błąd komunikacji 2,4 GHz"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "Parowanie 2.4 GHz"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "Ukończono parowanie za pośrednictwem połączenia 2.4 GHz"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Kończenie pobierania informacji o urządzeniach"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "Oczekiwanie na potwierdzenie statusu sieci przez akumulatory"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Wysyłanie do sterownika systemu polecenia zamknięcia przekaźnika EC1"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Nieznany"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Rozpoczynanie aktualizacji profilu sieci"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Trwa aktualizacja profilu sieci"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Ukończono aktualizację profilu sieci"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Pobieranie statusów przekaźników sterownika systemu po zainicjowaniu"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Interpretowanie statusów przekaźników sterownika systemu"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "Sterownik systemu jest w trybie off grid"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "Sterownik systemu jest w trybie off grid. Sieć jest dostępna"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "Mikrosieć jest zsynchronizowana z siecią. Gotowy do podłączenia do sieci"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "Sterownik systemu jest w trybie on grid"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Wysyłanie do sterownika systemu polecenia przejścia w tryb on grid"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Przygotowywanie do wykonania polecenia przejścia w tryb Off Grid od użytkownika"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Wysyłanie do sterownika systemu polecenia przejścia w tryb off grid"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "Sterownik System Controller pracuje w trybie połączenia z siecią. Odnajdowanie akumulatorów."
    },
    "ENCMN_STATE_MAX": {
      "val": "Nieznany"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "Nie wykryto mikroinwerterów"
    },
    "ENCHG_STATE_READY": {
      "val": "Akumulator działa"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Wysyłanie polecenia trybu sieciowego do akumulatora"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Aktualizowanie limitu stanu naładowania akumulatora"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Rozpoczynanie aktualizacji profilu sieci"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Trwa aktualizacja profilu sieci"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Ukończono aktualizację profilu sieci"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Pobieranie informacji o sprzęcie i oprogramowaniu od akumulatora"
    },
    "ST_NOP": {
      "val": "Nieznany"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "Sterownik systemu jest w trybie off grid. Łączenie z generatorem."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "Sterownik systemu jest w trybie off grid. Połączono z generatorem."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "Sterownik systemu jest w trybie off grid. Odłączanie od generatora."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "Styki EC1 zwarte. Test przekaźnika zakończony."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "Styki EC1 rozwarte. Trwa test przekaźnika."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "Przekaźnik GEN zwarty. Test przekaźnika zakończony."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "Przekaźnik GEN rozwarty. Trwa test przekaźnika."
    },
    "default": {
      "val": "Nieznany"
    },
    "controlState": "Stan kontroli",
    "CHECK_BUSES": {
      "val": "Sprawdzanie magistral i przekaźników",
      "info": "Uruchomiono ponownie sterownik systemu. Sprawdzanie parametrów systemu przed przestawieniem do innego stanu sieci."
    },
    "CYCLE_RELAYS": {
      "val": "Ponowne uruchamianie przekaźników",
      "info": "System ponownie uruchamia przekaźniki sterownika systemu, aby sprawdzić, czy ustaną warunki wywołujące błąd przekaźników."
    },
    "GRID_CONNECT": {
      "val": "Podłączanie do sieci",
      "info": "System łączy się z siecią po ponownym uruchomieniu sterownika systemu."
    },
    "EC1_EC2_CONNECT": {
      "val": "Podłączono akumulatory. Podłączanie urządzenia NFT",
      "info": "System przełącza się w tryb mikrosieci. Akumulatory są podłączone. Trwa podłączanie urządzenia NFT."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "Podłączono do sieci. Podłączanie akumulatorów",
      "info": "System jest podłączony do sieci. Trwa proces podłączania akumulatorów."
    },
    "GRID_OP_FULL": {
      "val": "Podłączono do sieci",
      "info": "System działa w trybie podłączenia do sieci."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Odłączono od sieci",
      "info": "System działa w trybie mikrosieci."
    },
    "SYNC_TO_GRID": {
      "val": "Synchronizacja z siecią",
      "info": "System przełącza się z trybu mikrosieci do trybu On Grid."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Awaria mikrosieci",
      "info": "Mikrosieć uległa awarii wskutek przeciążenia lub błędu systemu. Wkrótce nastąpi wznowienie systemu."
    },
    "MANUFACTURING_MODE": {
      "val": "Tryb produkcji",
      "info": "Skontaktuj się z obsługą klienta."
    },
    "RESET": {
      "val": "Ponowne uruchomienie sterownika systemu",
      "info": "Uruchomiono ponownie sterownik systemu. Wkrótce nastąpi wznowienie systemu."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "Podłączono do sieci. Otwieranie NFT",
      "info": "System jest podłączony do sieci. Trwa rozłączanie urządzenia NFT."
    },
    "MANUAL_OVERRIDE": {
      "val": "Aktywowano sterowanie ręczne",
      "info": "Ręcznie zamknięto urządzenie MID w celu przejścia w tryb On Grid. W przypadku pomyłki skontaktuj się z obsługą klienta"
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Nieznany",
      "info": "Skontaktuj się z obsługą klienta."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Zsynchronizowano; podłączanie do sieci"
    },
    "infoControlState": "stany kontroli",
    "faults": "Błąd sterownika systemu",
    "MID_FUSED": "System nie może przełączyć się w tryb mikrosieci, ponieważ urządzenie MID jest zablokowane w położeniu zamkniętym.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Przekaźniki urządzenia NFT są zablokowane w położeniu zamkniętym.",
    "NFT_OPEN": "System nie może przełączyć się w tryb mikrosieci, ponieważ przekaźniki urządzenia NFT są zablokowane w położeniu otwartym.",
    "MID_OPEN": "System nie może przełączyć się w tryb podłączenia do sieci, ponieważ urządzenie MID jest zablokowane w położeniu otwartym.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Twój system nie działa. Moduł przełącznika automatycznego (ATS) sterownika systemu uległ awarii.",
    "ADC_INIT": "Twój system nie działa. Moduł przełącznika automatycznego (ATS) sterownika systemu uległ awarii.",
    "I2C_COMM": "Twój system nie działa. Moduł przełącznika automatycznego (ATS) sterownika systemu uległ awarii.",
    "NFT_TEMP": "Twój system nie działa. Urządzenie NFT sterownika systemu przekroczyło limity temperatury.",
    "ATS_TEMP": "Twój system nie działa. Moduł przełącznika automatycznego (ATS) sterownika systemu przekroczył limity temperatury.",
    "E3_TEMP": "Twój system nie działa. Moduł sterownika systemu przekroczył limity temperatury.",
    "CRC_MISMATCH": "Twój system nie działa. Nie udało się zainicjować modułu sterownika systemu.",
    "V_IMBALANCE": "System nie może przełączyć się w tryb mikrosieci. Asymetria napięcia między L1 i L2 spowodowała samoczynne wyłączenie.",
    "MANUAL_OVR": "System jest w trybie podłączenia do sieci z uwagi na ręczne sterowanie sterownikiem systemu.",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "Urządzenie MID (Microgrid Interconnection Device) łączy (położenie zamknięte) dom z siecią elektroenergetyczną lub odłącza dom (położenie otwarte) od sieci elektroenergetycznej."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Zwarcie styków przekaźników rozproszonych źródeł energii (DER), DER L1, powoduje połączenie akumulatorów Encharge i instalacji PV odpowiednio z liniami 1 i 2 z instalacją domową."
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "Gdy przekaźniki EC1 L1 i L2 są w położeniu zamkniętym, łączą akumulatory lub moduły IQ8 z urządzeniami domowymi. Działają w trybie napięcia fazowego i nie mają punktu neutralnego."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "Przekaźniki IQ Battery L1 i L2, gdy są zamknięte, podłączają akumulatory do odbiorników domowych. Działają linia do linii i nie mają neutralnego."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "Przekaźniki PV L1 i L2, gdy są zamknięte, łączą IQ8 PV z odbiornikami w domu. Działają w konfiguracji linia do linii i nie mają przewodu N."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "Przekaźniki PV L1 i L2, gdy są zamknięte, łączą IQ PV z odbiornikami w domu. Działają w konfiguracji linia do linii i nie mają przewodu N."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "Skrót NFT pochodzi od słów Neutral Forming Transformer. Urządzenie to umożliwia systemowi pracę w trybie Off Grid. Gdy przekaźnik NFT L1 jest w położeniu zamkniętym, zasila urządzenie NFT. Gdy przekaźnik NFT N jest w położeniu zamkniętym, łączy punkt neutralny urządzenia NFT z urządzeniami domowymi."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "Gdy przekaźniki GID L1 i L2 są w położeniu zamkniętym, łączą generator z urządzeniami domowymi."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "Skrót NFT pochodzi od słów Neutral Forming Transformer. Urządzenie to umożliwia systemowi pracę w trybie Off Grid. Gdy przekaźnik NFT L1 jest w położeniu zamkniętym, zasila urządzenie NFT. Gdy przekaźnik NFT N jest w położeniu zamkniętym, łączy punkt neutralny urządzenia NFT z urządzeniami domowymi."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "Gdy przekaźniki DER1 L1 i L2 są w położeniu zamkniętym, łączą akumulatory lub moduły IQ8 z urządzeniami domowymi. Działają w trybie napięcia fazowego i nie mają punktu neutralnego."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "Gdy przekaźniki DER2 L1 i L2 są w położeniu zamkniętym, łączą moduły IQ8 z urządzeniami domowymi. Działają w trybie napięcia fazowego i nie mają punktu neutralnego."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Po zamknięciu te przekaźniki łączą urządzenia ze źródłem zasilania"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Zwarcie styków przekaźników rozproszonych źródeł energii (DER), DER L1, DER L2, DER L3 i DER N, powoduje połączenie akumulatora IQ Battery i mikroinwertera IQ Microinverter odpowiednio z liniami 1, 2, 3 lub z neutralną."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Zwarcie styków przekaźników rozproszonych źródeł energii (DER), DER L1, DER L2 i DER N, powoduje połączenie akumulatora IQ Battery i mikroinwertera IQ Microinverter odpowiednio z liniami 1, 2 lub z neutralną."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Zwarcie styków przekaźników rozproszonych źródeł energii (DER), DER L1 i DER N, powoduje połączenie akumulatora IQ Battery i mikroinwertera IQ Microinverter odpowiednio z linią neutralną lub instalacją domową."
    },
    "open": "Otwarty",
    "closed": "Zamknięty"
  }, _defineProperty(_liveVitalStats, "powered", "Zasilanie"), _defineProperty(_liveVitalStats, "notPowered", "Brak zasilania"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "Różnicę między napięciem i częstotliwością sieci elektroenergetycznej a mikrosieci można zaobserwować ze względu na spadek napięcia urządzenia MID."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "Ten schemat blokowy sterownika systemu ma charakter wyłącznie poglądowy."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Przekaźniki sterownika systemu"), _defineProperty(_liveVitalStats, "bmuWarning", "Ostrzeżenie BMU"), _defineProperty(_liveVitalStats, "bmuL1Error", "Błąd BMU, poziom 1"), _defineProperty(_liveVitalStats, "bmuL2Error", "Błąd BMU, poziom 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Ostrzeżenie o maksymalnym napięciu ogniw akumulatora"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Ostrzeżenie o minimalnym napięciu ogniw akumulatora"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Ostrzeżenie o asymetrii napięcia ogniw akumulatora"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Ostrzeżenie o przepięciu przełącznika FET akumulatora"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Błąd maksymalnego napięcia ogniw akumulatora, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Błąd minimalnego napięcia ogniw akumulatora, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Błąd maksymalnej temperatury ogniw akumulatora, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Błąd minimalnej temperatury ogniw akumulatora, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Błąd przepięcia podczas rozładowywania, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "Brak komunikacji z BMU."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Błąd prądu tranzystora polowego, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Błąd zadziałania bezpiecznika, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Błąd sterownika tranzystora polowego, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Błąd otwarcia linii wykrywania napięcia, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Błąd nadmiernej temperatury tranzystora polowego, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Błąd otwarcia linii term., poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Błąd obwodu wstępnego ładowania 24 V, poziom 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Błąd napięcia wstępnego ładowania ogniw akumulatora, poziom"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Błąd maksymalnego napięcia ogniw akumulatora, poziom 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Błąd minimalnego napięcia ogniw akumulatora, poziom 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Błąd maksymalnej temperatury ogniw akumulatora, poziom 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Błąd minimalnej temperatury ogniw akumulatora, poziom 2"), _defineProperty(_liveVitalStats, "gridMode", "Tryb sieci"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Powiązano z siecią",
    "info": "Akumulator jest w trybie podłączenia do sieci. W tym stanie tymczasowym nie utworzy mikrosieci, gdy sieć będzie niedostępna.",
    "pcuInfo": "Mikroinwerter jest w trybie podłączenia do sieci. Nie utworzy mikrosieci, gdy sieć będzie niedostępna."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "Podłączono do sieci",
    "info": "Akumulator jest w trybie podłączenia do sieci i ma możliwość utworzenia mikrosieci, jeśli zajdzie taka potrzeba.",
    "pcuInfo": "Mikroinwerter jest w trybie podłączenia do sieci i ma możliwość utworzenia mikrosieci, jeśli zajdzie taka potrzeba."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Odłączono od sieci",
    "info": "Akumulator utworzył mikrosieć.",
    "pcuInfo": "Mikroinwerter utworzył mikrosieć."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Wykryto wyspowy tryb pracy",
    "info": "Akumulator wykrył, że sieć jest niestabilna/niedostępna. Urządzenie jest w trakcie tworzenia mikrosieci.",
    "pcuInfo": "Mikroinwerter wykrył, że sieć jest niestabilna/niedostępna. Urządzenie jest w trakcie tworzenia mikrosieci"
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Tworzenie mikrosieci",
    "info": "Akumulator właśnie uruchomił się ponownie. Urządzenie wykryło, że sieć elektroenergetyczna jest niedostępna i jest w trakcie tworzenia mikrosieci. Zmniejszenie obciążenia w domu pomaga w tworzeniu mikrosieci.",
    "pcuInfo": "Mikroinwerter właśnie uruchomił się ponownie. Urządzenie wykryło, że sieć elektroenergetyczna jest niedostępna, i jest w trakcie tworzenia mikrosieci. Zmniejszenie obciążenia w domu pomaga w tworzeniu mikrosieci."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Nieprawidłowy",
    "info": "Otrzymano nieprawidłowy tryb sieci dla akumulatora.",
    "pcuInfo": "Otrzymano nieprawidłowy tryb sieci dla mikroinwertera."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "tryby sieci"), _defineProperty(_liveVitalStats, "ledStatus", "Statusy diod LED"), _defineProperty(_liveVitalStats, "phase", "Faza"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "Każdy akumulator jest wyposażony w %{pcuLength} mikroinwertery IQ8X-BAT."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Dodatnia wartość mocy mikroinwertera (kW) oznacza, że akumulator jest rozładowywany, natomiast ujemna wartość mocy (kW) oznacza, że akumulator jest ładowany."), _defineProperty(_liveVitalStats, "infoPcuMicro", "Mikroinwertery IQ8X-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "Microinversores IQ8D-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "Liczba mikroinwerterów IQ8D-BAT w każdym akumulatorze wynosi %{pcuLength}."), _defineProperty(_liveVitalStats, "pcu", "Mikro"), _defineProperty(_liveVitalStats, "enph_oper_state", "Stan"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Bezczynny"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "Uruchamianie"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Wykrywanie za pośrednictwem PLC (komunikacja elektroenergetyczną siecią rozdzielczą) w toku"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normalny"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normalny (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normalny (impulsowanie)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Praca w trybie stałego napięcia DC"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normalny (oczekiwanie)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Wyłączenie (awaria zabezpieczeń)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Wyłączenie (awaria sieci)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normalny (sprawdzanie DCR)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Nieznany"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Awaria oprogramowania sprzętowego"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Wyłączony (wyłączenie hosta)"
  }), _defineProperty(_liveVitalStats, "ac_power", "Moc AC"), _defineProperty(_liveVitalStats, "signalStrength", "Siła sygnału"), _defineProperty(_liveVitalStats, "commOk", "Komunikacja OK"), _defineProperty(_liveVitalStats, "noComm", "Brak komunikacji"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normalny"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Nieznany"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "Statusy diod LED",
    "code": {
      "-1": "Nieznany",
      "0": "Błąd wymaga obsługi",
      "1": "Błąd L1 BMU",
      "2": "Wysoka temperatura",
      "3": "Przełącznik DC WYŁ.",
      "4": "Brak komunikacji z bramą",
      "5": "Nawiązano komunikację, ale nie przesłano wezwania",
      "6": "Nawiązano komunikację i przesłano wezwanie",
      "7": "Aktualizacja nie powiodła się",
      "8": "Trwa aktualizacja BC",
      "9": "Atualização BMU em progresso",
      "10": "Trwa aktualizacja PCU",
      "11": "Tryb uśpienia",
      "12": "Ładowanie",
      "13": "Rozładowywanie",
      "14": "Pojemność akumulatora wynosi: 75–100%",
      "15": "Pojemność akumulatora wynosi: 50–75%",
      "16": "Pojemność akumulatora wynosi: 25–50%",
      "17": "Pojemność akumulatora wynosi: 0–25%",
      "18": "System działa"
    },
    "enpowerRow": {
      "code": {
        "-1": "Nieznane",
        "0": "Błąd sterownika System Controller (poł. z siecią)",
        "1": "Błędy sterownika System Controller (odł. od sieci)",
        "2": "Sterownik System Controller pracuje w trybie szybkiego wyłączania / ręcznego wymuszenia",
        "3": "Sterownik System Controller odłączony od sieci; źródła DER odłączone",
        "4": "Sterownik System Controller działa, ale nie wykrywa żadnych akumulatorów IQ Battery przez sieć CAN (poł. z siecią)",
        "5": "Sterownik System Controller działa, ale nie wykrywa nawet jednego akumulatora IQ Battery przez sieć CAN (poł. z siecią)",
        "6": "Sterownik System Controller działa, ale nie wykrywa nawet jednego akumulatora IQ Battery przez sieć CAN (odł. od sieci)",
        "7": "Sterownik System Controller odłączony od sieci; trwa przywracanie limitu SoC",
        "8": "Sterownik System Controller systemu synchronizuje się z siecią",
        "9": "Aktualizowanie opr. sprzętowego sterownika System Controller (poł. z siecią)",
        "10": "Aktualizowanie opr. sprzętowego sterownika System Controller (odł. od sieci)",
        "11": "Sterownik System Controller WŁ., uruchamianie",
        "12": "Sterownik System Controller WŁ. i podłączony do sieci",
        "13": "Sterownik System Controller WŁ. i odłączony od sieci",
        "14": "Sterownik System Controller WYŁ."
      }
    },
    "info": {
      "safetyIssue": "Żaden ze statusów diod LED nie informuje o problemie z bezpieczeństwem",
      "title": {
        "flashingRed": "Miga na czerwono",
        "flashingYellow": "Miga na żółto",
        "softPulseYellow": "Delikatnie pulsuje na żółto",
        "softPulseBlue": "Delikatnie pulsuje na niebiesko",
        "softPulseGreen": "Delikatnie pulsuje na zielono",
        "solidRed": "Świeci na czerwono",
        "solidYellow": "Świeci na żółto",
        "solidBlueOrGreen": "Świeci na niebiesko lub zielono",
        "ledOff": "Wył"
      },
      "desc": {
        "flashingRed": "Nie udało się zaktualizować lub w akumulatorze wystąpił błąd. Skontaktuj się z instalatorem lub obsługą klienta Enphase.",
        "flashingYellow": "Trwa aktualizacja.",
        "softPulseYellow": "Włączony tryb uśpienia.",
        "softPulseBlue": "Rozładowywanie.",
        "softPulseGreen": "Ładowanie..",
        "solidRed": "Uruchamianie.",
        "solidYellow": "Nie działa z powodu wysokiej temperatury. Zobacz \"IQ Battery Rozwiązywanie problemów\" A, aby uzyskać więcej informacji.",
        "solidBlueOrGreen": "Bezczynność. Kolor zmienia się między niebieskim a zielonym zgodnie ze zmianą stanu naładowania. Stan ładowania jest aktualizowany w aplikacji Enphase. Aby uzyskać więcej szczegółów, patrz „Rozwiązywanie problemów z IQ Battery” C.",
        "ledOff": "Nie działa. Zobacz \"Rozwiązywanie problemów z IQ Battery\" B, aby uzyskać więcej informacji."
      }
    }
  },
  "updatePending": {
    "title": "Trwa przesyłanie danych",
    "content": "Bramka przesyła dane systemu do chmury Enphase. Dzieje się tak, gdy bramka pracowała przez pewien czas w trybie offline. Zwykle trwa to 1 godzinę na każdy dzień pracy bramki w trybie offline. Nie ma powodu do zmartwień. Gdy wszystkie dane zostaną przesłane, komunikat zniknie.",
    "envoyDataTitle": "Przesyłanie danych",
    "envoyDataContent": "Twój system niedawno ponownie połączył się z Internetem i pobranie danych zajmie trochę czasu. Każdy dzień, w którym był offline, może potrwać nawet godzinę."
  },
  "bkpConfig": {
    "title": "Konfiguracja zasobów rezerwowych",
    "0": "Nie wybrano",
    "1": "Zasilanie części domu z zasobów rezerwowych",
    "2": "Zasilanie całego domu z zasobów rezerwowych"
  },
  "set": "Set",
  "change": "Zmiana",
  "allTopics": "Wszystkie tematy",
  "referFriends": {
    "title": "Polecaj znajomych",
    "subTitle_1": "poleć ",
    "subTitle_2": " i otrzymaj ",
    "description_1": "Ty i Twój znajomy będziecie mogli otrzymać kartę podarunkową o wartości  ",
    "description_2": " po dokonaniu przez znajomego zakupu i aktywacji nowego układu słonecznego Enphase za pomocą poniższego linku.",
    "description_3": " gdy polecona przez Ciebie osoba dokona zakupu i aktywacji nowego systemu produkcji energii słonecznej Enphase, korzystając z poniższego łącza.",
    "urlHeading": "Adres URL do polecenia",
    "shareButton": "Udostępnij łącze polecające",
    "copyButton": "Skopiuj łącze polecające",
    "termsConditions": "Regulamin",
    "applyTerms": " ",
    "toastMessage": "Skopiowano łącze polecające do schowka",
    "shareMessage_1": "Hej! Czy wiesz, że mój dom jest zasilany energią słoneczną? Jeśli zastanawiasz się nad montażem systemu produkcji energii słonecznej, teraz jest ku temu doskonała okazja. Mam wyjątkowy link polecający, którego możesz użyć, aby otrzymać ",
    "shareMessage_2": " gdy aktywujesz nowy system do produkcji energii słonecznej Enphase.",
    "shareMessageAU_1": "Hej! Zakup systemu produkcji energii słonecznej firmy Enphase do domu był jedną z moich najlepszych inwestycji. Dlatego też chcę zachęcić Cię do tego samego. Jeśli szukasz sposobu na obniżenie rachunków za prąd i zwiększenie oszczędności, skorzystaj z mojego linku polecającego, dzięki któremu możesz otrzymać",
    "shareMessageAU_2": " gdy przejdziesz na energię słoneczną z firmą Enphase. Sprawdź:",
    "tncTitle": "Warunki i postanowienia programu poleceń Enphase:",
    "important_title": "Ważne",
    "important_subtitle": "Ty i wybrana przez Ciebie osoba będziecie uprawnieni do otrzymania kuponu tylko wtedy, gdy:",
    "important_1": "There is a gap of at least 15 days between completed registration and installation.",
    "important_2": "Adres e-mail, na który otrzymano lub zarejestrowano polecenie, posłuży do aktywacji systemu po zainstalowaniu",
    "tnc": {
      "1": "Obowiązuje limit 30 poleceń na klienta.",
      "2": "Polecane osoby muszą użyć udostępnionego przez Ciebie łącza i przekazać swoje dane do kontaktu firmie Enphase w specjalnej witrynie Enphase do dnia 31 grudnia 2022 roku (włącznie).",
      "3": "Jeśli Enphase lub instalatorzy firmy mają już w swojej bazie identyfikator adresu e-mail wprowadzony przez poleconą osobę, nie będzie ona kwalifikować się do udziału w programie poleceń.",
      "4": "Zarówno Osoba polecająca, jak i Osoba polecona, będą uprawnione do otrzymania kart podarunkowych tylko wtedy, gdy Osoba polecona dokona zakupu i montażu oraz dokończy aktywację produktu Enphase w ciągu 2 lat od otrzymania przez Enphase informacji o Osobie poleconej w witrynie Enphase.",
      "5": "Po otrzymaniu przez Ciebie i poleconą osobę powiadomienia o przyznaniu karty podarunkowej przez firmę Enphase, musicie odebrać kartę w ciągu 90 dni od powiadomienia.",
      "6_One": "Jeśli karty podarunkowe w kwocie ",
      "6_Two": "  będą niedostępne, firma Enphase może je zastąpić inną nagrodą o takiej samej lub większej wartości.",
      "7": "Kwota na karcie podarunkowej stanowi równowartość zaoszczędzonych bezpośrednich wydatków marketingowych na rekrutację nowego klienta.",
      "8": "Jeśli Ty lub polecona przez Ciebie osoba chcecie wycofać się z programu poleceń lub zrezygnować z karty podarunkowej, należy skontaktować się z obsługą klienta firmy Enphase.",
      "9": "Firma Enphase nie ponosi odpowiedzialności za błędne, nieprawidłowe, niekompletne lub spóźnione zgłoszenia ani za błędy typograficzne, problemy z przesyłaniem lub pobraniem informacji dotyczących poleceń ani za żadne inne awarie techniczne sieci, Internetu, urządzeń elektronicznych i witryn internetowych.",
      "10": "Firma Enphase zastrzega sobie prawo do modyfikacji, zawieszenia lub zakończenia programu poleceń bez uprzedniego powiadomienia.",
      "11": "Niniejszy program poleceń nie jest realizowany w miejscach, gdzie taka działalność jest zabroniona.",
      "12": "Przy polecaniu Ty i osoba polecana musicie skorzystać z unikatowego łącza udostępnionego przez firmę Enphase.",
      "13": "Między zakończeniem rejestracji a instalacją musi nastąpić co najmniej 15-dniowy odstęp.",
      "14": "Adres e-mail, na który otrzymano lub zarejestrowano polecenie, musi posłużyć do aktywacji systemu po zainstalowaniu."
    }
  },
  "contactPVMaintainer": "Skontaktuj się z serwisantem paneli słonecznych",
  "contactStorageMaintainer": "Skontaktuj się z serwisantem akumulatorów",
  "pvInstallerDetails": "Dane instalatora paneli słonecznych",
  "storageInstallerDetails": "Dane instalatora akumulatorów",
  "customerSupport": "Obsługa klienta",
  "soFarToday": "Dotychczas dziś,",
  "forSelectedPeriod": "Dla wybranego okresu,",
  "energyIndependence": {
    "title": "Niezależność energetyczna",
    "subTitle": "Mierzy Twoją niezależność od sieci elektroenergetycznej",
    "formulaText": "Obliczenie niezależności energetycznej:",
    "formula": "[1-(Zaimportowano / Zużyto)] * 100%",
    "formulaForGenerator": "[1 - {(Energia pobrana z sieci + Energia pobrana z generatora) / Zużyto}] * 100%",
    "desc1": "Niezależność energetyczna to wskaźnik samowystarczalności energetycznej. Oznacza, że jesteś w stanie samodzielnie zaspokoić całe swoje zapotrzebowanie na energię.",
    "unknown": "nie można ustalić, ponieważ system nie przesłał jeszcze żadnych danych dotyczących zużycia.",
    "0": "cała zużywana przez Ciebie energia pochodzi z zewnętrznego źródła, takiego jak sieć elektroenergetyczna. Przekłada się to na wynik niezależności energetycznej %{eiValue}% w okresie %{periodValue}.",
    "100": "żadna część zużywanej przez Ciebie energii nie pochodzi z zewnętrznego źródła, takiego jak sieć elektroenergetyczna. Przekłada się to na wynik niezależności energetycznej %{eiValue}% w okresie %{periodValue}.",
    "value": "%{geValue}% Twojego zużycia energii pochodzi z zewnętrznego źródła, takiego jak sieć elektroenergetyczna. Przekłada się to na wynik niezależności energetycznej %{eiValue}% w okresie %{periodValue}.",
    "forTodayPeriod": "dziś jest",
    "forSelectedPeriod": "wybrany okres to",
    "addStorageTitle": "Dodaj akumulator",
    "addStorage": "Aby zwiększyć niezależność energetyczną.",
    "addStorageTitleWB": "Dodawanie paneli słonecznych lub akumulatorów",
    "addStorageWB": "zwiększa niezależność energetyczną.",
    "clarify": "Niezależność energetyczna nie obejmuje energii eksportowanej i nie należy jej mylić z pomiarem netto (lub energią netto), która jest różnicą między energią importowaną i eksportowaną."
  },
  "backupHistory": {
    "backupEvents": "Łączna liczba zdarzeń dotyczących zasobów rezerwowych"
  },
  "eventHistory": {
    "totalEvents": "Łączna liczba zdarzeń",
    "events": "Punkt/zdarzenie",
    "deviceImpacted": "Dotknięte urządzenie",
    "recommendedAction": "Zalecane działanie",
    "noBackupHistoryFound": "Nie znaleziono historii zasobów rezerwowych",
    "eventStatus": "Estado do evento"
  },
  "siteActivationStage": {
    "title": " inicjuje aktywację Twojego systemu Enphase, ",
    "learnToUse": "Dowiedz się, jak wykorzystać aplikację Enphase do monitorowania swojego nowego systemu Enphase."
  },
  "sfdcChatBot": {
    "exitConfirmation": "Czy na pewno chcesz opuścić czat z nami?",
    "sfdcChatSubject": "Czatuj z poziomu aplikacji Enphase",
    "offlineSupport": "Niestety nasi agenci są offline. Zostaw nam wiadomość."
  },
  "pushN": {
    "ok": "Ok, go there",
    "stay": "Stay here",
    "permMsg": "Otrzymano powiadomienie dla obiektu %{siteName}. Przejdź do obiektu, aby wyświetlić powiadomienie."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Który tryb należy wybrać?",
    "autofillRatePlanExistFAQ": "Dlaczego mój plan taryfowy nie jest wymieniony?",
    "autofillRatePlanMatchFAQ": "Dlaczego moje dane nie zgadzają się z rachunkiem?",
    "autofillTariffNote": "W razie problemów ze znalezieniem nazwy/kodu taryfy należy skontaktować się ze sprzedawcą energii.",
    "whtBaslineElecRate": "Jaka jest Twoja podstawowa stawka zapłaty za energię elektryczną?",
    "doElecPayRateVaryWeekends": "Czy Twoja stawka zapłaty za energię elektryczną zmienia się w weekendy?",
    "doElecPayRateVarySeasonaly": "Czy Twoja stawka zapłaty za energię elektryczną różni się w zależności od pory roku?",
    "elecPayGoesUpWithUsage": "Czy Twoja stawka zapłaty za energię elektryczną rośnie wraz ze zwiększonym wykorzystaniem?",
    "pRatePeakOffPecakChanges": "Czy Twoja stawka zapłaty za energię elektryczną różni się w szczycie i poza szczytem?",
    "ratePerUnitOfSolar": "Jaka jest Twoja stawka zapłaty za jednostką wygenerowanej energii słonecznej?",
    "payOutRate": "Stawka zapłaty",
    "tarifeditorConstants1": "Stawka za energię elektryczną",
    "tarifeditorConstants2": "Przekształca dane dotyczące energii w stawki pieniężne",
    "tarifeditorConstants3": "Wyświetl/edytuj strukturę stawek za energię elektryczną swojego dostawcy prądu",
    "tarifeditorConstants4": "Stawkę za pobór energii elektrycznej można sprawdzić na rachunku za prąd, pod sekcją ze szczegółami naliczanych opłat.",
    "tarifeditorConstants5": "Dodaj stawkę za pobór energii elektrycznej",
    "tarifeditorConstants6": "Ustaw strukturę stawek, w oparciu o które płacisz za pobór energii elektrycznej z sieci.",
    "tarifeditorConstants7": "Uwaga ",
    "tarifeditorConstants8": "Brama wykorzystuje informacje o stawkach za energię elektryczną do ustalenia najkorzystniejszego harmonogramu ładowania i rozładowywania akumulatorów, gdy jako profil akumulatorów ustawisz tryb oszczędzania. Zmiana tych informacji spowoduje zmianę działania systemu.",
    "tarifeditorConstants9": "Nie dodano struktury stawek za energię elektryczną",
    "tarifeditorConstants10": "Dodaj stawkę za pobór energii elektrycznej",
    "tarifeditorConstants11": "Wybierz tryb, aby dodać szczegóły",
    "tarifeditorConstants12": "Automatyczne wypełnienie ",
    "tarifeditorConstants13": "Zaimportuj strukturę stawek za energię elektryczną, wykorzystując informacje od swojego przedsiębiorstwa energetycznego.",
    "tarifeditorConstants14": "Ręcznie ",
    "tarifeditorConstants15": "Wprowadź ręcznie szczegóły struktury stawek za energię elektryczną swojego dostawcy prądu. ",
    "tarifeditorConstants16": "Kod pocztowy ",
    "tarifeditorConstants17": "Nazwa dostawcy prądu ",
    "tarifeditorConstants18": "Nazwa/kod taryfy ",
    "tarifeditorConstants19": "Szczegóły stawki za pobór energii elektrycznej ",
    "tarifeditorConstants20": "Stawka stała ",
    "tarifeditorConstants21": "Stawka zmienna ",
    "tarifeditorConstants22": "Czas użytkowania ",
    "tarifeditorConstants23": "Stawka ryczałtowa ",
    "tarifeditorConstants24": "Zastrzeżenie odpowiedzialności ",
    "tarifeditorConstants25": "Podane stawki za energię elektryczną obejmują zmiany uwzględniające wyłącznie elementy oparte na zużyciu. Stałe stawki, korekty, kredyty, dofinansowania, różnice regionalne, konkretne różnice i podatki nie są uwzględnione. ",
    "tarifeditorConstants26": "Potwierdź i zapisz ",
    "tarifeditorConstants27": "Nazwa stawki za energię elektryczną ",
    "tarifeditorConstants28": "Podstawowa stawka za energię elektryczną ",
    "tarifeditorConstants29": "Czy na pewno chcesz zresetować szczegóły? ",
    "tarifeditorConstants30": "Czy Twoja stawka za energię elektryczną różni się w szczycie i poza szczytem? ",
    "tarifeditorConstants31": "Czy Twoja stawka za energię elektryczną rośnie wraz ze zwiększonym wykorzystaniem? ",
    "tarifeditorConstants32": "Stała stawka, które nie ulega zmianie. ",
    "tarifeditorConstants33": "Stawka za energię elektryczną rośnie wraz ze zwiększonym wykorzystaniem. ",
    "tarifeditorConstants34": "Czy Twoja stawka za energię elektryczną różni się w zależności od pory roku? ",
    "tarifeditorConstants35": "Czy Twoja stawka za energię elektryczną zmienia się w weekendy? ",
    "tarifeditorConstants36": "Jaka jest Twoja podstawowa stawka za energię elektryczną? ",
    "tarifeditorConstants37": "Stała stawka, które nie ulega zmianie. ",
    "tarifeditorConstants38": "Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku. ",
    "tarifeditorConstants39": "Struktura stawek za energię elektryczną zmienia się w weekendy. ",
    "tarifeditorConstants40": "Struktura stawek za energię elektryczną zmienia się wraz z porą roku, jak i w weekendy. ",
    "tarifeditorConstants41": "Stawka za energię elektryczną rośnie wraz ze zwiększonym wykorzystaniem. ",
    "tarifeditorConstants42": "Podstawowa stawka za energię elektryczną : ",
    "tarifeditorConstants43": "Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku. ",
    "tarifeditorConstants44": "Stawka za energię elektryczną różni się w szczycie i poza szczytem. ",
    "tarifeditorConstants45": "Struktura stawek za energię elektryczną zmienia się tylko w weekendy ",
    "tarifeditorConstants46": "Dodaj stawkę za eksport energii elektrycznej ",
    "tarifeditorConstants47": "Dodaj strukturę stawek, w ramach której otrzymujesz zapłatę za eksport energii wyprodukowanej przez system fotowoltaiczny do sieci. ",
    "tarifeditorConstants48": "Wybierz plan eksportu energii elektrycznej ",
    "tarifeditorConstants49": "Jak wybrać plan eksportu energii elektrycznej ",
    "tarifeditorConstants50": "Możesz sprawdzić te informacje na rachunku za prąd, pod sekcją przedstawiającą kredyty i korekty. ",
    "tarifeditorConstants51": "Opomiarowanie netto (NEM) ",
    "tarifeditorConstants52": "Zaznacz to, jeśli masz w domu konfigurację licznika netto. <b style='font-weight: bold;'>Twoja stawka importu energii elektrycznej zostanie skopiowana jako stawka eksportu energii elektrycznej</b> ",
    "tarifeditorConstants53": "Taryfa gwarantowana netto (Net FIT) ",
    "tarifeditorConstants54": "Sprawdź, czy otrzymujesz zapłatę tylko za energię słoneczną, która wraca do sieci z Twojego domu. ",
    "tarifeditorConstants55": "Taryfa gwarantowana brutto (Gross FIT) ",
    "tarifeditorConstants56": "Sprawdź, czy otrzymujesz zapłatę za każdą jednostkę energii elektrycznej wygenerowaną przez Twoje panele słoneczne. ",
    "tarifeditorConstants57": "Inne ",
    "tarifeditorConstants58": "Sprawdź, czy korzystasz z innego planu. ",
    "tarifeditorConstants59": "Szczegóły stawki za eksport energii elektrycznej ",
    "tarifeditorConstants60": "Struktura stawek zapłaty za energię elektryczną ",
    "tarifeditorConstants61": "Plan eksportu ",
    "tarifeditorConstants62": "Edytuj stawkę za eksport energii elektrycznej ",
    "tarifeditorConstants63": "Czy w ramach swojego planu FIT otrzymujesz zapłatę za jednostkę wyeksportowanej energii słonecznej w stałej cenie? ",
    "tarifeditorConstants64": "Stawka zmienna w czasie ",
    "tarifeditorConstants65": "Stawka zapłaty za energię elektryczną różni się w szczycie i poza szczytem ",
    "tarifeditorConstants66": "Stała stawka zapłaty za energię elektryczną, która nie ulega zmianie ",
    "tec67": "Podstawowa stawka zwrotu za energię elektryczną",
    "tec68": "Nazwa stawki",
    "tec69": "Z przykrością informujemy, że Twoja struktura taryfowa nie umożliwia automatycznego uzupełnienia. Pracujemy nad rozwiązaniem. W międzyczasie możesz ustawić taryfę, korzystając z przepływu ręcznego.",
    "tec70": "Não foi possível encontrar o nome do serviço público para o seu código zip. Defina a tarifa manualmente.",
    "tec71": "Niestety nie możemy pobrać szczegółów taryfy.",
    "tec72": "Wybierz nazwę dostawcy",
    "tec73": "Wyszukiwanie",
    "tec74": "Nazwa/kod taryfy",
    "tec75": "Wybierz kod/nazwę taryfy",
    "tec76": "Ustaw taryfę ręcznie",
    "tec77": "spróbuj ponownie",
    "tec78": "Wybierz czas ładowania",
    "tec79": "Ładuj akumulatory z sieci",
    "from": "Od",
    "to": "do",
    "tec80": "Pomyślnie zaktualizowano ładowanie akumulatorów z sieci",
    "try_again": "Spróbuj ponownie.",
    "tec81": "Oceń swoje doświadczenia",
    "tec82": "Czy te informacje były pomocne i rzetelne?",
    "tec83": "Raczej nie",
    "tec84": "Raczej tak",
    "tec85": "Skontaktuj się z nami w razie pytań lub wątpliwości.",
    "tec86": "Nie chcesz, aby Twoje akumulatory były ładowane z sieci?",
    "tec87": "Dziękujemy za opinię, to dla nas ważne",
    "talc": "Spróbuj ponownie później",
    "tec88": "Jak oceniasz edytora taryf?",
    "tec89": "Uwaga",
    "tec90": "Skopiuj z taryfy kupna",
    "tec91": "Skopiuj ustawienie taryfy z ustawionej taryfy kupna",
    "tec92": "Stawka za eksport energii elektrycznej",
    "tec93": "Stawka za import energii elektrycznej",
    "tec94": "Wyświetlana tutaj stawka za energię elektryczną stanowi sumę elementów składowych stawki przedstawionych poniżej.",
    "tec95": "Udziel odpowiedzi na poniższe pytania, aby ustawić swój typ taryfy.",
    "tec96": "Nieprawidłowy przedział czasu",
    "tec97": "Wybrano już przedział %{time1}– %{time2}",
    "peak": "Szczyt",
    "aPeak": "Dodaj szczyt",
    "aSeason": "Dodaj sezon",
    "season": "Sezon",
    "eSeason": "Edytuj sezon",
    "tec98": "Nieprawidłowy wpis. Wartość powinna być większa od poziomu %{index}",
    "tec99": "Wystąpił błąd. Spróbuj ponownie później",
    "tec100": "Stawka zwrotu za energię elektryczną rośnie wraz z wykorzystaniem.",
    "tec101": "Stawka zmienna w czasie",
    "tier": "Poziom",
    "offPeak": "Poza szczytem",
    "tec102": "Edytuj stawkę za import energii elektrycznej",
    "tec103": "Konfiguracja ręczna",
    "tec104": "automatyczne uzupełnienie taryfy",
    "tec105": "Wybierz tryb",
    "tec106": "Wybierz tryb, aby edytować szczegóły",
    "tec107": "wybierz nazwę taryfy",
    "tec108": "Informacje o stawkach za energię elektryczną są wykorzystywane przez bramę do ustalenia najlepszego harmonogramu ładowania i rozładowywania akumulatora. Zmiana tych informacji spowoduje zmianę działania systemu.",
    "tec109": "Informacje o stawkach za energię elektryczną są wykorzystywane do obliczenia oszczędności energii na przestrzeni czasu oraz przedstawienia spersonalizowanych zaleceń, które pomagają obniżyć koszt energii.",
    "tec110": "Ile wynosi Twoja stawka zapłaty za jednostką wyeksportowanej energii słonecznej?",
    "tec111": "Zapisano/dodano stawkę za import energii elektrycznej",
    "tec112": "Pomyślnie zaktualizowano stawkę za import energii elektrycznej",
    "tec113": "Pomyślnie zresetowano stawkę za import energii elektrycznej",
    "tec114": "Zapisano/dodano stawkę za eksport energii elektrycznej",
    "tec115": "Pomyślnie zaktualizowano stawkę za eksport energii elektrycznej",
    "tec116": "Pomyślnie zresetowano stawkę za eksport energii elektrycznej",
    "rate": "Stawka",
    "tec117": "Stała stawka zapłaty",
    "tec118": "Inne (Stawka zmienna )",
    "tec119": "Inne (Czas użytkowania )",
    "tec120": "Inne (Stawka stała )",
    "tec121": "Taryfa gwarantowana brutto",
    "tec122": "Net FIT (Stawka zmienna w czasie)",
    "tec123": 'Net FIT (Stawka stała )',
    "tec124": "Opomiarowanie netto",
    "tec125": "Stała stawka, które nie ulega zmianie. Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku.",
    "tec126": "Stała stawka, które nie ulega zmianie. Struktura stawek za energię elektryczną zmienia się tylko w weekendy.",
    "tec127": "Stała stawka, które nie ulega zmianie. Struktura stawek za energię elektryczną zmienia się wraz z porą roku, jak i w weekendy.",
    "tec128": "Stała stawka zapłaty za energię elektryczną, która nie ulega zmianie. Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku.",
    "tec129": "Stała stawka zapłaty za energię elektryczną, która nie ulega zmianie. Struktura stawek za energię elektryczną zmienia się tylko w weekendy.",
    "tec130": "Stała stawka zapłaty za energię elektryczną, która nie ulega zmianie. Struktura stawek za energię elektryczną zmienia się wraz z porą roku, jak i w weekendy.",
    "tec131": "Stawka za energię elektryczną różni się w szczycie i poza szczytem. Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku.",
    "tec132": "Stawka za energię elektryczną różni się w szczycie i poza szczytem. Struktura stawek za energię elektryczną zmienia się tylko w weekendy.",
    "tec133": "Stawka za energię elektryczną różni się w szczycie i poza szczytem. Struktura stawek za energię elektryczną zmienia się wraz z porą roku, jak i w weekendy.",
    "tec134": "Stawka zapłaty za energię elektryczną różni się w szczycie i poza szczytem. Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku.",
    "tec135": "Stawka zapłaty za energię elektryczną różni się w szczycie i poza szczytem. Struktura stawek za energię elektryczną zmienia się tylko w weekendy.",
    "tec136": "Stawka zapłaty za energię elektryczną różni się w szczycie i poza szczytem. Struktura stawek za energię elektryczną zmienia się wraz z porą roku, jak i w weekendy.",
    "tec137": "Stawka za energię elektryczną rośnie wraz ze zwiększonym wykorzystaniem. Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku.",
    "tec138": "Stawka zwrotu za energię elektryczną rośnie wraz z wykorzystaniem. Struktura stawek za energię elektryczną zmienia się tylko wraz z porą roku.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Pokaż stawki historyczne",
    "tec141": "Pomyślnie dodano stawkę importu energii elektrycznej",
    "tec142": "Oceń swoje doświadczenia z procesem dodawania stawki za energię elektryczną",
    "tec143": "Niezadowolony(-a)",
    "tec144": "Zadowolony(-a)",
    "tec145": "Pomiń",
    "tedc0": "Opłata za moc",
    "tedc1": "Całodniowa opłata za moc (24 godziny)",
    "tedc2": "Twoja stawka za energię elektryczną uwzględnia opłatę za moc dodawaną co miesiąc do rachunku za prąd.",
    "tedc3": "Twoja stawka za energię elektryczną zawiera opłatę za zapotrzebowanie. W godzinach szczytu maksymalne zużycie w dowolnym przedziale %{time}-minutowym w miesiącu będzie naliczane zgodnie z następującymi danymi",
    "tedc4": "%{time}-min Max. Consumption",
    "tedc5": "Wybierz strukturę stawek za energię elektryczną",
    "tet1": "Chcę dowiedzieć się więcej o dodawaniu stawki za prąd",
    "tet2": "W niektórych miejscach koszt energii elektrycznej zmienia się w ciągu dnia lub w zależności od jej zużycia. Wykorzystujemy stawkę za prąd do ustalenia najkorzystniejszego harmonogramu ładowania i rozładowywania akumulatora, gdy jego profil jest ustawiony na tryb oszczędzania.",
    "tet3": "Wprowadzenie",
    "tet4": "Kliknij opcję „Dodaj stawkę za import energii elektrycznej”.",
    "tet5": "Wpisz swoje dane",
    "tet6": "Użyj trybu automatycznego wypełniania lub trybu ręcznego, aby wprowadzić szczegóły stawki. Jeśli chcesz wpisać swoją stawkę ręcznie, możesz potrzebować aktualnego rachunku za energię.",
    "tet7": "Automatyczne wypełnienie",
    "tet8": "Wybierz przedsiębiorstwo energetyczne i nazwę lub kod planu z rozwijanych menu. Aplikacja automatycznie sprawdzi stawkę za import energii elektrycznej.",
    "tet9": "Ręcznie",
    "tet10": "Wprowadź szczegóły w każdym polu. Może zajść konieczność sprawdzenia aktualnego rachunku za energię elektryczną w celu zebrania wszystkich potrzebnych informacji.",
    "tet11": "Dodaj stawkę za eksport energii elektrycznej",
    "tet12": "Jeśli uzyskasz ulgę za przesyłanie energii elektrycznej z powrotem do sieci, w następnym kroku dodaj swoją stawkę za eksport energii elektrycznej. Kliknij opcję „Dodaj stawkę za eksport energii elektrycznej”, aby rozpocząć. Będziesz mieć te same opcje wprowadzania informacji w trybie automatycznego wypełniania, jak i ręcznym.",
    "tet13": "Jak ustalamy i wykorzystujemy Twoją stawkę za energię elektryczną?",
    "undefined": "inne (warstwowe)",
    "timeDiffError": "Różnica między czasem rozpoczęcia i zakończenia nie powinna przekraczać 15 minut.",
    "periodOverlapError": "Ten okres pokrywa się z jednym z innych okresów.",
    "peakConflictError": "Stawka w godzinach szczytu powinna być wyższa niż stawka poza szczytem.",
    "isTimeValid": 'Czas rozpoczęcia musi być wcześniejszy niż czas zakończenia'
  },
  "appliance": {
    "info": "Aby w domu długo nie zabrakło energii elektrycznej podczas przerw zasilania, zalecamy minimalizowanie zużycia energii i odpowiednie nim zarządzanie.",
    "desc": "Wyłącz niepotrzebne urządzenia domowe, aby wydłużyć dostępność zasobów rezerwowych.",
    "descSystem2_0AndEncharge": "Dobre praktyki na wypadek przerwy w zasilaniu z sieci.",
    "largeAppliances": "Duże urządzenia",
    "useSparingly": "używaj oszczędnie",
    "essentialAppliances": "Niezbędne urządzenia",
    "useNormally": "używaj normalnie",
    "airConditioner": "Klimatyzator",
    "dishwasher": "Zmywarka",
    "poolPump": "Pompa basenowa",
    "washingMachine": "Pralka",
    "electricVehicle": "Pojazd elektryczny",
    "electricDryer": "Suszarka elektryczna",
    "lights": "Oświetlenie",
    "laptop": "Laptop",
    "television": "Telewizor",
    "refrigerator": "Lodówka",
    "wifiRouter": "Router Wi-Fi",
    "microwave": "Mikrofalówka"
  },
  "rootedAlert": {
    "exitBtn": "Zamknij",
    "proceedBtn": "Kontynuuj",
    "agreeBtn": "Zgadzam się",
    "warningLabel": "OSTRZEŻENIE!",
    "warningTextInitial": "Wygląda na to, że Twoje urządzenie ma zdjęte ograniczenia. Zdjęcie ograniczeń usuwa domyślne zabezpieczenia i zagraża bezpieczeństwu danych zapisanych na urządzeniu. Nie zalecamy korzystania z aplikacji Enphase na urządzeniu ze zdjętymi ograniczeniami.",
    "warningTextFinal": "Poprzez kontynuowanie oświadczam, że rozumiem i akceptuję, iż firma Enphase nie będzie ponosić odpowiedzialności za żadne awarie ani konsekwencje używania aplikacji Enphase na tym urządzeniu ze zdjętymi ograniczeniami."
  },
  "generator": {
    "exerciseModeOverlap1": "Czas kondycjonowania nakłada się na czas ciszy",
    "exerciseModeOverlap2": "do",
    "exerciseModeOverlap3": "Kontynuować?",
    "dayInWeek": "Dzień tygodnia",
    "time": "Godzina",
    "duration": "Czas trwania",
    "frequency": "Częstotliwość",
    "save": "Zapisz",
    "edit": "EDYTUJ",
    "cancelRequest": "Anuluj żądanie",
    "activate": "Aktywuj",
    "okayText": "Rozumiem!",
    "batteryUnavailable": "<span>Twój system nie jest wyposażony w akumulator.<a href='https://estimator.enphaseenergy.com/login' target='_blank'> Dodaj akumulator</a>, aby kontrolować urządzenie %{device} na podstawie stanu naładowania akumulatora. </span>",
    "suspendedStateText": "Twój generator jest aktualnie wyłączony. Włącz generator przyciskiem przełączania u góry ekranu, aby aktywować profil generatora.",
    "suspendedModalHeading": "W tym stanie generator będzie zawsze wyłączony.",
    "suspendedModalSubheading": " Czy chcesz kontynuować?",
    "infoHeadng": "Generator",
    "infoSubheading": "When %{enabled}, you can choose one of the two profiles to start your generator. %{nl} When %{disabled} or when your system is On Grid, the generator will always be turned off.",
    "advancedSettings": "Ustawienia zaawansowane",
    "pendingRequest": "oczekujące żądanie",
    "disabled": "Wyłączono",
    "disable": "Wyłącz",
    "enabled": "Włączono",
    "waiting": "Oczekiwanie na informacje",
    "active": "Aktywny",
    "deviceDetails": "Wybierz profil, aby włączyć generator",
    "autoStart": "Automatic​",
    "autoStartSubheading": "Włącz w trybie Off Grid",
    "batteryOptimizationSubheading": "Włącz w oparciu o poziom naładowania akumulatora",
    "batteryChargeThreshold": "Granica ładowania akumulatora",
    "lowerLimit": "Limit uruchamiania: ",
    "upperLimit": "Limit wyłączania: ",
    "start": "Rozpocznij: ",
    "stop": "Zatrzymaj: ",
    "addQuietTime": "Ustaw czas wyciszenia",
    "quietTime": "Czas wyciszenia",
    "quietTimeToggle": "Użyj, jeśli nie chcesz, aby generator włączał się w tym czasie. Gdy akumulator osiągnie poziom krytyczny, generator włączy się niezależnie od czasu wyciszenia.",
    "startTime": "Godzina rozpoczęcia: ",
    "endTime": "Godzina zakończenia: ",
    "criticalChargeSettings": "Ustawienia krytycznego poziomu naładowania:",
    "generatorLoadingToast": "Potwierdzenie statusu generatora trwa nieoczekiwanie długo. Zajrzyj ponownie później.",
    "exerciseMode": "Zastosuj ustawienia",
    "exerciseModeSubheading": "Ta funkcja służy do automatycznego uruchamiania generatora w regularnych odstępach w celu zapewnienia jego sprawności.",
    "batteryOptimization": "Ekologiczny",
    "activateBatteryProfile": "Wybrano profil Automatyczne uruchamianie. Aby dodać czas wyciszenia, aktywuj profil uruchamiania w zależności od stanu naładowania akumulatora",
    "manualMode": "Tryb ręczny",
    "manualModeDescription": "Generator pracuje obecnie w trybie ręcznym. Zmień tryb generatora na automatyczny lub skontaktuj się z instalatorem.",
    "generatorStartLimit": "Limit uruchamiania nie może być mniejszy niż 10%",
    "generatorStartStopLimit": "Limity uruchamiania i zatrzymywania powinny różnić się o co najmniej 5%",
    "generatorLimitDescription": "Skorzystaj z tej funkcji, aby uniknąć włączania generatora w określonych okresach. Generator włącza się, gdy poziom naładowania akumulatora spadnie poniżej wartości krytycznej.",
    "generatorQuietTime": "Czas wyciszenia",
    "generatorNormalTime": "Czas zwykły",
    "generatorEnableGenerator": "Włącz generator",
    "generatorDisableGenerator": "Wyłącz generator",
    "automatic": "Automatyczny",
    "ecoFriendly": "Ekologiczny"
  },
  "sgipStatic": {
    "applyForIncentive": "Złóż wniosek o ulgę SGIP",
    "subheadingSgip": "Właściciele systemów w Kalifornii, którzy planują zakup akumulatora marki Enphase lub już to zrobili, mogą ubiegać się o świadczenie SGIP",
    "applyNow": "Złóż teraz",
    "learnMore": "Dowiedz się więcej",
    "serviceFee": "* Może obowiązywać opłata za usługę",
    "enphaseRepresentative": "* Przedstawiciel Enphase może się z Tobą skontaktować telefonicznie/e-mailowo",
    "documentsRequired": "Do ubiegania się o ulgę SGIP są wymagane następujące dokumenty:",
    "documentHeading1": "1. Ostatnie rachunki za media (co najmniej jeden rachunek z ostatnich 3 miesięcy)",
    "documentHeading2": "2. Dokument umowy",
    "additionalInfo": "* Przed ostatnią wypłatą dofinansowania mogą być wymagane dodatkowe dokumenty"
  },
  "activationProgress": {
    "systemActivationInProgress": "Trwa aktywowanie systemu",
    "completed": "Ukończono",
    "viewDetails": "Wyświetl szczegóły",
    "activationCompleted": "Aktywacja jest w 100% zakończona",
    "activationInProgress": "Trwa aktywacja",
    "devices": "Urządzenia",
    "status": "Status",
    "envoy": "Brama",
    "encharge": "Akumulator",
    "enpower": "Sterownik systemu",
    "pvProduction": "Produkcja energii słonecznej",
    "cosumptionCT": "TK zużycia",
    "systemOperational": "System działa",
    "reporting": "Raportowanie",
    "notReporting": "Brak raportowania",
    "enabled": "Włączono",
    "notEnabled": "Nie włączono",
    "producing": "Produkcja",
    "verified": "Zweryfikowano",
    "notVerified": "Nie zweryfikowano",
    "featuresNowEnable": "Obecnie dostępne są następujące funkcje.",
    "featuresWillBeEnabled": "Następujące funkcje zostaną włączone po zakończeniu aktywacji systemu:",
    "consumptionMonitoring": "Monitorowanie zużycia",
    "liveStatus": "Stan bieżący",
    "stormGuard": "Ochrona przed burzą",
    "batteryProfileSetting": "Ustawienia profilu akumulatora",
    "gridControl": "Sterowanie siecią"
  },
  "prodIssue_faq_1": "Dlaczego jeden z moich paneli produkuje mniej energii niż pozostałe?",
  "prodIssue_faq_2": "Często panele umieszczone na dachu generują różną ilość energii. Na różnice wpływa wiele czynników, takich jak kierunek ustawienia paneli, „zacienienie” przez kominy lub drzewa oraz inne przeszkody.",
  "accountNew": {
    "account": {
      "title": "Twoje informacje",
      "title_alternate": "Informacje osobiste",
      "save_changes": "Zapisz zmiany",
      "name_label": "Imię i nazwisko:",
      "phone_label": "Telefon komórkowy:",
      "phone_placeholder": "Numer telefonu",
      "first_name_placeholder": "Imię",
      "last_name_placeholder": "Nazwisko",
      "email_placeholder": "Adres e-mail",
      "email_label": "Adres e-mail:",
      "change_password": "Zmień hasło",
      "current_password": "Bieżące hasło:",
      "password_label": "Nowe hasło:",
      "password2_label": "Wpisz nowe hasło ponownie:",
      "password_footnote": "Hasła muszą składać się co najmniej z sześciu znaków i zawierać przynajmniej jedną cyfrę lub znak specjalny.",
      "cancel_change_password": "Nie zmieniaj hasła",
      "units_label": "System:",
      "units_metric": "Metryczne (°C, km)",
      "units_us": "Imperialne (°F, mi)",
      "locale_label": "Język:",
      "equivalent_label": "Ekwiwalent energii:",
      "equivalent_display": "Rozpocznij od",
      "notification_label": " Powiadomienia:",
      "preference_monthly_email": "Wyślij mi miesięczne podsumowania wydajności systemu",
      "preference_enphase_email": "Wyślij mi biuletyny, promocje i ankiety dotyczące produktów lub usług Enphase",
      "production_issues_email": "Poinformuj mnie o problemach związanych z produkcją systemu lub usługami",
      "save_successful": "Twoje informacje zostały zapisane.",
      "save_successful_email": "Twoje informacje zostały zapisane. Zobacz poniższą uwagę dotyczącą zmiany adresu e-mail.",
      "save_failed": "Nie udało się zapisać Twoich informacji.",
      "system_info": "Informacje o systemie %{site_name}",
      "system_weather": "System – pogoda",
      "show_system_weather": "Pokaż funkcje pogodowe dla tej lokalizacji",
      "save": "Zapisz"
    },
    "system_preferences": {
      "title": "Preferencje systemu",
      "name_label": "Imię i nazwisko:",
      "public_label": "Publiczna strona systemu:",
      "public_text_html": "Utwórz stronę publiczną mojego systemu",
      "public_preview_link": "Podgląd strony publicznej",
      "public_help_link": "Więcej informacji",
      "public_footnote": "Umożliwi to udostępnianie funkcji społecznościowych i pozwoli na odwiedzanie Twojego systemu.",
      "display_label": "Wyświetl nazwę systemu jako:",
      "save_changes": "Zapisz preferencje systemu",
      "save_location_changes": "Zapisz ustawienia prywatności",
      "save_successful": "Zapisano preferencje Twojego systemu.",
      "save_failed": "Nie udało się zapisać preferencji systemu.."
    },
    "validations": {
      "required": "To pole jest wymagane.",
      "password_too_short": "Twoje hasło musi składać się co najmniej z sześciu znaków i zawierać przynajmniej jedną cyfrę lub znak specjalny.",
      "password_too_long": "Wprowadź mniej niż 50 znaków.",
      "password_similar_to_username": "Twoje hasło nie może być takie samo jak Twój adres e-mail.",
      "password_too_weak": "Twoje hasło musi składać się co najmniej z sześciu znaków i zawierać przynajmniej jedną cyfrę lub znak specjalny.",
      "password_weak": "Twoje hasło musi składać się co najmniej z sześciu znaków i zawierać przynajmniej jedną cyfrę lub znak specjalny.",
      "password_good": "Siła hasła: Dobre",
      "password_strong": "Siła hasła: Silne",
      "password_policy": "Twoje hasło musi liczyć co najmniej %{pwd_min_length}–%{pwd_max_length} znaków i zawierać cyfrę %{digit_in_pwd}, wielką literę %{uppercase_in_pwd}, małą literę %{lowercase_in_pwd} i %{special_character_in_pwd} znaków specjalnych (tylko ~!@#$%^&*)",
      "equalTo": "Wprowadź ponownie tę samą wartość.",
      "invalid_phone_number": "Wprowadź prawidłowy numer telefonu.",
      "empty_phone_number": "Wprowadź swój numer telefonu komórkowego.",
      "email_used": "Ten identyfikator e-mail jest już zarejestrowany. Spróbuj ponownie, używając innego identyfikatora e-mail, lub kliknij $cHere, aby zresetować hasło.",
      "emailInvalid": "Wprowadź poprawny adres e-mail"
    }
  },
  "accountDelete": {
    "deleteAccount": "Usuń konto",
    "deletePopUpText": "Twoje konto i powiązane dane osobowe zostaną usunięte. Zostaniesz wylogowany po usunięciu konta. Czy chcesz kontynuować?",
    "deleteCnfText": "Twoje konto i powiązane dane osobowe zostaną usunięte, z wyjątkiem informacji, które musimy zachować w związku z Twoim Systemem Energetycznym. Zostaniesz wylogowany po usunięciu konta. Czy chcesz kontynuować?",
    "yes": "TAk",
    "no": "Nie",
    "verificationCode": "Kod weryfikacyjny",
    "enterCodeText": "Wprowadź 4-cyfrowy kod, który został wysłany na zarejestrowany adres e-mail i numer telefonu komórkowego.",
    "didntReceive": "Nie otrzymałeś kodu?",
    "resend": "Wysłać ponownie",
    "deleteCnfTextEnlm": "Twoje konto i powiązane dane osobowe zostaną usunięte, z wyjątkiem informacji, które musimy zachować w związku z Twoim Systemem Energetycznym. Utracisz także dostęp do Enlighten Managera. Zostaniesz wylogowany po usunięciu konta. Czy chcesz kontynuować?",
    "deleteAdmin": "Twoje konto nie może zostać usunięte, ponieważ jesteś administratorem Enphase",
    "verifyCode": "Kod weryfikacyjny",
    "logOutText": "Zostaniesz wylogowany po weryfikacji kodu.",
    "confirmText": "Twoje konto jest dezaktywowane. Zachowamy dane osobowe związane z Twoim Systemem Energetycznym, aby honorować Twoją gwarancję i wspierać Twój system.",
    "ok": "Ok, rozumiem",
    "activateCnfText": "Twoje konto Enphase nie jest aktywne, ponieważ usunąłeś swoje konto. Czy chcesz go ponownie aktywować?",
    "activateText": "Identyfikator e-mail jest zarejestrowany w Enphase. Jednak nie jest aktywny, ponieważ został usunięty.",
    "click": "Kliknij ",
    "activateAgain": "tutaj, aby ponownie go aktywować",
    "activateAccount": "Aktywuj konto",
    "emailIDRegistered": "Identyfikator e-mail jest zarejestrowany w Enphase. Jednak nie jest aktywny, ponieważ został usunięty. $cHere, aby aktywować go ponownie.",
    "deleteAccountPopupText": "Usunięcie konta spowoduje dezaktywację konta i usunięcie wszystkich danych osobowych powiązanych z kontem. Ponieważ jesteś powiązany z systemem Enphase Energy, jesteśmy zobowiązani do przechowywania twoich danych osobowych w celu wsparcia gwarancji na produkt, aktualizacji systemu i wsparcia.",
    "learnMore": "Ucz się więcej",
    "accountdeletion": "Twoje konto jest w trakcie usuwania. Ten proces może potrwać do 30 dni, a po usunięciu poprzedniego konta możesz utworzyć nowe konto.",
    "incorrectEmailandPass": "Wprowadzony adres e-mail i hasło nie są zgodne z naszymi danymi. Proszę spróbuj ponownie.",
    "accountdeletioninfo": "Twoje konto jest w trakcie usuwania. Może to potrwać do 30 dni.",
    "WOAccntdeletePopup": "Usunięcie konta spowoduje dezaktywację konta i usunięcie wszystkich danych osobowych powiązanych z kontem.",
    "accountdelReq": "Prośba o usunięcie konta",
    "verfcodedel": "Twój kod weryfikacyjny do usunięcia konta Enphase",
    "accountActvReq": "Prośba o aktywację konta",
    "codedelAccount": "Kod weryfikacyjny do usunięcia konta Enphase",
    "codeDuration": "Ten kod będzie ważny tylko przez 15 minut.",
    "userDelReq": "Użytkownik poprosił o opcję usunięcia konta w aplikacji Enphase. Poniżej znajdują się dane użytkownika",
    "requestReceived": "Otrzymaliśmy Twoją prośbę o aktywację konta Enphase. Aby to zrobić, kliknij poniższy link w ciągu 7 dni od otrzymania tego e-maila.",
    "activate": "Aktywuj",
    "accActivate": "Aktywuj swoje konto",
    "optdelaccount": "Twój kod weryfikacyjny do usunięcia konta Enphase to %{otp}. Ten kod jest ważny przez 15 minut.",
    "emailCheckInstruction": "Sprawdź pocztę e-mail, aby uzyskać instrukcje dotyczące aktywacji konta."
  },
  "phase": {
    "all": "Widok trójfazowy",
    "phaseL": "Faza L",
    "msgOffGrid": "Dane dotyczące zużycia energii w poszczególnych fazach nie są dostępne, gdy system jest odłączony od sieci."
  },
  "vls": {
    "vlsHeading": "Poziom wyłączenia akumulatora",
    "shutdownLevelLine1": "W przypadku przerwy w dostawie prądu akumulator wyłączy się przy",
    "shutdownLevelLine1-2": "poziomie naładowania w celu oszczędzania energii. Uruchomi się ponownie, wykorzystując zachowaną energię, gdy zasilanie w sieci zostanie przywrócone lub gdy panele słoneczne zaczną generować energię.",
    "shutdownLevelLine2": "Wybierz wysoką wartość, jeśli warunki pogodowe są niekorzystne i wpływają na produkcję energii słonecznej.",
    "vlsWarning": "Poziom wyłączenia akumulatora nie może być wyższy niż moc rezerwowa akumulatora (%{soc}%)",
    "stormVlsWarning": "W systemie jest aktywny alarm burzowy. Po zakończeniu alarmu burzowego moc rezerwowa akumulatora zostanie zaktualizowana do %{soc}%, ponieważ nie może być niższa od poziomu wyłączenia.",
    "batteryReserveWarning": "Mocy rezerwowej akumulatora nie można ustawić na poziomie niższym niż poziom wyłączenia akumulatora (%{horizontal}%). W celu zmniejszenia mocy rezerwowej akumulatora należy zmniejszyć poziom wyłączenia akumulatora w #Ustawieniach zaawansowanych#.",
    "editRequest": "Masz aktywne żądanie. Aby kontynuować z wyborem, musisz poczekać na potwierdzenie lub anulować zgłoszenie."
  },
  "defaultLocale": {
    "popContent1": "Wybierz język aplikacji",
    "popContentBody1": "Czy chcesz kontynuować, używając ",
    "popContentBody2": " jako języka aplikacji?",
    "button1": "OK, kontynuuj",
    "button2": "Wybierz inny język",
    "button3": "Nie, zmień na ",
    "en": "język angielski",
    "de": "Niemiecki",
    "es": "hiszpański",
    "fr": "Francuski",
    "it": "Włoski",
    "nl": "Holenderski",
    "pl": "Polski",
    "pt": "portugalski",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "Brak zestawów!",
    "noArraysDesc": "Nie masz zainstalowanych żadnych paneli słonecznych",
    "noAccessConsumptionData": "Nie masz dostępu do danych dotyczących zużycia w tej lokalizacji."
  },
  "drEventsActive": "DR Event: Active",
  "pleaseGoTo": "Proszę przejść do ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": ", aby zaktualizować preferencje dotyczące powiadomień.",
  "loadControl": {
    "enabled": "Włączono",
    "disabled": "Wyłączono",
    "smartEnabled": "Włączono inteligentną kontrolę",
    "offGridBehaviour": "Działanie w trybie odłączenia od sieci",
    "modeDetails": "Szczegóły trybu inteligentnego sterowania",
    "newModeDetails": "Szczegóły trybu Sterowanie odbiornikami",
    "basicMode": "Tryb podstawowy",
    "cannotUse": "Nie można użyć urządzenia %{loadName}",
    "genOnUSe": "Nie można użyć urządzenia %{loadName}, gdy generator jest włączony",
    "genMode": "Tryb generatora",
    "batteryMode": "Tryb akumulatora",
    "batteryModePercent": "Z urządzenia %{loadName} można korzystać, gdy poziom naładowania akumulatora wynosi co najmniej %{lowerSoc}%.",
    "batteryModeSoc": "Jeśli poziom naładowania akumulatora spadnie poniżej %{lowerSoc}%, nie będzie można użyć urządzenia %{loadName}% – niezbędne będzie naładowanie akumulatora do %{upperSoc}%.",
    "loadControlHeading": "W trybie odłączenia od sieci należy kontrolować zasilanie urządzeń",
    "loadControlSubHeading": "Po podłączeniu do sieci wszystkie urządzenia będą zasilane",
    "powered": "Zasilanie",
    "notPowered": "Brak zasilania",
    "unknown": "Nieznany",
    "permissionOfIntstaller": "Nie masz uprawnień do edytowania żadnych ustawień tego urządzenia. Aby dowiedzieć się więcej, skontaktuj się z instalatorem lub obsługą klienta Enphase.",
    "willbePowered": "W tym stanie urządzenie %{loadName} będzie zawsze zasilane.",
    "poweredOnOffGrid": "Urządzenie %{loadName} będzie zasilane w zależności od wybranego działania w trybie odłączenia od sieci.",
    "continueModal": "Czy chcesz kontynuować?",
    "infoDetails": "Gdy inteligentne sterowanie jest wyłączone lub gdy system jest podłączony do sieci, urządzenia będą zawsze zasilane.",
    "newInfoDetails": "Zasilaniem odbiorników można sterować na podstawie dostępnych zasobów energetycznych lub pory dnia. Można również użyć trybu ręcznego, aby natychmiast zmienić sposób zasilania odbiorników.",
    "enableSmartComtrol": "Włącz inteligentne sterowanie, aby korzystać z tej funkcji.",
    "enableToggle": "Czy chcesz włączyć inteligentne sterowanie?",
    "disableToggle": "Czy chcesz wyłączyć inteligentne sterowanie?",
    "apply": "Zastosuj",
    "modalPara1": "<div>Gdy inteligentne sterowanie jest <span style='color: #F37320'>włączone</span>, możesz wybrać jeden z trzech trybów działania w trybie odłączenia od sieci.</div>",
    "disabledModalText": "Funkcja inteligentnego sterowania jest wyłączona w przypadku tego urządzenia. Włącz funkcję inteligentnego sterowania za pomocą przełącznika, aby zaktualizować działanie w trybie odłączenia od sieci",
    "batteryChargeLowerLimit": "Dolny limit naładowania akumulatora nie może być niższy niż 10%",
    "batteryChargeHigherLimit": "Dolny limit naładowania akumulatora nie może być wyższy niż 90%",
    "loadControlLoadingToast": "potwierdzanie statusu %{loadName} trwa dłużej niż oczekiwano. Sprawdź ponownie później.",
    "loadControlTakingLonger": "Potwierdzanie statusu odbiornika trwa dłużej niż oczekiwano. Sprawdź ponownie później.",
    "batteryChargeLowerHigherLimit": "Dolna i górna granica naładowania akumulatora powinny różnić się o co najmniej 5%",
    "mode": "tryb",
    "lcMainHeading": "Sterowanie zasilaniem urządzeń",
    "basic": "podstawowe",
    "scheduled": "planowane",
    "advanced": "zaawansowane",
    "manual": "ręczne",
    "notSelected": "Nie wybrano",
    "poweredWhen": "Zasilanie, gdy poziom naładowania akumulatora przekracza",
    "poweredGenOn": "Zasilanie przy włączonym generatorze",
    "poweredBetweenTime": "Zasilanie między %{startTime} a %{endTime}",
    "onceDisconnected": "Po odłączeniu od źródła zasilania obciążenie nie będzie zasilane, dopóki akumulator nie naładuje się do poziomu 100%.",
    "alwaysPowered": "Zasilanie stałe",
    "neverPowered": "Zawsze bez zasilania",
    "minDiff": "Godzina rozpoczęcia i zakończenia powinna różnić się o co najmniej 15 minut.",
    "startLessThanEnd": "Godzina początkowa powinna być wcześniejsza niż godzina końcowa",
    "notValidTime": "Godzina początkowa i godzina końcowa powinny mieścić się w przedziale od %{startTime} do %{endTime}.",
    "completed": "Tryb %{loadName} zaktualizowany pomyślnie.",
    "notCompleted": "Twoje żądanie nie mogło zostać zrealizowane. Spróbuj ponownie później",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "Nie znaleziono sterownika odbiornika",
    "allowedWarning": "W przypadku modyfikacji tego okna czasowego należy upewnić się, że produkcja energii słonecznej jest wystarczająca do pokrycia zapotrzebowania na energię w tym oknie.",
    "advancedMode": {
      "subtitle": "Steruj odbiornikiem za pomocą:",
      "notPowered": "Zasilanie, gdy poziom naładowania jest wyższy niż ",
      "batterySocDesc1": "Brak zasilania, gdy poziom naładowania spadnie poniżej ",
      "batterySocDesc2": "Zasilanie dopiero po naładowaniu akumulatora do poziomu ",
      "batterySocDesc3": " (nawet jeśli generator jest włączony)",
      "notAvailable": "Niedostępne",
      "onGridGenPowered": "Zasilanie",
      "offGridGenPowered": "Zasilanie przy włączonym generatorze"
    }
  },
  "app_info": {
    "update_available": "Dostępna aktualizacja aplikacji",
    "already_updatec": "Twoja aplikacja jest zaktualizowana do najnowszej",
    "update_now": "Zaktualizuj teraz",
    "latest_update": "OSTATNIA AKTUALIZACJA",
    "update_history": "Historia aktualizacji",
    "show_more": "Pokaż więcej",
    "show_less": "Pokaż mniej"
  },
  "s1": "Pomóż mi wybrać profil",
  "s2": "Dowiedz się więcej o profilach akumulatora",
  "s3": "Zaproponuj mi profil",
  "s4": "Poziom naładowania akumulatora jest większy niż poziom rezerwowy",
  "s5": "Niezależność energetyczna po godzinach szczytu:",
  "s6": "Poza godzinami szczytu panele słoneczne najpierw naładują akumulator, a następnie zaczną zasilać dom. Nadmiar wytworzonej energii słonecznej zostanie przesłany z powrotem do sieci, aby obniżyć rachunki za prąd.",
  "s7": "Jeśli zapotrzebowanie Twojego domu na energię elektryczną będzie przewyższało zdolności produkcyjne paneli słonecznych, prąd zostanie pobrany z sieci.",
  "s8": "Działanie systemu w godzinach szczytu",
  "s9": "Zmniejsz rachunki za prąd",
  "s10": "W niektórych miejscach cena energii elektrycznej zmienia się w ciągu dnia, rosnąc w godzinach szczytu, kiedy występuje zwiększone zapotrzebowanie.",
  "s11": "Aby uniknąć kupowania energii elektrycznej po wyższej cenie, Twój dom będzie korzystał z energii zgromadzonej w akumulatorach. Jeśli zapotrzebowanie Twojego domu na energię elektryczną będzie przewyższało jej ilość zgromadzoną w akumulatorze, będzie ona pobierana z paneli słonecznych, a następnie z sieci. Wszelka dodatkowa energia słoneczna będzie eksportowana do sieci.",
  "s12": "W nocy, gdy panele słoneczne nie produkują prądu, Twój dom korzysta z energii zgromadzonej w akumulatorze do momentu osiągnięcia rezerwowego poziomu naładowania.",
  "s13": "Energia elektryczna jest importowana z sieci, gdy energia słoneczna nie jest dostępna, a Twój dom potrzebuje jej więcej niż może zapewnić akumulator.",
  "s14": "Zasilaj swój dom czystą energią",
  "s15": "Twój dom będzie w pierwszej kolejności korzystał z czystej energii. W ciągu dnia dom zasila energia słoneczna, a następnie akumulator. Wszelka dodatkowa energia jest eksportowana do sieci. W ciągu nocy dom jest zasilany przez akumulator.",
  "s16": "Gdy Twój dom potrzebuje więcej energii elektrycznej niż dostarczają instalacja fotowoltaiczna i akumulator, energia jest importowana z sieci.",
  "s17": "Akumulator jest w pełni naładowany",
  "s18": "Działanie systemu poza godzinami szczytu",
  "s19": "Panele słoneczne najpierw naładują akumulator, a następnie zaczną zasilać dom. Nadmiar wytworzonej energii słonecznej zostanie przesłany z powrotem do sieci.",
  "s20": "Jeśli w nocy lub o innej porze Twoje zapotrzebowanie na energię elektryczną będzie przewyższało zdolności produkcyjne paneli słonecznych, prąd zostanie pobrany z sieci. Energia zgromadzona w akumulatorach jest wykorzystywana wyłącznie w przypadku przerwy w dostawie prądu.",
  "s21": "Kliknij profil, aby przejść do jego stron.",
  "s22": "Przesuń w lewo lub w prawo, aby uzyskać więcej informacji.",
  "s23": "Akumulatory będą rozładowywać się nawet po godzinach szczytu.",
  "s24": "Energia elektryczna jest importowana z sieci, gdy energia słoneczna nie jest dostępna, a Twój dom potrzebuje jej więcej niż może zapewnić akumulator.",
  "s25": "Działanie systemu poza godzinami szczytu",
  "s26": "Ciesz się prądem podczas awarii zasilania",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Jest to szacunkowa kwota oszczędności finansowych uzyskanych z systemu dzięki produkcji energii fotowoltaicznej. Wartość ta jest obliczana na podstawie wprowadzonych szczegółowych danych na temat stawek za energię elektryczną.",
      "noTeriffMsg": "Dodaj stawkę za energię elektryczną, aby poznać swoje oszczędności",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Wprowadzenie",
      "billingCycle": {
        "more": "więcej niż o tej godzinie w ostatnim cyklu rozliczeniowym",
        "less": "mniej niż o tej godzinie w ostatnim cyklu rozliczeniowym",
        "same": "Mniej więcej tak samo, jak o tej godzinie w ostatnim cyklu rozliczeniowym"
      },
      "calendarMonth": {
        "more": "więcej niż tym razem w poprzednim miesiącu",
        "less": "mniej niż w tym czasie w poprzednim miesiącu",
        "same": "Mniej więcej tak samo jak o tej porze w poprzednim miesiącu"
      },
      "day": {
        "more": "więcej niż o tej porze poprzedniego dnia",
        "less": "mniej niż o tej porze poprzedniego dnia",
        "same": "Mniej więcej tak samo jak o tej porze poprzedniego dnia",
        "significantMore": "Znacznie wyższy niż dzień poprzedni"
      },
      "week": {
        "more": "więcej niż tym razem w poprzednim tygodniu",
        "less": "mniej niż o tej porze w poprzednim tygodniu",
        "same": "Mniej więcej tak samo jak o tej porze w poprzednim tygodniu"
      },
      "year": {
        "more": "więcej niż w tym czasie w poprzednim roku",
        "less": "mniej niż w tym czasie w poprzednim roku",
        "same": "Mniej więcej tak samo jak w tym czasie w poprzednim roku"
      },
      "editElectricity": "EDYTUJ STAWKĘ ZA ENERGIĘ ELEKTRYCZNĄ",
      "viewSavingsBased": "Zobacz oszczędności na podstawie",
      "calendarMonthTitle": "Miesiąc kalendarzowy",
      "calendarMonthDesc": "Okres od pierwszego do ostatniego dnia miesiąca",
      "noExportRate": "Dodaj %{exportCTA}, aby zobaczyć swoje całkowite oszczędności",
      "exportRate": "Szybkość eksportu"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Nie można się połączyć lokalnie",
    "limitedAppFunctionality": "Ograniczona funkcjonalność aplikacji",
    "needHelpGatewayWifi": "Potrzebujesz pomocy w skonfigurowaniu połączenia Wi-Fi bramki",
    "howToConnectGatewayNetwork": "Jak połączyć się z siecią bramki",
    "connectGatewayToWifi": "Połącz bramkę z siecią Wi-Fi",
    "connectLocally": "POŁĄCZ LOKALNIE",
    "checkNetworkConnection": "Proszę sprawdzić połączenie sieciowe.",
    "noInternetModalSubText1": "Proszę sprawdzić połączenie sieciowe. W międzyczasie możesz zobaczyć aktualny stan systemu.",
    "noInternetModalSubText2": "Sprawdź połączenie sieciowe. W międzyczasie, jeśli znajdujesz się w pobliżu swojego systemu, możesz połączyć się lokalnie z bramką, aby sprawdzić jej bieżący stan.",
    "refereshing": "Odświeżanie",
    "pullToReferesh": "Pociągnij, aby odświeżyć",
    "connectionStatus": "Telefon jest teraz połączony lokalnie z siecią bramki.",
    "connectivityErrorMsg1": "Upewnij się, że telefon i bramka są połączone z tą samą siecią",
    "connectivityErrorMsg2": 'Bramka była ostatnio podłączona do sieci %{wifiName}',
    "connectivityErrorMsg3": "Ewentualnie możesz połączyć telefon z siecią Wi-Fi bramki, włączając w bramce tryb AP.",
    "connecting": "Telefon próbuje nawiązać lokalne połączenie z bramką w celu wyświetlenia bieżącego stanu systemu.",
    "viewLiveStatus": "Wyświetl dane bieżące",
    "pleaseTryAgainInSomeTime": "Proszę spróbować ponownie za jakiś czas.",
    "connectedLocally": "Podłączono lokalnie",
    "ssidNotMatchedError": "Telefon komórkowy nie jest podłączony do prawidłowej sieci bramek. Połącz swój telefon komórkowy z tą siecią bramek: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Sieci bramki Gateway dla tej lokalizacji",
      "message": "Połącz telefon komórkowy wyłącznie z siecią jednej z bramek tej lokalizacji. Oto sieci bramek dla tej lokalizacji:",
      "buttonText": "Jasne!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "Telefon komórkowy nie został połączony z odpowiednią siecią bramki. Telefon komórkowy należy połączyć wyłącznie z siecią jednej z bramek tej lokalizacji.",
    "configureButtonMultiEnvoyMsg": "Telefon komórkowy nie jest podłączony do prawidłowej sieci bramek. Połącz telefon komórkowy wyłącznie z siecią jednej z bramek tej lokalizacji. Oto sieci bramek dla tej lokalizacji:",
    "listOfGatewayNetworks": "Lista sieci bramek dla tej lokalizacji",
    "configureWifiMultiEnvoyMsg": "Aby skonfigurować Wi-Fi dla bramki (nr seryjny: XXXX) należy podłączyć telefon komórkowy do trybu AP tej bramki. Połączyłeś się z trybem AP bramki (nr seryjny:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "Jak nawiązać połączenie z siecią Wi-Fi bramki Gateway",
      "okGotIt": "OK, rozumiem",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Aby zmienić ustawienia systemu, połącz się lokalnie z siecią bramki Gateway.",
      "subText2": 'Upewnij się, że telefon i bramka Gateway są połączone z tą samą siecią %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(bramka Gateway zosta\u0142a niedawno po\u0142\u0105czona z sieci\u0105 \"%{lastConnection}\")",
      "subText3": "Ewentualnie możesz połączyć telefon komórkowy z siecią Wi-Fi bramki Gateway, włączając w niej tryb AP.",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Ostatnie połączenia bramek z siecią Wi-Fi",
      "gatewayPrefix": "Nr ser. bramki",
      "gatewayBtn": "Sieci Wi-Fi bramki dla tej lokalizacji",
      "alternetively": "Ewentualnie możesz połączyć telefon z dowolną siecią bramki, włączając w bramce tryb AP."
    },
    "isTouPopupMsg": "Nie można aktywować trybu oszczędnościowego, gdyż działa on tylko wtedy, gdy użytkownik ma licznik energii netto (NEM), a stawka za energię elektryczną zmienia się w zależności od czasu użytkowania (ToU). Stawkę za energię elektryczną można konfigurować lub aktualizować tylko wtedy, gdy telefon jest podłączony do Internetu.",
    "configWifiToGateway": "Skonfiguruj wi-fi dla swijej bramy ",
    "phoneNtConnectedToGateway": "Twój telefon nie jest podłączony do bramki",
    "chooseWifiNetwork": "Wybierz sieć Wi-Fi, której chcesz używać z bramą.",
    "learnWifiConfigToGatway": "Dowiedz się, jak skonfigurować Wi-Fi dla swojej bramy",
    "step": "Krok",
    "connectPhoneToGateway": "Podłącz telefon do bramki",
    "connectToGatewayNetwork": "Połącz się z siecią bramy, aby skonfigurować Wi-Fi dla swojej bramy",
    "gatewayNtReachable": "Twoja brama jest nieosiągalna",
    "pleaseEnsure": "Proszę upewnij się:",
    "gatewayAPModeOn": "Tryb AP bramki jest włączony",
    "phoneInCloseProximity": "Telefon znajduje się w bliskiej odległości od bramki",
    "mobileDataOff": "Dane mobilne (dane komórkowe) są wyłączone",
    "searchingGateway": "Szukam sieci bramy",
    "devicePluggedIn": "Upewnij się, że Twoje urządzenie jest w pobliżu, jest podłączone, a tryb AP jest włączony",
    "connectingTo": "Łączenie z",
    "reflectedInApp": "Może to potrwać kilka minut, zanim zostanie to odzwierciedlone w aplikacji",
    "connectionFailed": "Nie udało się połączyć z siecią bramy",
    "connectedToGateway": "Telefon jest podłączony do bramki"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Połącz bramę z Wi-Fi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Wybierz sieć Wi-Fi, z którą chcesz połączyć swoją bramę."), _defineProperty(_offline, "scanNetwork", "Skanuj sieć Wi-Fi"), _defineProperty(_offline, "enterPassword", "Wpisz hasło do"), _defineProperty(_offline, "join", "Dołączyć"), _defineProperty(_offline, "gatewayConnected", "Brama jest pomyślnie połączona z %{selectedWifi}"), _defineProperty(_offline, "disconnectPhoneFromGateway", "Możesz teraz odłączyć telefon od sieci bramy i podłączyć go do Wifi/włączyć dane mobilne"), _defineProperty(_offline, "failedToConnect", "Nie udało się połączyć"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Upewnij się, że brama jest podłączona do źródła zasilania i znajdujesz się w jej pobliżu."), _defineProperty(_offline, "routerIsOn", "Upewnij się, że router Wi-Fi jest włączony i znajdujesz się w pobliżu routera Wi-Fi"), _defineProperty(_offline, "unableToDisplayNetworks", "Nie można wyświetlić sieci Wi-Fi"), _defineProperty(_offline, "errorDisplayingNetworks", "Wystąpił błąd podczas wyświetlania sieci Wi-FI z powodu pewnych problemów technicznych. Proszę spróbuj ponownie."), _defineProperty(_offline, "errorInConnectingToWifi", "Wystąpił błąd podczas łączenia się z siecią Wi-Fi. Spróbuj później lub połącz się z inną siecią."), _defineProperty(_offline, "unableToConnect", "Nie można połączyć"), _defineProperty(_offline, "pairGateway", "Sparuj bramkę z telefonem przez Bluetooth."), _offline),
  "tutorial": {
    "back": "Z powrotem",
    "apMode": "Jak włączyć tryb AP?",
    "step1": "Krok 1 z 3",
    "step2": "Krok 2 z 3",
    "step3": "Krok 3 z 3",
    "powerOnGateway": "Włącz bramę",
    "title2": "Naciśnij przycisk trybu AP",
    "title3": "That's it!",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Zaczynaj",
    "next": "Następny krok",
    "prev": "Poprzedni krok",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "Otóż",
    "step1of2": "Krok 1 z 2",
    "step2of2": "Krok 2 z 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Spróbuj połączyć bramkę z telefonem. Upewnij się, że znajdujesz się w pobliżu bramki, a komórkowa transmisja danych jest wyłączona"
  }
};
module.exports = mobile;